import { saveAs } from 'file-saver'

export const options = [
    {
        id: 1,
        skill:'Beginner',
        description: 'Almost 0 knowledge'
    }, 
    {
        id:2,
        skill:'Beginner',
        description: 'Basic understanding'
    }, 
    {
        id:3,
        skill:'Intermediate',
        description: 'Have done some work on it'
    }, 
    {
        id:4,
        skill:'Expert',
        description: 'Work regularly with it'
    }
]

export const capitalise = (str = "") => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const testimonials = [
    {
        id: 1,
        name: 'Vivek Jarngal',
        image: 'https://assets.learntube.ai/files/AI_Syllabus_generator/Ellipse_907.png?updatedAt=1685776843845',
        designation: 'Freelance Designer',
        description:`“This is exactly what I was looking for”`

    },
    {
        id: 2,
        name: 'Bala Nath Rai',
        image: 'https://assets.learntube.ai/files/AI_Syllabus_generator/Ellipse_907__1_.png?updatedAt=1685776939014',
        designation: 'Account Executive',
        description:`“Wow, I really didn’t know there was so much I needed to learn!”`

    },
    {
        id: 3,
        name: 'Shruti Das',
        image: 'https://assets.learntube.ai/files/AI_Syllabus_generator/Shruti.png?updatedAt=1685777697916',
        designation: 'Web Developer',
        description:`“Finally, a course that understands me & my goals!”`

    },
    {
        id: 4,
        name: 'Somesh Mishra',
        image: 'https://assets.learntube.ai/files/AI_Syllabus_generator/Ellipse_907__3_.png?updatedAt=1685777109765',
        designation: 'Project Manager',
        description:`“I’ve been looking since months when the perfect course was just minutes away..”`

    },
]

export const questionLoader = [
    {
        id: 1,
        description: 'Analysing the skill map'
    },
    {
        id: 2,
        description: 'Generating questions for you'
    },
    {
        id: 3,
        description: 'Loading questions and optimising quiz settings'
    },
    {
        id: 4,
        description: 'Loading questions and optimising quiz settings'
    },
]

export const images = [
    'https://assets.learntube.ai/files/certifiedOptimisation/Group_8427-modified.webp?updatedAt=1720518119244', 
    'https://assets.learntube.ai/files/certifiedOptimisation/Group_8427__1_-modified.webp?updatedAt=1720518119064', 
    'https://assets.learntube.ai/files/certifiedOptimisation/Group_8427__2_-modified.webp?updatedAt=1720518119012', 
    'https://assets.learntube.ai/files/certifiedOptimisation/Group_8427__3_-modified.webp?updatedAt=1720518119173', 
    'https://assets.learntube.ai/files/certifiedOptimisation/Group_8427__4_-modified.webp?updatedAt=1720518119178'
]

export const questionsTag = [
    '86% people who completed this quiz got hired',
    '93% users loved their feedback & course',
    '93% users loved their feedback & course',
    '88% quiz takers felt more confident on completing',
    '70% Users Got Hired Who Completed This Quiz'
]

export const expertsData = [
    {
        expert_name: 'Ravi Garikipati',
        designation: 'Ex-CTO',
        imgLink: 'https://assets.learntube.ai/files/About-us/Rectangle_52.png?updatedAt=1685423721302',
        companyImage: 'https://assets.learntube.ai/files/About-us/Flipkart_-_png_0.png?updatedAt=1685423777121',
        companyName: 'Flipkart'
    },
    {
        expert_name: 'Kaushik Subramanian',
        designation: 'Business Lead',
        imgLink: 'https://assets.learntube.ai/files/About-us/Rectangle_520323456.png?updatedAt=1685423959561',
        companyImage: 'https://assets.learntube.ai/files/About-us/Facebook_-_png_0.png?updatedAt=1685424009735',
        companyName: 'Facebook'
    }
]

export const expertsDataBasedOnSubject = {
    'Project Management': [
        {
            expert_name: 'Ravijot Chugh',
            designation: 'Co Founder',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/nMiEdEeDasJNctuGSQkhFnr3STg/43z6jg../1517366956945.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Ey9L8fdV2AEBjl8dO-fxDh8GB0o/C6Jg1w../1732599862731.jpeg",
            companyName: 'Upgrad'
        },
        {
            expert_name: 'Niket Phuria',
            designation: 'Lead PM',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/NUMaYaqzqUcJ-71MpISlZJMA1lc/yA07WQ../1705569924854.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/0WBg9XRy9M3HIM7HiDFiWedm8sU/5pxTDQ../1631312592031.jpeg",
            companyName: 'Artivatic.ai'
        }
    ],
    'Business Analyst': [
        {
            expert_name: 'Shajikumar Devakar',
            designation: 'Director',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/oHE58stksB5mT_P3-8v1Dyuot0M/umntFA../Rectangle_5203__5_.webp',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Ob53JzHeOgiiaaPNkjRuO0Kn2sc/GLTJ0g../1731654433773.jpeg",
            companyName: 'IIFL'
        },
        {
            expert_name: 'Riya Bhambhu',
            designation: 'Business Analyst',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/oU6YfH3bwDMaUBp-YD5YmZmxol4/SVZK_g../1688228283026.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/nLYn_TsHCYHpPFzn68JqmouqfJc/84Hnnw../lenskart_com_logo.jpeg",
            companyName: 'Lenskart'
        },
    ],
    'Data Analytics': [
        {
            expert_name: 'Rohit Kilam',
            designation: 'CTO',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/iImgq1kAnACVzCe4jyZ9MuGYUh8/8TwYhg../1638962979363.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/gWQCWf7DM_3qmr7OpF3klCxSf4A/QvX2-w../hdfc_life_logo.jpeg",
            companyName: 'HDFC Life'
        },
        {
            expert_name: 'Anirban Paul',
            designation: 'Tech Lead-DS&AI',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/l-SalBKwwXjy0QzdWUHys_d8CoU/Ty-Ixw../1730523832537.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/K0vFL-t33V6t297S3WPs5MOH5YY/Y-MwWA../oracle_logo.jpeg",
            companyName: 'Oracle'
        },
    ],
    'Scrum Master': [
        {
            expert_name: 'Kaushik Subramanian',
            designation: 'Ex- Product Lead',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/_GsKeMxeXEO9jbn1W3HtGj51Dc0/5IpjcA../1544441903852.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/ahk9uIh_oq2L5V-Wma1JmWBW8Jc/paa-XA../facebook_logo.jpeg",
            companyName: 'Meta'
        },
        {
            expert_name: 'Ravi Beri',
            designation: 'Prog. Manager',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/K0SHVKhpaENuNXRc4hc6Pm4x078/Gz9_aw../1657010941747.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/m-M21gOZZJnK6KxVtfdwSO7W6rE/QlG1Sg../LinkedIn.png",
            companyName: 'LinkedIn'
        },
    ],
    'Java': [
        {
            expert_name: 'Ravi Garikipati',
            designation: 'Ex- CTO',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/z3X1GwTFWWH0nBynAdpltNVBRVY/8858_A../1552955406952.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/qX4tGD2uS1lqPyGiwDyuphcfttw/yzD6OA../1627543110554.jpeg",
            companyName: 'Flipkart'
        },
        {
            expert_name: 'Niket Phuria',
            designation: 'Lead PM',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/NUMaYaqzqUcJ-71MpISlZJMA1lc/yA07WQ../1705569924854.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/0WBg9XRy9M3HIM7HiDFiWedm8sU/5pxTDQ../1631312592031.jpeg",
            companyName: 'Artivatic.ai'
        }
    ],
    'Six Sigma': [
        {
            expert_name: 'Kaushik Subramanian',
            designation: 'Ex- Product Lead',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/_GsKeMxeXEO9jbn1W3HtGj51Dc0/5IpjcA../1544441903852.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/ahk9uIh_oq2L5V-Wma1JmWBW8Jc/paa-XA../facebook_logo.jpeg",
            companyName: 'Meta'
        },
        {
            expert_name: 'Athira',
            designation: 'PM',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/6qN2KPjxctgoOtNJp6s9QiFA2d4/kZWsUQ../1710668299302.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Xl7ZxtV838wTp03TsIprFYNkf8Y/DoMOmg../mcdonalds_corporation_logo.jpeg",
            companyName: "McDonald's"
        },
    ],
    'Jira': [
        {
            expert_name: 'Rohit Chaddha',
            designation: 'Pres. & COO-Dig.',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/tMjZng0A1NRIVhQgqhsTHhHOP6M/EJmXXA../rohit_chadha.webp',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/RX5L0mpBfn-OR2s0G0w0Ol6jE5U/eouXVQ../times_television_network_logo.jpeg",
            companyName: 'Times Network'
        },
        {
            expert_name: 'Arbaaz Khan',
            designation: 'PM',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/ZRaOCG2XPpLETXtgHYF--K8N5L4/uoi9TA../1709010245626.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Oyh-ADGeM0m62DIiNCjKt2nNybk/0kB7ig../symbo_global_logo.jpeg",
            companyName: 'Symbo'
        },
    ],
    'UI & UX': [
        {
            expert_name: 'Rohit Chaddha',
            designation: 'Pres. & COO-Dig.',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/tMjZng0A1NRIVhQgqhsTHhHOP6M/EJmXXA../rohit_chadha.webp',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/RX5L0mpBfn-OR2s0G0w0Ol6jE5U/eouXVQ../times_television_network_logo.jpeg",
            companyName: 'Times Network'
        },
        {
            expert_name: 'Dulal Deb',
            designation: 'Sr. Asst. VP',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/teij6TXICn-6CbwZURKq1AtoCz0/rNRQQQ../1669139367014.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/xn91fYuNdM45Uzfh6auT-NMD9v8/tOjF_g../Wells_Fargo_Logo_%282020%29.png",
            companyName: 'Wells Fargo '
        },
    ],
    'Digital Marketing': [
        {
            expert_name: 'Rohit Raj',
            designation: 'Co -Founder',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/IPl2Pmsq_6VDcg64z9WwWMQTXzs/QzBdqA../rohit_raj.webp',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/vjQkCIX5BDCcl2hu8qbPBdvIsk4/_wGUZQ../the_glitch_logo.jpeg",
            companyName: 'The Glitch'
        },
        {
            expert_name: 'Sevya Pande',
            designation: 'Media Perf. Mgr.',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/QNVMuIU4-dtOEgDZT9guZ4_wpZI/MZNV0w../1638168507933.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/7oPhyaWWQNW4aN8O6uS1c_5vlE0/6y_6tA../publicismedia_logo.jpeg",
            companyName: 'Publicis Media'
        },   
    ],
    'Python': [
        {
            expert_name: 'Nanda Mallapragada',
            designation: 'Sr. Advisor - DS',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/AoJfguIIj_onI-euzajQnM5RKtc/3DBjEg../1655879134720.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/PhM-CCrzkzRoV3PWGI7JKK2upvg/4j2Gpg../Dell.png",
            companyName: 'Dell Technologies'
        },
        {
            expert_name: 'Anirban Paul',
            designation: 'Tech Lead-DS&AI',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/l-SalBKwwXjy0QzdWUHys_d8CoU/Ty-Ixw../1730523832537.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/K0vFL-t33V6t297S3WPs5MOH5YY/Y-MwWA../oracle_logo.jpeg",
            companyName: 'Oracle'
        },
    ],
    'Generative AI': [
        {
            expert_name: 'Vaibhavi Jani',
            designation: 'Sr. PM, Gen AI',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/k8ZUZ8EBura8PZUHX4xOcjnFJdI/1oiq6w../1719578235688.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/p6qdAz-i7R49qPknLe5IlnL4unA/q6z0_w../adobe_logo.jpeg",
            companyName: 'Adobe'
        },
        {
            expert_name: 'Anirban Paul',
            designation: 'Tech Lead-DS&AI',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/l-SalBKwwXjy0QzdWUHys_d8CoU/Ty-Ixw../1730523832537.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/K0vFL-t33V6t297S3WPs5MOH5YY/Y-MwWA../oracle_logo.jpeg",
            companyName: 'Oracle'
        }
    ],
    'Performance Marketing': [
        {
            expert_name: 'Rajesh Bysani',
            designation: 'Mob. Transf. Lead',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/DGl9GgveGrEVeKa2kdXW6ZFkapQ/jjuZVg../1579517984686.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/bH6s0cuM5DwRpMFKvdoFrMK4Mwk/aeWDtg../1631311446380.jpeg",
            companyName: 'Google'
        },
        {
            expert_name: 'Soniya keswani',
            designation: 'Sr. Prog. Manager',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/8G85bs3v0vZQo5DI7xoiIzilM-Q/8foa1w../1710782308315.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/bH6s0cuM5DwRpMFKvdoFrMK4Mwk/aeWDtg../1631311446380.jpeg",
            companyName: 'Google'
        },
    ],
    'SQL': [
        {
            expert_name: 'Rohit Kilam',
            designation: 'CTO',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/iImgq1kAnACVzCe4jyZ9MuGYUh8/8TwYhg../1638962979363.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/gWQCWf7DM_3qmr7OpF3klCxSf4A/QvX2-w../hdfc_life_logo.jpeg",
            companyName: 'HDFC Life'
        },
        {
            expert_name: 'Naved Imran',
            designation: 'Prog. Head-DS',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/KGqtu-97zeKbdhT3tK1hod1C-l4/xjLhyA../1719017084012.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/muTd9Mf0IDbU6dMCd-t-S6Ipd5I/XxoIkA../eClerx-Logo_Final.png",
            companyName: 'eClerx'
        },
    ],
    'HR Management': [
        {
            expert_name: 'Dr. Ajay Prabhu',
            designation: 'COO',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/ojq9LCiUzGQVPExuwkw54gHQGh4/HCMbag../1660713159396.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/K-_y53I2GgOTBvOM36Oolv3LXHU/ME33ug../quest_global_logo.jpeg",
            companyName: 'Quest Global'
        },
        {
            expert_name: 'Jitendra Gupta',
            designation: 'Founder',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/cI49Jirc-iRNKCYZtPogQvCX85E/TTI1og../1541035094531.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/MS6FSiDswkZAamjODqlcn7qjRds/fL1b0g../payu_logo.jpeg",
            companyName: 'Pay U'
        }
    ],
    'Others': [
        {
            expert_name: 'Jitendra Gupta',
            designation: 'Founder',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Fcv89KLmmhqLQrHTz57k4t0auhg/EGiKdw../1541035094531.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/B6zxrOTDwCMJW581qnnhtn-2U_8/uVycxA../payu_logo.jpeg",
            companyName: 'Pay U'
        },
        {
            expert_name: 'Niket Phuria',
            designation: 'Lead PM',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/NUMaYaqzqUcJ-71MpISlZJMA1lc/yA07WQ../1705569924854.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/0WBg9XRy9M3HIM7HiDFiWedm8sU/5pxTDQ../1631312592031.jpeg",
            companyName: 'Artivatic.ai'
        }
    ],
    'UnPaidUsers': [
        {
            expert_name: 'Niket Phuria',
            designation: 'Lead PM',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/NUMaYaqzqUcJ-71MpISlZJMA1lc/yA07WQ../1705569924854.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/0WBg9XRy9M3HIM7HiDFiWedm8sU/5pxTDQ../1631312592031.jpeg",
            companyName: 'Artivatic.ai'
        },
        {
            expert_name: 'Jitendra Gupta',
            designation: 'Founder',
            imgLink: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Fcv89KLmmhqLQrHTz57k4t0auhg/EGiKdw../1541035094531.jpg',
            companyImage: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/B6zxrOTDwCMJW581qnnhtn-2U_8/uVycxA../payu_logo.jpeg",
            companyName: 'Pay U'
        }
    ]
}

export const faqs = [
    {
        id: 0,
        question: 'How is this course personalised for me?',
        answer: 'Our domain experts (with 30+ years of combined experience) along with our AI engine analyse your skills, goals & answers to identify what you need to learn. We then build a detailed syllabus accordingly for you. And the personalisation doesn’t end here. Once you start learning, your course will be further personalised to you as per your needs.'

    },
    {
        id: 1,
        question: 'What all courses do you offer?',
        answer: 'Our personalisation technology works across domains, from career skills like Java to even hobbies like baking. Most users use us to learn work related skills in the domain of Programming, Marketing, Data Science, Design, Business & lots of different tools.'

    },
    {
        id: 2,
        question: 'Does the course really help in jobs?',
        answer: 'Yess! If you learn properly, do your assessments & projects and then showcase your skills in your CV & portfolio to employers it will make a huge difference in your job applications & even your own confidence. Our learners work at top companies from Amazon to TCS and many have gone on to become freelancers & entrepreneurs.'

    },
    {
        id: 3,
        question: 'Does LearnTube make the content too?',
        answer: 'We make personalised, certified courses. We do not make the videos in the course. Those are sourced from across the internet to make sure we get the very best content for you. Most videos are from top YouTube creators. We do the hard work of figuring out what you need to learn, finding the very best videos for it, arranging it in the best order, assessing your skills, solving your doubts, giving you projects to do & then certifying you.'

    },
    {
        id: 4,
        question: 'How do I get certified?',
        answer: 'Once you complete the course & assessments you will get certified immediately. Our certificate is recognised by hundreds of companies.'

    },
    {
        id: 5,
        question: 'Is there any refund policy?',
        answer: 'There sure is. While completing your course, if you find a cheaper, more personalised course than ours you will get your money back! Just reach out to us within 30 days of purchase with the details on hello@careerninja.in'

    },
    {
        id: 6,
        question: 'What all will be unlimited?',
        answer: 'You will be able to create unlimited personalised courses on any topic, get certified upon completing each of them, get unlimited doubt solving support & feedback in multiple languages. Note: To prevent any abuse of the system, at a time you can learn from 3 courses & the moment you complete one of them you can start another one. There is no limit to how many courses you can complete every month.'
    }
]

export const newFaqs = [
    {
        id: 0,
        question: 'What will I get after completing the payment?',
        answer: "You'll receive a link on WhatsApp as well as Email to access all the courses in your bundle, after completing the payment."

    },
    {
        id: 1,
        question: 'What else will I get along with the courses in my bundle?',
        answer: "You'll receive the following if you've selected the corresponding add-on while purchasing:",
        points: [ "A complete schedule of 4 live online sessions (1-hour each) for Placement Support training in batches.", "A link to choose your mentor and schedule a 1-hour live mentorship.", "A link to access unlimited courses on our platform, in addition to those in your bundle."]

    },
    {
        id: 2,
        question: 'How is this course personalised to my career goals?',
        answer: 'We personalise each course based on your experience, current role, and aspirations. Our AI-driven experts build a learning path that evolves as you progress to fit your needs.'

    },
    {
        id: 3,
        question: 'Will I receive certificates, and are they recognised?',
        answer: 'Yes! Our certificates, recognised by 1,100+ hiring partners like Google, Microsoft, and Capgemini, enhance your profile and increase job opportunities.'

    },
    {
        id: 4,
        question: 'How likely am I to get a job after completing the courses?',
        answer: 'Learners have secured jobs at top companies such as Google, Wipro, and Capgemini. Our targeted content significantly improves your chances of fast-tracking your career.'

    },
    {
        id: 5,
        question: 'How does this course help me achieve my career goals efficiently?',
        answer: "We focus only on essential skills, cutting out unnecessary content. With top resources and practical projects, you'll upskill quickly and effectively, ensuring a high ROI."

    },
    {
        id: 6,
        question: 'Is there a refund policy?',
        answer: "Yes, we offer a 7-day money-back guarantee if we are unable to cater to your learning needs. We build our courses with meticulous planning and learning frameworks. While we've never had a user find a more personalised course for them yet, if you do find one at a better price, just reach out for a refund."
    },
    {
        id: 7,
        question: 'How will I learn - would the lectures be Live or Pre-Recorded?',
        answer: 'All our courses are fully online, pre-recorded, and self-paced. You can learn anytime, anywhere, giving you the flexibility to fit learning into your own schedule and revisit lessons whenever needed.'
    },
    {
        id: 8,
        question: 'What type of content will I learn, and who creates it?',
        answer: 'We curate the best content from platforms like YouTube, selected by industry experts to ensure high-quality learning tailored to your goals.'
    },
    {
        id: 9,
        question: 'How long is the course material accessible?',
        answer: 'You’ll have lifetime access to the course, allowing you to complete and revisit the material anytime for maximum learning flexibility.'
    },
    {
        id: 10,
        question: 'How does this plan meet future job market demands?',
        answer: 'Our courses are designed with industry trends in mind and are part of Google’s Accelerator Program, giving you the skills needed to stay competitive in the job market.'
    },
]

export const certifiedFaq = [
    {
        id: 0,
        question: 'What is LearnTube?',
        answer: (<p>LearnTube is a global, AI led Education Startup which has 220+ industry- relevant courses in domains like Programming, Digital Marketing, Data Science, Design, Finance, and Investment. We have over 600K+ users learning through our website, mobile app, or whatsapp bot. Upskill with us & achieve your biggest career aspirations. Our 900+ hiring partners like Amazon, Google, Accenture, Deloitte, IBM, Meta, and many more directly pick profiles from our pool of best candidates.</p>)
    },
    {
        id: 1,
        question: 'How do I download my certificate?',
        answer: (<p>Certificate will be shared on your Email. Please be on the lookout for the same through <a href='mailto:noreply@learntube.ai' className='text-secondary-text underline'>noreply@learntube.ai</a> after your payment.</p>)
    },
    {
        id: 2,
        question: 'How valuable is this certificate in the job market?',
        answer: (<p>This certificate is your key to standing out—recognized by 1,100+ top companies like Google, Microsoft, LinkedIn, Oracle, etc., it elevates your resume value by 42% and increases your chances of landing interviews by 66%.</p>)
    },
    {
        id: 4,
        question: 'How will I receive the additional certificates that I add to my bundle?',
        answer: <p>After completing your payment, you will receive a link on your Email to select your subjects and take the corresponding assessments. Upon passing the assessments, you can download the certificates immediately, and they will also be sent to your registered Email.</p>
    },
    {
        id: 6,
        question: 'How will I access the personalized course that I add to my bundle?',
        answer: <p>After completing your payment, you will receive a link on your Email to access your personalized course.</p>
    },
    {
        id: 5,
        question: 'How will I access 1240+ certified courses that I add to my bundle?',
        answer: <p>After completing your payment, you will receive a link on your Email through which you can access 1,240+ courses on our platform. We offer a wide range of courses tailored to your interests and career goals, covering topics like Programming, Marketing, Data Science, Design, etc. as well as hobbies such as Baking, Piano, Photography, and many more.</p>
    },
    {
        id: 13,
        question: 'Will your courses really help me land interviews or get a job?',
        answer: <p>Yes, our courses can indeed help you land interviews and secure a job, but only if you sincerely engage with the coursework, complete all the assessments and projects on time & effectively showcase your skills, projects and certificates in your resume and network. Many of our learners have secured positions at top companies like Amazon and Deloitte or thrived as freelancers and entrepreneurs.</p>
    },
    {
        id: 12,
        question: 'Is there any refund policy?',
        answer: <p>We have a no questions asked 3 day refund policy incase we are unable to provide you for the service/product you have paid for.</p>
    },
]

export const otherFqs = [
    {
        id: 7,
        question: 'What are the eligibility criteria for placement?',
        answer: <p>To be eligible for placement, you need to opt in for the placement service, attend all 4 live online placement training sessions, and ensure to complete the tasks assigned during these sessions.</p>
    },
    {
        id: 8,
        question: 'What happens in the placement training sessions?',
        answer: <p>These live instructor-led sessions will help you revamp your CV, optimize your LinkedIn profile, and receive interview training with 5 practice interviews and live feedback. You'll gain valuable insights to boost your chances of landing your ideal job. The schedule for these sessions will be shared post payment.</p>
    },
    {
        id: 9,
        question: 'What comes next after I complete the placement training sessions?',
        answer: <p>Once you’ve completed all your purchased courses, attended all 4 live placement training sessions, and completed all the assigned tasks, we'll send your CV to our 1,100+ hiring partners. You can also apply for external job opportunities using the strategies learned during the training. With the mock interviews and comprehensive preparation you’ve received, you’ll be well-equipped to succeed in real interviews.</p>
    }
]

export const companyList1 = [
    'https://assets.learntube.ai/files/About-us/Stripe_-_png_0.png?updatedAt=1689841721147',
    'https://assets.learntube.ai/files/About-us/Netflix_-_png_0.png?updatedAt=1689841784275',
    'https://assets.learntube.ai/files/About-us/Twitter__-_png_0.png?updatedAt=1689841630758',
    'https://assets.learntube.ai/files/About-us/Spotify_-_png_0.png?updatedAt=1689841851007',
    'https://assets.learntube.ai/files/About-us/Expedia_-_png_0.png?updatedAt=1689842162702',
    'https://assets.learntube.ai/files/About-us/Apple_-_png_0.png?updatedAt=1689842084926',
    'https://assets.learntube.ai/files/About-us/Adobe_-_png_0.png?updatedAt=1689841946750',
    'https://assets.learntube.ai/files/About-us/Tata_Consultancy_Services_-_png_0.png?updatedAt=1689842026923',
    'https://assets.learntube.ai/files/About-us/Airbnb_-_png_0.png?updatedAt=1689842238525',
    'https://assets.learntube.ai/files/About-us/Slack_-_png_0.png?updatedAt=1689842318844',
    'https://assets.learntube.ai/files/About-us/Intel_-_png_0.png?updatedAt=1689842367676',
    'https://assets.learntube.ai/files/About-us/Figma_-_png_0.png?updatedAt=1689842408135'
]

export const companyList2 = [
    'https://assets.learntube.ai/files/Learntube/Expedia_-_png_0.png?updatedAt=1688820725181',
    'https://assets.learntube.ai/files/Learntube/Apple_-_png_0.png?updatedAt=1688820724720',
    'https://assets.learntube.ai/files/Learntube/Adobe_-_png_0.png?updatedAt=1688820725291',
    'https://assets.learntube.ai/files/Learntube/Tata_Consultancy_Services_-_png_0.png?updatedAt=1688820729741',
]

export const companyList3 = [
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Airbnb_-_png_0.png?updatedAt=1685600253243',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Slack_-_png_0__1_.png?updatedAt=1685600253185',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Intel_-_png_0.png?updatedAt=1685600253088',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Figma_-_png_0.png?updatedAt=1685600252737'
]

export const successStories = [
    {
        id: 1,
        name: 'Kishore V',
        description: "Having completed my MBA in Business Administration, my inclination towards the financial sector led me to a position in a cooperative bank. Seeking a transition to the tech field, a mutual friend recommended LearnTube as the ideal platform for upskilling and acquiring tech skills.\nThe courses, meticulously structured and easily comprehensible, facilitated my learning journey. Within a span of 3 weeks, I successfully completed around 7-8 micro-skills in UI/UX Design. The depth of the course videos and the inclusion of quizzes significantly enhanced my understanding and retention of the material.\nLearnTube's experienced mentors, who are domain experts, conducted weekly sessions, providing me with the opportunity to address any doubts or queries I encountered. I wholeheartedly endorse LearnTube to anyone seeking to upskill and navigate a career transition!",
        videoUrl: 'https://youtu.be/vVUpuvHWaz8',
        from: 'From Finance',
        to: 'Tech in 3 Weeks',
        thumbNail: 'https://assets.learntube.ai/files/certifiedOptimisation/Rectangle%205146.webp?updatedAt=1720517135735',
        thumbNail2: 'https://assets.learntube.ai/files/Post%20Payment/Rectangle%205146%20(9).png?updatedAt=1706100044811'
    },
    {
        id: 2,
        name: 'Fahmida',
        description: "My substantial academic development, spanning from the initial year to the ultimate year, owes a considerable portion of its success to the remarkable support I received in upskilling through a platform I stumbled upon on Instagram, known as LearnTube. Delving into their courses, I made the strategic decision to specialize in digital marketing.\nThe LearnTube experience went beyond merely imparting new skills and securing verified certifications; it became a transformative force in bolstering my resume and offering invaluable interview preparation assistance. The comprehensive nature of the courses allowed me to navigate the intricacies of digital marketing with confidence and competence.",
        videoUrl: 'https://youtu.be/JfGX8-Z55EE',
        from: 'Fresher',
        to: 'A Digital Marketind Specialist',
        thumbNail: 'https://assets.learntube.ai/files/certifiedOptimisation/Rectangle%205146%20(1).webp?updatedAt=1720517135700',
        thumbNail2: 'https://assets.learntube.ai/files/Post%20Payment/Rectangle%205147.png?updatedAt=1706100149035'
    },
    {
        id: 3,
        name: 'SHUBHAM GAIKWAD',
        description: "As a Computer Engineering student, my aspiration was to explore the realm of Web Development. While I possessed some preliminary knowledge, delving into the courses offered by LearnTube unveiled the vastness of the field. Through LearnTube, I not only obtained certifications in HTML, Java, and CSS but also applied these acquired skills in a practical project. The experienced mentors at LearnTube played a pivotal role in providing guidance, imparting real-world knowledge that transcended the theoretical realm.\nThe exceptional team at LearnTube was consistently supportive, readily available whenever I required assistance. This collaborative environment enhanced my learning experience, fostering a sense of confidence and competence in the intricate domain of Web Development. LearnTube not only equipped me with certifications but also facilitated the practical application of skills, bridging the gap between theoretical understanding and real-world implementation.",
        videoUrl: 'https://youtu.be/zQbxAQESw8Y',
        from: 'Computer Engineer',
        to: 'An expert Web Developer',
        thumbNail: 'https://assets.learntube.ai/files/certifiedOptimisation/Rectangle%205146%20(2).webp?updatedAt=1720517135761',
        thumbNail2: 'https://assets.learntube.ai/files/Post%20Payment/Rectangle%205148.png?updatedAt=1706100206471'
    },
    // {
    //     id: 4,
    //     name: 'Aftab ahmed',
    //     description: "Despite having a masters in aerospace engineering I was always intrigued by the world of artificial intelligence as well as robotics. That's where LearnTube came in.\n I completed various courses on LearnTube related to AI such as data structures & algorithms, python, machine learning and deep learning. I love the fact that they have content from a whole range of tutors, and you can learn from the ones who best suit you.\nSomething I found very useful was the mentorship program, which ensured that I got valuable advice that sped up my preparation. LearnTube also helped me build valuable projects using cutting-edge technology and make me confident to face interviews, and I'm hopeful that I will get into my dream company.",
    //     videoUrl: 'https://youtu.be/nPFIEpK8NKE',
    //     from: 'Pivot from Aersopace engineering',
    //     to: 'AI',
    //     thumbNail: 'https://assets.learntube.ai/files/certifiedOptimisation/Rectangle%205146%20(3).webp?updatedAt=1720517135641',
    //     thumbNail2: 'https://assets.learntube.ai/files/Post%20Payment/Rectangle%205149.png?updatedAt=1706100257026'
    // },
    {
        id: 7,
        name: 'Ribhu',
        description: "Being a freelancer, I knew that despite having a Masters degree in Mass Communication, I needed to keep updating my skills to have a competitive edge in my career. I started learning Search Engine Marketing on LearnTube to understand the field of SEM in depth and Marketing as a whole and enhance my knowledge.\nThe best part about LearnTube is that they support you through every step of your upskilling journey and help you analyze your progress from start to end and provide insightful tips to boost your learning curve.\nAfter finishing the SEM courses on LearnTube, I have a much deeper understanding about the subject. I am confident in demonstrating my SEM skills to my clients and in the process even gained new clients!",
        videoUrl: 'https://youtu.be/pKkerknQF5k',
        from: 'Passive freelancing',
        to: 'Landing countless clients',
        thumbNail: 'https://assets.learntube.ai/files/certifiedOptimisation/Rectangle%205146%20(6).webp?updatedAt=1720517135714',
        thumbNail2: 'https://assets.learntube.ai/files/Post%20Payment/Rectangle%205152.png?updatedAt=1706100433715'
    },
    {
        id: 5,
        name: 'Dinesh',
        description: "After my graduation, I was on the lookout for internships and full-time jobs when a friend told me about an app called LearnTube. I signed up and started learning various courses such as Computer Fundamentals and some programming languages. The courses were well structured and the videos explained the concepts in depth, which benefited me a lot in enhancing my skills.\nArmed with stronger and better skillsets, I landed an internship at Candere by Kalyan Jewellers with a great stipend. I kept gaining more skills on LearnTube along with my internship. Once my internship was over, I decided to turn my focus towards getting a full time job.\nI started learning some core skills such as Machine Learning and enhancing my CV and profile, all of which led me to crack an excellent job opportunity at Mirae Asset Capital Markets as a Software Developer, with a significant salary bump and great perks!",
        videoUrl: 'https://www.youtube.com/shorts/FLkTD1R_tfg',
        from: 'Graduate',
        to: 'Landing an internship at Kalyan Jewellers',
        thumbNail: 'https://assets.learntube.ai/files/certifiedOptimisation/Rectangle%205146%20(4).webp?updatedAt=1720517135705',
        thumbNail2: 'https://assets.learntube.ai/files/Post%20Payment/Rectangle%205150.png?updatedAt=1706100314081'
    },
    {
        id: 6,
        name: 'Darshan Deshmukh',
        description: "Enrolling in LearnTube initiated my exploration of various Python courses, with a focus on Modules and Packages. Completing these courses significantly enhanced my understanding of Python and its crucial role in data analytics, vital for my ongoing pursuits in this field.\nAddressing challenges or unclear concepts during the learning process became effortless by consulting the experienced mentors on LearnTube. Their guidance played a key role in fortifying my understanding and strengthening foundational concepts.\nAn exceptional feature of these courses is their cost-free nature, ensuring access to valuable learning resources without financial burden. This not only fosters a conducive learning environment but also democratizes education, providing high-quality Python courses to learners without monetary constraints. LearnTube has truly become an invaluable asset in my journey to expertise in Python and data analytics.",
        videoUrl: 'https://youtube.com/shorts/iJxXNE5DsVM?feature=share',
        from: 'Novice',
        to: 'An Expert Data Analyst',
        thumbNail: 'https://assets.learntube.ai/files/certifiedOptimisation/Rectangle%205146%20(5).webp?updatedAt=1720517135623',
        thumbNail2: 'https://assets.learntube.ai/files/Post%20Payment/Rectangle%205151.png?updatedAt=1706100362879'
    },
    {
        id: 9,
        name: 'Sree Varsha',
        description: "Being a computer science and engineering I was always intrigued by the world of Full stack development . That's where LearnTube came in.\nI completed various courses on LearnTube related to Full Stack Development such as data structures & algorithms, Front end development (HTML, CSS, JS and REACT JS) , Backend (MERN) and much more. I love the fact that they have content from a whole range of tutors, and you can learn from the ones who best suit you.\nSomething I found very useful was the mentorship program, which ensured that I got valuable advice that sped up my preparation. LearnTube also helped me build valuable projects using cutting-edge technology and make me confident to face interviews, and I'm hopeful that I will get into my dream company.",
        videoUrl: 'https://www.youtube.com/watch?feature=shared&v=H6KNNlCLdc8',
        from: 'Computer Science Engineer',
        to: 'A Full Stack Developer',
        thumbNail: 'https://assets.learntube.ai/files/certifiedOptimisation/Rectangle%205146%20(7).webp?updatedAt=1720517135538',
        thumbNail2: 'https://assets.learntube.ai/files/Post%20Payment/Rectangle%205153.png?updatedAt=1706100491936'
    },
    {
        id: 10,
        name: 'Rupa Shree',
        description: "Earning five LearnTube certifications in a month marked the start of my academic journey. The WhatsApp bot amazed me, enabling seamless learning on the go, even amid travel or work. LearnTube's organized courses, with regular quizzes, fortified my understanding and ensured concept retention, boosting confidence in my PGDM studies.\nLearnTube's versatile approach, integrating the WhatsApp bot, made education flexible. The structured curriculum, with interactive quizzes, vitalized my knowledge for PGDM challenges. LearnTube's commitment to enhancing learning was evident, offering a valuable resource that significantly enriched my academic pursuits.",
        videoUrl: 'https://youtu.be/KvygfsHoUUE',
        from: 'Went from achieveing 5 Certificates a month',
        to: 'Aceing her PGDM studies ',
        thumbNail: 'https://assets.learntube.ai/files/certifiedOptimisation/Rectangle%205146%20(8).webp?updatedAt=1720517135770',
        thumbNail2: 'https://assets.learntube.ai/files/Post%20Payment/Rectangle%205154.png?updatedAt=1706100529885'
    },
]

export const successStoriesTwo = [
    {
        id: 1,
        name: 'Saurabh Sharma',
        from: 'Product Manager',
        to: 'General Manager Marketing',
        thumbNail: 'https://assets.learntube.ai/files/personalise-app-lesson/Ellipse%20828.svg?updatedAt=1738043989778',
    },
    {
        id: 2,
        name: 'Koganti Bhavya Sri',
        from: 'Computer Operator',
        to: 'HR Manager Specializing in US IT Recruitment',
        thumbNail: 'https://assets.learntube.ai/files/personalise-app-lesson/Ellipse%20828%20(1).svg?updatedAt=1738044100529',
    },
    {
        id: 3,
        name: 'Kanak Saini',
        from: 'Quality Assurance Engineer',
        to: 'Senior Analyst - QA',
        thumbNail: 'https://assets.learntube.ai/files/personalise-app-lesson/Group%206517.svg?updatedAt=1738044327261',
    },
    {
        id: 7,
        name: 'Manish K Sapru',
        from: 'Technical Service Associate',
        to: 'Team Leader - Operations',
        thumbNail: 'https://assets.learntube.ai/files/personalise-app-lesson/Group%206517%20(1).svg?updatedAt=1738044430582',
    }
]

export async function getLinkFromBuffer(testData){
    try{
        const blob = new Blob([testData], {
            type: 'image/jpeg',
        })
        let urlCreator = window.URL || window.webkitURL;
        let imageUrl = urlCreator.createObjectURL( blob )
        return imageUrl;
    }
    catch(err){
        console.log(err);
    }
}

const constants = {

    Mixpanel: {
        // Landing Page 
        LANDING_PAGE: 'Landing-Page loaded',
        LANDING_PAGE_BUTTON_CLICKED: 'Landing-Page Take Quiz Button Was Clicked',

        // Course Selection Page
        COURSE_AND_SKILL_SELECTION_PAGE_LOADED: 'Course and Skill selection page loaded',
        COURSE_PAGE_COURSE_SELECTED: 'Course was selected',
        COURSE_PAGE_SKILL_SELECTED: 'SKill was selected',

        // Skill Selection Page
        SKILL_SELECTION_PAGE_LOADED: 'Skill Selection Page Loaded',
        SKILL_SELECTION_PAGE_SKILL_SELECTED: 'Skill was selected',
        
        // Onboarding Page
        ONBOARDING_PAGE: 'Onboarding-Page loaded',
        ONBOARDING_PAGE_BUTTON_CLICKED: 'Onboarding-Page First Name and Last Name Was Submitted',
        ONBOARDING_PAGE_LOADER_SCREEN_1: 'Onboarding-Page First Screen Was Loaded',
        ONBOARDING_PAGE_LOADER_SCREEN_2: 'Onboarding-Page Second Screen Was Loaded',

        // MCQ Page
        MCQ_PAGE_QUESTION_1: 'MCQ First Question Was Loaded',
        MCQ_PAGE_ANSWER_1: 'MCQ First Question Was Answered',
        MCQ_PAGE_RE_ANSWER_1: 'MCQ First Question Was Answered Again',
        MCQ_PAGE_QUESTION_2: 'MCQ Second Question Was Loaded',
        MCQ_PAGE_ANSWER_2: 'MCQ Second Question Was Answered',
        MCQ_PAGE_RE_ANSWER_2: 'MCQ Second Question Was Answered Again',
        MCQ_PAGE_QUESTION_3: 'MCQ Third Question Was Loaded',
        MCQ_PAGE_ANSWER_3: 'MCQ Third Question Was Answered',
        MCQ_PAGE_RE_ANSWER_3: 'MCQ Third Question Was Answered Again',
        MCQ_PAGE_QUESTION_4: 'MCQ Fourth Question Was Loaded',
        MCQ_PAGE_ANSWER_4: 'MCQ Fourth Question Was Answered',
        MCQ_PAGE_RE_ANSWER_4: 'MCQ Fourth Question Was Answered Again',
        MCQ_PAGE_QUESTION_5: 'MCQ Fifth Question Was Loaded',
        MCQ_PAGE_ANSWER_5: 'MCQ Fifth Question Was Answered',
        MCQ_PAGE_RE_ANSWER_5: 'MCQ Fifth Question Was Answered Again',
        MCQ_PAGE_QUESTION_6: 'MCQ Sixth Question Was Loaded',
        MCQ_PAGE_ANSWER_6: 'MCQ Sixth Question Was Answered',
        MCQ_PAGE_RE_ANSWER_6: 'MCQ Sixth Question Was Answered Again',
        MCQ_PAGE_QUESTION_7: 'MCQ Seventh Question Was Loaded',
        MCQ_PAGE_ANSWER_7: 'MCQ Seventh Question Was Answered',
        MCQ_PAGE_RE_ANSWER_7: 'MCQ Seventh Question Was Answered Again',
        MCQ_PAGE_QUESTION_8: 'MCQ Eigth Question Was Loaded',
        MCQ_PAGE_ANSWER_8: 'MCQ Eigth Question Was Answered',
        MCQ_PAGE_RE_ANSWER_8: 'MCQ Eigth Question Was Answered Again',
        MCQ_PAGE_QUESTION_9: 'MCQ Ninth Question Was Loaded',
        MCQ_PAGE_ANSWER_9: 'MCQ Ninth Question Was Answered',
        MCQ_PAGE_RE_ANSWER_9: 'MCQ Ninth Question Was Answered Again',
        MCQ_PAGE_QUESTION_10: 'MCQ Tenth Question Was Loaded',
        MCQ_PAGE_ANSWER_10: 'MCQ Tenth Question Was Answered',
        MCQ_PAGE_RE_ANSWER_10: 'MCQ Tenth Question Was Answered Again',

        // Register Page
        REGISTER_PAGE: 'Register Page Was Loaded',
        REGISTER_PAGE_PHONE_NO: 'Register Page Phone No Was Submitted',
        REGISTER_PAGE_EMAIL: 'Register Page Email Was Submitted',
        REGISTER_PAGE_LOADER: 'Register Page Loader Screen Loaded',
        REGISTER_PAGE_JOB_ROLE: 'Register Page Job Role Was Submitted',
        REGISTER_PAGE_USER_NAME : 'Register Page User Name Was Submitted',

        // Analysis Page
        ANALYSIS_PAGE: 'Analysis Page Was Loaded',
        SEO_ANALYSIS_PAGE_LOADED: 'SEO Analysis Page Loaded',
        ANALYSIS_PAGE_ADDITIONAL_FEATURE: 'Analysis Page Additional Features Was Clicked',
        ANALYSIS_PAGE_ADDITIONAL_FEATURE_1: 'Analysis Page Additional Feature One Was Selected',
        ANALYSIS_PAGE_ADDITIONAL_FEATURE_1_REMOVED: 'Analysis Page Additional Feature One Was Removed',
        ANALYSIS_PAGE_ADDITIONAL_FEATURE_2: 'Analysis Page Additional Feature Two Was Selected',
        ANALYSIS_PAGE_ADDITIONAL_FEATURE_2_REMOVED: 'Analysis Page Additional Feature Two Was Removed',
        ANALYSIS_PAGE_ADDITIONAL_FEATURE_3: 'Analysis Page Additional Feature Three Was Selected',
        ANALYSIS_PAGE_ADDITIONAL_FEATURE_3_REMOVED: 'Analysis Page Additional Feature Three Was Removed',
        ANALYSIS_PAGE_STICKY_BUTTON: 'Analysis Page Sticky Button Was Clicked',
        ANALYSIS_PAGE_NORMAL_BUTTON_TOP: 'Analysis Page Normal Top Button Was Clicked',
        ANALYSIS_PAGE_NORMAL_BUTTON_DOWN: 'Analysis Page Normal Bottom Button Was Clicked',
        ANALYSIS_PAGE_ANALYSIS_BUTTON: 'Analysis Page Unlock Analysis Button Was Clicked',

        // Saved Analysis Page
        SAVED_ANALYSIS_PAGE: 'Saved Analysis Page Was Loaded',
        SEO_SAVED_ANALYSIS_PAGE_LOADED: 'SEO Analysis Page Loaded',
        SAVED_ANALYSIS_PAGE_ADDITIONAL_FEATURE: 'Saved Analysis Page Additional Features Was Clicked',
        SAVED_ANALYSIS_PAGE_ADDITIONAL_FEATURE_1: 'Saved Analysis Page Additional Feature One Was Selected',
        SAVED_ANALYSIS_PAGE_ADDITIONAL_FEATURE_1_REMOVED: 'Saved Analysis Page Additional Feature One Was Removed',
        SAVED_ANALYSIS_PAGE_ADDITIONAL_FEATURE_2: 'Saved Analysis Page Additional Feature Two Was Selected',
        SAVED_ANALYSIS_PAGE_ADDITIONAL_FEATURE_2_REMOVED: 'Saved Analysis Page Additional Feature Two Was Removed',
        SAVED_ANALYSIS_PAGE_ADDITIONAL_FEATURE_3: 'Saved Analysis Page Additional Feature Two Was Selected',
        SAVED_ANALYSIS_PAGE_ADDITIONAL_FEATURE_3_REMOVED: 'Saved Analysis Page Additional Feature Two Was Removed',
        SAVED_ANALYSIS_PAGE_STICKY_BUTTON: 'Saved Analysis Page Sticky Button Was Clicked',
        SAVED_ANALYSIS_PAGE_NORMAL_BUTTON_TOP: 'Saved Analysis Page Normal Top Button Was Clicked',
        SAVED_ANALYSIS_PAGE_NORMAL_BUTTON_DOWN: 'Saved Analysis Page Normal Bottom Button Was Clicked',
        SAVED_ANALYSIS_PAGE_ANALYSIS_BUTTON: 'Saved Analysis Page Unlock Analysis Button Was Clicked',

        //Leaderboard Page
        LEADERBOARD_PAGE_LOADED : 'Leaderboard Page was Loaded',
        LEADERBOARD_PAGE_GET_MORE_CERTIFICATES : 'Leaderboard Page Get More Certificates was Clicked',
        LEADERBOARD_PAGE_PERFECT_YOUR_SKILLS: 'Leaderboard Page View Personalised Course was Clicked',
        LEADERBOARD_PAGE_GET_IN_THE_TOP : 'Leaderboard Page Top 10 was Clicked',

        // New Leaderboard Page loaded
        NEW_LEADERBOARD_PAGE_LOADED: 'New Leaderboard Page was loaded',
        NEW_LEADERBOARD_PAGE_GET_MORE_CERTIFICATE_CARD_CLICKED: 'New Leaderboard Page Get More Certificates was Clicked',
        NEW_LEADERBOARD_PAGE_PERFECT_YOUR_SKILLS_CARD_CLICKED: 'New Leaderboard Page Get Personalised Course was Clicked',
        NEW_LEADERBOARD_PAGE_LEADERBOARD_BUTTON_CLICKED: 'New Leaderboard Page Leaderboard Button was Clicked',
        NEW_LEADERBOARD_PAGE_ANALYSIS_PERSONALISED_COURSE_BUTTON_CLICKED: 'New Leaderboard Page Analysis Personalised Button was Clicked',
        NEW_LEADERBOARD_PAGE_SOMETHING_ELSE_CLICKED: 'New Leaderboard Page Something Else Button was Clicked',
        NEW_LEADERBOARD_PAGE_STICKY_BUTTON_FOR_PERSONALISE_CLICKED: 'New Leaderboard Page Sticky Button for Personalised Course was Clicked',
        NEW_LEADERBOARD_PAGE_STICKY_BUTTON_FOR_MORE_CERTIFICATES_CLICKED: 'New Leaderboard Page Sticky Button For More Certificates was Clicked',
        NEW_LEADERBOARD_PAGE_CERTIFICATE_WAS_DOWNLOADED: 'New Leaderboard Page Download Button was Clicked',
    
        //MultiSelectionPage
        MULTISELECTION_PAGE_LOADED : 'MultiSelectionSkillPage was Loaded',
        MULTISELECTION_PAGE_COURSE : 'MultiSelectionSkillPage Course was Selected',
        MULTISELECTION_PAGE_SKILL : 'MultiSelectionSkillPage Skill was Selected',
        MULTISELECTION_PAGE_SKILL_UNSELECT: 'MultiSelectionSkillPage Skill was Unselected',
        MULTISELECTION_PAGE_NEXT_BUTTON : 'MultiSelectionSkillPage Skill Next Button was Selected',

        // New MultiSkillSelectionPage
        NEW_MULTISKILL_SELECTION_PAGE: 'New MultiSkillSelectionPage was loaded',
        NEW_MULTISKILL_SELECTION_PAGE_NEXT_BUTTON: 'New MultiSkillSelectionPage Next button was clicked',
        NEW_MULTISKILL_SELECTION_PAGE_SKILL_WAS_SELECTED: 'New MultiSkillSelectionPage Skill was selected',
        NEW_MULTISKILL_SELECTION_PAGE_SKILL_WAS_REMOVED: 'New MultiSkillSelectionPage Skill was removed',

        // Multi Skill Selection Pricing Page
        MULTI_SKILL_SELECTION_PRICING_PAGE: 'Multi skill selection Pricing Page was Selected',
        MULTI_SKILL_SELECTION_PRICING_PAGE_FEATURE_1_SELECTED: 'Multi skill selection Pricing Page Feature 1 was Selected',
        MULTI_SKILL_SELECTION_PRICING_PAGE_FEATURE_2_SELECTED: 'Multi skill selection Pricing Page Feature 2 was Selected',
        MULTI_SKILL_SELECTION_PRICING_PAGE_FEATURE_1_REMOVED: 'Multi skill selection Pricing Page Feature 1 was Removed',
        MULTI_SKILL_SELECTION_PRICING_PAGE_FEATURE_2_REMOVED: 'Multi skill selection Pricing Page Feature 2 was Removed',
        MULTI_SKILL_SELECTION_PRICING_PAGE_STICKY_BUTTON: 'Multi skill selection Page Sticky Button Was Clicked',
        MULTI_SKILL_SELECTION_PRICING_PAGE_NORMAL_BUTTON_TOP: 'Multi skill selection Page Normal Top Button Was Clicked',
        MULTI_SKILL_SELECTION_PRICING_PAGE_NORMAL_BUTTON_DOWN: 'Multi skill selection Page Normal Bottom Button Was Clicked',

        // Certificate Course
        LEADERBOARD_PERSONALISE_BUTTON_CLICKED: "Personalise course button in leaderboard clicked",
        CERTIFICATE_COURSE_PAGE_LOADED: "Personalise course page loaded",
        CERTIFICATE_COURSE_PAGE_STICKY_BUTTON: "Personalise course sticky button was clicked",
        CERTIFICATE_COURSE_PAGE_NORMAL_BUTTON: "Personalise course normal button was clicked",

        // Skill Level Selection Page
        SKILL_LEVEL_PAGE_LOADED: "Skill Level page loaded",
        SKILL_LEVEL_PAGE_SKILL_SELECTED: "Skill Level page skill was selected",
        SKILL_LEVEL_SELECTION_PAGE_LOADER_SCREEN_1: "Skill Level Selection Page Loader 1 Loaded",
        SKILL_LEVEL_SELECTION_PAGE_LOADER_SCREEN_2: "Skill Level Selection Page Loader 2 Loaded",
        SKILL_LEVEL_SELECTION_PAGE_LOADER_SCREEN_3: "Skill Level Selection Page Loader 3 Loaded",
        SKILL_LEVEL_SELECTION_PAGE_LOADER_SCREEN_4: "Skill Level Selection Page Loader 4 Loaded",

        // Questions Page
        QUESTIONS_PAGE: "Questions page was loaded",
        QUESTION_1_ANSWERED: "Question 1 was answered",
        QUESTION_2_ANSWERED: "Question 2 was answered",
        QUESTION_3_ANSWERED: "Question 3 was answered",
        QUESTION_4_ANSWERED: "Question 4 was answered",
        QUESTION_5_ANSWERED: "Question 5 was answered",
        QUESTION_1_NEXT_BUTTON: "Question 1 next button was clicked",
        QUESTION_2_NEXT_BUTTON: "Question 2 next button was clicked",
        QUESTION_3_NEXT_BUTTON: "Question 3 next button was clicked",
        QUESTION_4_NEXT_BUTTON: "Question 4 next button was clicked",
        QUESTION_5_NEXT_BUTTON: "Question 5 next button was clicked",

        // Analysis Page
        ANALYSIS_PAGE_LOADED: "Analysis Page Loaded",
        ANALYSIS_PAGE_LOADER_SCREEN_1: "Analysis Page Loader Screen 1 Loaded",
        ANALYSIS_PAGE_LOADER_SCREEN_2: "Analysis Page Loader Screen 2 Loaded",
        ANALYSIS_PAGE_LOADER_SCREEN_3: "Analysis Page Loader Screen 3 Loaded",
        ANALYSIS_PAGE_LOADER_SCREEN_4: "Analysis Page Loader Screen 4 Loaded",
        ANALYSIS_STICKY_BUTTON: "Analysis Page Sticky Button was Clicked",
        ANALYSIS_NORMAL_BUTTON: "Analysis Normal Button was Clicked",
        SKIP_ADD_ON_BUTTON: "Skip Add On Button was Clicked",

        //New Analysis Page
        ANALYSIS_PAGE_STICKY_PAYMENT_BUTTON_WAS_CLICKED: 'Analysis Page Sticky Payment Button Was Clicked',
        ANALYSIS_PAGE_MAIN_PAYMENT_BUTTON_WAS_CLICKED: 'Analysis Page Main Payment Button Was Clicked',
        ANALYSIS_PAGE_YOUR_SCORE_TILE_WAS_OPENED: 'Analysis Page Your Score Tile Was Opened',
        ANALYSIS_PAGE_UPGRADE_CAREER_PAYMENT_BUTTON_WAS_CLICKED: 'Analysis Page Upgrade Career Payment Button Was Clicked',
        ANALYSIS_PAGE_CHANGE_SKILL_BUTTON_WAS_CLICKED: 'Analysis Page Change Skill Button Was Clicked',
        ANALYSIS_PAGE_CHANGE_SKILL_MODAL_WAS_OPENED: 'Analysis Page Change Skill Modal Was Opened',
        ANALYSIS_PAGE_CHANGE_SKILL_MODAL_CONTINUE_BUTTON_WAS_CLICKED: 'Analysis Page Change Skill Continue Button Was Clicked',
        ANALYSIS_PAGE_GET_COURSE_BUTTON_WAS_CLICKED: 'Analysis Page Get Course Button Was Clicked',
        ANALYSIS_PAGE_GET_COURSE_MODAL_WAS_OPENED: 'Analysis Page Get Course Modal Was Opened',
        ANALYSIS_PAGE_UNLOCK_COURSE_BUTTON_ON_MODAL_WAS_CLICKED: 'Analysis Page Unlock Course Button On Modal Was Clicked',
        ANALYSIS_PAGE_SHEWTA_VIDEO_LINK_WAS_CLICKED: "Analysis Page Shweta's Video Link Was Clicked",
        ANALYSIS_PAGE_ADD_ONS_BUTTON_WAS_CLICKED: 'Analysis Page Add-Ons Button Was Clicked',

        NEW_CART_PAGE_LOADED: 'T1 Cart Page Was Loaded',
        NEW_CART_PAGE_INSTANT_CERTIFICATES_MODAL_ON_CART_WAS_OPENED: 'T1 Instant Certificates Modal On Cart Was Opened',
        NEW_CART_PAGE_3_CERTIFICATE_BUNDLE_ON_CART_WAS_ADDED: 'T1 3 Certificate Bundle On Cart Was Added',
        NEW_CART_PAGE_3_CERTIFICATE_BUNDLE_ON_CART_WAS_REMOVED: 'T1 3 Certificate Bundle On Cart Was Removed',
        NEW_CART_PAGE_5_CERTIFICATE_BUNDLE_ON_CART_WAS_ADDED: 'T1 5 Certificate Bundle On Cart Was Added',
        NEW_CART_PAGE_5_CERTIFICATE_BUNDLE_ON_CART_WAS_REMOVED: 'T1 5 Certificate Bundle On Cart Was Removed',
        NEW_CART_PAGE_7_CERTIFICATE_BUNDLE_ON_CART_WAS_ADDED: 'T1 7 Certificate Bundle On Cart Was Added',
        NEW_CART_PAGE_7_CERTIFICATE_BUNDLE_ON_CART_WAS_REMOVED: 'T1 7 Certificate Bundle On Cart Was Removed',
        NEW_CART_PAGE_CERTIFIED_COURSES_MODAL_WAS_OPENED: 'T1 Certified Courses Modal On Cart Was Opened',
        NEW_CART_PAGE_PLACEMENT_MODAL_WAS_OPENED: 'T1 Certified Courses Modal On Cart Was Opened',
        NEW_CART_PAGE_STICKY_BAR_PAYMENT_BUTTON_WAS_CLICKED: 'T1 Sticky Bar Payment Button Was Clicked',

        NEW_SCANNING_LOADER_SCREEN_WAS_LOADED: 'Certificate Scanning Loader Screen Was Loaded',

        // Personalise Course
        PERSONALISE_COURSE_PAGE_LOADED: "Personalise course page loaded",
        PERSONALISE_COURSE_PAGE_STICKY_BUTTON: "Personalise course sticky button was clicked",
        PERSONALISE_COURSE_PAGE_NORMAL_BUTTON: "Personalise course normal button was clicked",

        // Personalise course pricing page
        PERSONALISE_COURSE_PRICING_PAGE: "Personalise course pricing page loaded",
        PERSONALISE_COURSE_PRICING_PAGE_FEATURE_1: "Personalise course pricing page feature 1 selected",
        PERSONALISE_COURSE_PRICING_PAGE_FEATURE_2: "Personalise course pricing page feature 2 selected",
        PERSONALISE_COURSE_PRICING_PAGE_FEATURE_1_REMOVED: "Personalise course pricing page feature 1 removed",
        PERSONALISE_COURSE_PRICING_PAGE_FEATURE_2_REMOVED: "Personalise course pricing page feature 2 removed",
        PERSONALISE_COURSE_PRICING_PAGE_STICKY_BUTTON: "Personalise course pricing page sticky button clicked",
        PERSONALISE_COURSE_PRICING_PAGE_NORMAL_BUTTON: "Personalise course pricing page normal button clicked",

        // Certified course pricing page
        CERTIFICATE_COURSE_PRICING_PAGE: "Certified course pricing page loaded",
        CERTIFICATE_COURSE_PRICING_PAGE_FEATURE_1: "Certified course pricing page feature 1 selected",
        CERTIFICATE_COURSE_PRICING_PAGE_FEATURE_2: "Certified course pricing page feature 2 selected",
        CERTIFICATE_COURSE_PRICING_PAGE_FEATURE_1_REMOVED: "Certified course pricing page feature 1 removed",
        CERTIFICATE_COURSE_PRICING_PAGE_FEATURE_2_REMOVED: "Certified course pricing page feature 2 removed",
        CERTIFICATE_COURSE_PRICING_PAGE_STICKY_BUTTON: "Certified course pricing page sticky button clicked",
        CERTIFICATE_COURSE_PRICING_PAGE_NORMAL_BUTTON: "Certified course pricing page normal button clicked",

        // Flightbooking Style Addon features
        NEW_ADDON_FEATURE_CERTIFICATES_SELECTION_PAGE: "New Addon multiple certificate selection page loaded",
        NEW_ADDON_FEATURE_CERTIFICATES_THREE_CERTIFICATES_SELECTED: "New Addon three certificates bundle selected",
        NEW_ADDON_FEATURE_CERTIFICATES_THREE_CERTIFICATES_REMOVED: "New Addon three certificates bundle removed",
        NEW_ADDON_FEATURE_CERTIFICATES_FIVE_CERTIFICATES_SELECTED: "New Addon five certificates bundle selected",
        NEW_ADDON_FEATURE_CERTIFICATES_FIVE_CERTIFICATES_REMOVED: "New Addon five certificates bundle removed",
        NEW_ADDON_FEATURE_CERTIFICATES_SEVEN_CERTIFICATES_SELECTED: "New Addon Seven certificates bundle selected",
        NEW_ADDON_FEATURE_CERTIFICATES_SEVEN_CERTIFICATES_REMOVED: "New Addon Seven certificates bundle removed",
        NEW_ADDON_FEATURE_CERTIFICATES_CONTINUE_WITH_1_CERTIFICATE: "New Addon certificates continue with 1 certificate button clicked",
        NEW_ADDON_FEATURE_HANDLE_BACKWARD_FROM_CERTIFICATES_PAGE: "New Addon going back button from certificates page clicked",
        NEW_ADDON_FEATURE_CERTIFICATES_STICKY_BAR_NEXT_BUTTON: "New Addon certificates sticky bar next button clicked",
        NEW_ADDON_FEATURE_CERTIFICATES_TOP_SKIP_THIS_BUTTON: "New Addon certicates top skip this button clicked",
        NEW_ADDON_FEATURE_CERTIFICATES_TOP_MOVE_FORWARD_THIS_BUTTON: "New Addon certicates top moveforward button clicked",
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_PAGE: "New Addon personal and pro memberships selection page loaded",
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_PERSONALISED_COURSE_SELECTED: "New Addon personal and pro memberships personalised course selected",
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_PERSONALISED_COURSE_REMOVED: "New Addon personal and pro memberships personalised course removed",
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_PRO_MEMBERSHIP_COURSE_SELECTED: "New Addon personal and pro memberships pro-membership selected",
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_PRO_MEMBERSHIP_COURSE_REMOVED: "New Addon personal and pro memberships pro-membership removed",
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_CONTINUE_WITH_BUTTON: "New Addon personal and pro memberships continue with button clicked",
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_ANALYSIS_BUTTON: "New Addon personal and pro memberships personalised course selected from Analysis section",
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_STICKY_BAR_GET_CERTIFICATE_BUTTON: "New Addon personal and pro memberships sticky bar get certificate button clicked",
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_SKIP_THIS_BUTTON: "New Addon personal and pro memberships skip this button clicked",
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_BACK_BUTTON: "New Addon personal and pro memberships back button clicked",
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_BOTTOM_STICKY_SKIP_BUTTON: "New Addon personal and pro memberships bottom sticky bar skip button clicked",
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_BOTTOM_STICKY_ADDING_BOTH_ADDON_BUTTON: "New Addon personal and pro memberships bottom sticky bar adding both addon button clicked",
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_FOUR_WEEK_PLACEMENT_SELECTED: "New Addon personal and pro memberships four week placement selected",
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_FOUR_WEEK_PLACEMENT_REMOVED: "New Addon personal and pro memberships four week placement removed",
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_ONE_ON_ONE_MENTORSHIP_SELECTED: "New Addon personal and pro memberships one on one mentorship selected",
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_ONE_ON_ONE_MENTORSHIP_REMOVED: "New Addon personal and pro memberships one on one removed",
        CERTIFICATE_AND_PERSONALISE_BUTTON_CLICKED: "Personalise and certificate button clicked",
        CERTIFICATE_BUTTON_CLICKED: 'Certificate button clicked',
        FIRST_TRANSACTION_PAYMENT_CANCEL_MODAL_OPENED: 'First Transaction Payment Cancel Modal Opened',
        FIRST_TRANSACTION_PAYMENT_CANCEL_MODAL_PAYMENT_BUTTON_CLICKED: 'First Transaction Payment Cancel Modal Payment Button Clicked',
        FIRST_TRANSACTION_PAYMENT_CANCEL_MODAL_CLOSED: 'First Transaction Payment Cancel Modal Closed',

        // Post Payment feature
        NEW_POST_PAYMENT_FEATURE_PLACEMENT_TAB_SELECTED: "New post payment placement feature tab selected",
        NEW_POST_PAYMENT_FEATURE_LEARNING_TAB_SELECTED: "New post payment learning feature tab selected",
        NEW_POST_PAYMENT_FEATURE_LOADED: "New post payment feature loaded",
        NEW_POST_PAYMENT_FEATURE_LEARNING_PACK_SELECTED: "New post payment feature learning pack selected",
        NEW_POST_PAYMENT_FEATURE_PLACEMENT_PACK_SELECTED: "New post payment feature placement pack selected",
        NEW_POST_PAYMENT_FEATURE_PLACEMENT_ADD_ON_SELECTED: "New post payment feature placement pack add on selected",
        NEW_POST_PAYMENT_FEATURE_MENTORSHIP_ADD_ON_SELECTED: "New post payment feature mentorship add on selected",
        NEW_POST_PAYMENT_FEATURE_LEARNING_PACK_ADD_ON_SELECTED: "New post payment feature learning pack add on selected",
        NEW_POST_PAYMENT_FEATURE_LEARNING_PACK_BOTTOM_STICKY_SELECTED: "New post payment feature learning pack bottom sticky selected",
        NEW_POST_PAYMENT_FEATURE_PLACEMENT_PACK_BOTTOM_STICKY_SELECTED: "New post payment feature placement pack bottom sticky selected",
        NEW_POST_PAYMENT_FEATURE_CERTIFICATE_SHARE_BUTTON_CLICKED: "New post payment feature certificate share button clicked",
        NEW_POST_PAYMENT_FEATURE_CERTIFICATE_DOWNLOAD_BUTTON_CLICKED: "New post payment feature certificate download button clicked",
        NEW_POST_PAYMENT_FEATURE_PERSONALISE_SUBJECT_ADDON_CLICKED: "New post payment feature personalise addon selected",
        NEW_POST_PAYMENT_FEATURE_PERSONALISE_SUBJECT_ADDON_REMOVED: "New post payment feature personalise addon removed",
        NEW_POST_PAYMENT_FEATURE_CV_SHARING_ADDON_CLICKED: "New post payment feature CV sharing addon selected",
        NEW_POST_PAYMENT_FEATURE_CV_SHARING_ADDON_REMOVED: "New post payment feature CV sharing addon removed",
        NEW_POST_PAYMENT_FEATURE_PRACTICE_INTERVIEW_ADDON_CLICKED: "New post payment feature practice interview addon selected",
        NEW_POST_PAYMENT_FEATURE_PRACTICE_INTERVIEW_ADDON_REMOVED: "New post payment feature practice interview addon removed",
        NEW_POST_PAYMENT_FEATURE_INSTANT_CERTIFICATE_ADDON_CLICKED: "New post payment feature instant certificate addon selected",
        NEW_POST_PAYMENT_FEATURE_INSTANT_CERTIFICATE_ADDON_REMOVED: "New post payment feature instant certificate addon removed",
        NEW_POST_PAYMENT_FEATURE_CV_REVAMP_ADDON_CLICKED: "New post payment feature CV revamp addon selected",
        NEW_POST_PAYMENT_FEATURE_CV_REVAMP_ADDON_REMOVED: "New post payment feature CV revamp addon removed",

        // Thank You page after purchasing current certificate course
        THANK_YOU_PAGE_LOADED: "Thank You Page Loaded After Purchase",

        // New Post payment feature
        NEW_POST_CERTIFICATE_PURCHASE_PAGE_LOADED: "New Post Certificate Purchase Page Loaded",
        NEW_POST_CERTIFICATE_PURCHASE_PAGE_NORMAL_BUTTON_CLICKED: "New Post Certificate Purchase Page Normal Buy Button Clicked",
        NEW_POST_CERTIFICATE_PURCHASE_PAGE_STICKY_BUTTON_CLICKED: "New Post Certificate Purchase Page Sticky Buy Button Clicked",
        NEW_POST_CERTIFICATE_PURCHASE_PAGE_NORMAL_CONTACT_COUNSELLOR_BUTTON_CLICKED: "New Post Certificate Purchase Page Normal Contact Counsellor Button Clicked",
        NEW_POST_CERTIFICATE_PURCHASE_PAGE_STICKY_CONTACT_COUNSELLOR_BUTTON_CLICKED: "New Post Certificate Purchase Page Sticky Contact Counsellor Button Clicked",
        NEW_POST_CERTIFICATE_PURCHASE_PAGE_EDIT_USER_GOAL_BUTTON_CLICKED: "New Post Certificate Purchase Page Edit User Goal Button Clicked",
        NEW_POST_CERTIFICATE_PURCHASE_PAGE_VIEW_SYLLABUS_BUTTON_CLICKED: "New Post Certificate Purchase Page View Syllabus Button Clicked",
        NEW_POST_CERTIFICATE_PURCHASE_PAGE_VIEW_PROJECTS_BUTTON_CLICKED: "New Post Certificate Purchase Page View Projects Button Clicked",
        NEW_POST_CERTIFICATE_PURCHASE_PAGE_VIEW_PLACEMENT_MODAL_BUTTON_CLICKED: "New Post Certificate Purchase Page View Placement Modal Button Clicked",

        //New Pack Approach
        NEW_PACK_PAGE_LOADED: 'New Pack Page Loaded',
        BEGINNER_PACK_SELECTED: 'Beginner Pack Selected',
        INTERMEDIATE_PACK_SELECTED: 'Intermediate Pack Selected',
        ADVANCE_PACK_SELECTED: 'Advance Pack Selected',
        BEGINNER_PACK_REMOVED: 'Beginner Pack Removed',
        INTERMEDIATE_PACK_REMOVED: 'Intermediate Pack Removed',
        ADVANCE_PACK_REMOVED: 'Advance Pack Removed',
        NEW_PACK_PAGE_SKIP_ADD_ON_BUTTON_CLICKED: 'New Pack Page Skipp Add-On Button Clicked',
        NEW_PACK_PAGE_CONTINUE_WITH_ONE_CERTIFICATE: 'New Page Continue With One Certificate Button Clicked',
        NEW_PACK_PAGE_STICKY_BAR_BUTTON_CLICKED: 'New Page Sticky Bar Button Clicked',
        BEGINNER_PACK_DETAILS_EXPANDED: 'Beginner Pack Details Expanded',
        INTERMEDIATE_PACK_DETAILS_EXPANDED: 'Intermediate Pack Details Expanded',
        ADVANCE_PACK_DETAILS_EXPANDED: 'Advance Pack Details Expanded',
        BEGINNER_PACK_DETAILS_CLOSED: 'Beginner Pack Details Closed',
        INTERMEDIATE_PACK_DETAILS_CLOSED: 'Intermediate Pack Details Closed',
        ADVANCE_PACK_DETAILS_CLOSED: 'Advance Pack Details Closed',
        BEGINNER_PACK_PAYMENT_BUTTON: 'Beginner Pack Payment Button Clicked',
        INTERMEDIATE_PACK_PAYMENT_BUTTON: 'Intermediate Pack Payment Button Clicked',
        ADVANCE_PACK_PAYMENT_BUTTON: 'Advance Pack Payment Button Clicked',

        //Custom Bundle Page
        CUSTOM_BUNDLE_PAGE_LOADED: 'Custom Bundle Page Loaded',
        CUSTOM_BUNDLE_CREATED: 'Custom Bundle Created',
        STICKY_BAR_CREATE_BUNDLE_BUTTON_CLICKED: 'Sticky Bar Create Bundle Button Clicked',

        // Bundle Approach
        NEW_ADDON_FEATURE_BUNDLE_SELECTION_PAGE_LOADED: 'New Add-On Page Bundle Selection Page Loaded',
        NEW_ADDON_FEATURE_BUNDLE_SELECTION_PAGE_SUGGESTED_SKILL_MODAL: 'New Add-On Page Bundle Selection Page View Suggested Skill Modal Opened',
        NEW_ADDON_FEATURE_BUNDLE_SELECTION_STICKY_BAR_REMOVE_ADD_ON: 'New Add-On Feature Bundle Selection Sticky Bar Remove Add-On Clicked',
        
        // Others
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_PAGE_PLACEMENT_MODAL: 'New Add-on Personal and Pro Membership Page Placement Modal Opened',
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_PAGE_COURSE_SYLLABUS_MODAL: 'New Add-on Personal and Pro Membership Page Personalise Course Syllabus Modal Opened',
        NEW_ADDON_FEATURE_PERSONAL_AND_PRO_MEMBERSHIP_PAGE_COURSE_MODAL: 'New Add-on Personal and Pro Membership Page Course Category Modal Opened',

        //New Post Payment Screens
        NEW_GOAL_TAKING_SCREEN_LOADED: "New User Goal Taking Screen Loaded",
        NEW_GOAL_SCREEN_USER_SELECTED_PROFESSIONAL_EXPERIENCE: "New User Goal Screen User Selected Professional Experience",
        NEW_GOAL_SCREEN_USER_SELECTED_IMMEDIATE_CAREER_GOAL: "New User Goal Screen User Selected Immediate Career Goal",
        NEW_GOAL_SCREEN_USER_SUBMITTED_GOAL_DETAILS: "New User Goal Screen User Submitted Goal Details",

        //New Certificate Download
        NEW_CERTIFICATE_DOWNLOAD_PAGE_LOADED: "New Certificate Download Page Loaded",
        NEW_CERTIFICATE_DOWNLOAD_PAGE_DOWNLOAD_BUTTON_CLICKED: "New Certificate Download Page Download Button Clicked",
        NEW_CERTIFICATE_DOWNLOAD_PAGE_SHARE_BUTTON_CLICKED: "New Certificate Download Page LinkedIn Share Button Clicked",
        NEW_CERTIFICATE_DOWNLOAD_PAGE_COPY_LINK_BUTTON_CLICKED: "New Certificate Download Page Copy Link Button Clicked",
        NEW_POST_CERTIFICATE_PURCHASE_PAGE_UNLOCK_REWARD_NOW_BUTTON_CLICKED: "New Post Certificate Purchase Page Unlock Reward Now Button Clicked",
        NEW_CERTIFICATE_DOWNLOAD_PAGE_EXPAND_CERTIFICATE_BUTTON_CLICKED: "New Certificate Download Page Expand Certificate Button Clicked",
        NEW_CERTIFICATE_DOWNLOAD_PAGE_AFTER_EXPANDING_CERTIFICATE_DOWNLOAD_BUTTON_CLICKED: "New Certificate Download Page After Expanding Certificate Download Button Clicked",
        NEW_CERTIFICATE_DOWNLOAD_PAGE_AFTER_EXPANDING_CERTIFICATE_SHARE_BUTTON_CLICKED: "New Certificate Download Page After Expanding Certificate Share Button Clicked",
        NEW_CERTIFICATE_DOWNLOAD_PAGE_GET_TO_MY_GOAL_ANIMATION_BUTTON_CLICKED: "New Certificate Download Page Get To My Goal Animation Button Clicked",

        //Draft Screen
        NEW_POST_CERTIFICATE_PURCHASE_PAGE_DRAFT_SCREEN_PAGE_LOADED: "New Post Certificate Purchase Page Draft Screen Page Loaded",
        DRAFT_SCREEN_PAGE_EDIT_GOAL_BUTTON_CLICKED: "Draft Screen Page Edit Goal Button Clicked",
        DRAFT_SCREEN_PAGE_ADD_MORE_TOPICS_BUTTON_CLICKED: "Draft Screen Page Add More Topics Button Clicked",
        DRAFT_SCREEN_PAGE_ADD_MORE_TOPICS_FOR_CERTIFICATE_BUTTON_CLICKED: "Draft Screen Page Add More Topics For Certificate Button Clicked",
        DRAFT_SCREEN_PAGE_INSIDE_MODAL_ADD_MORE_TOPICS_BUTTON_CLICKED: "Draft Screen Page Inside Modal Add More Topics Button Clicked.",
        DRAFT_SCREEN_REGENERATE_PATH_BUTTON_CLICKED: "Draft Screen Regenerate Path Button Clicked.",
        DRAFT_SCREEN_PAGE_REMOVE_COURSE_BUTTON_CLICKED: "Draft Screen Page Remove Course Button Clicked.",
        DRAFT_SCREEN_PAGE_REMOVE_CERTIFICATE_BUTTON_CLICKED: "Draft Screen Page Remove Certificate Button Clicked.",
        DRAFT_SCREEN_PAGE_REGNERATE_PATH_SUBMITTED: "Draft Screen Regenerate Path Submitted",
        DRAFT_SCREEN_PAGE_CONTINUE_LEARNING_PATH_CLICKED: "Draft Screen Continue Learning Path Button Clicked.",
        DRAFT_SCREEN_PAGE_UNDO_BUTTON_FOR_COURSE_CLICKED: "Draft Screen Undo Button For Course Clicked",
        DRAFT_SCREEN_PAGE_ADD_COURSE_BUTTON_CLICKED: "Draft Screen Add Course Button Clicked",
        DRAFT_SCREEN_PAGE_UNDO_BUTTON_FOR_CERTIFICATE_CLICKED: 'Draft Screen Undo Button For Certificate Clicked',
        DRAFT_SCREEN_PAGE_ADD_BUTTON_FOR_CERTIFICATE_CLICKED: 'Draft Screen Add Button For Certificate Clicked',
        DRAFT_SCREEN_PAGE_UNDO_BUTTON_FOR_ADD_ON_CLICKED: "Draft Screen Undo Button For Add-On Clicked",
        DRAFT_SCREEN_PAGE_ADD_BUTTON_FOR_ADD_ON_CLICKED: 'Draft Screen Add Button For Add-On Clicked',

        REMOVE_SECTION_I_ALREADY_KNOW_THIS_SELECTED: "Remove Section I already Know this Selected",
        REMOVE_SECTION_ITS_IRRELEVENT_BUTTON_CLICKED: "Remove Section It's Irrelevent Selected",
        REMOVE_SECTION_I_WANT_ITS_ADVANCED_VERSION: "Remove Section I Want It's Advanced Version Selected",
        REMOVE_SECTION_I_WANT_ITS_BASIC_VERSION: "Remove Section I Want It's Basic Version Selected",
        REMOVE_SECTION_OTHER_REASON_SELECTED: "Remove Section Other Reason Selected",

        CERTIFICATE_REMOVE_SECTION_I_ALREADY_KNOW_THIS_SELECTED: "Certificate Remove Section I Want To Learn this Selected",
        CERTIFICATE_REMOVE_SECTION_ITS_IRRELEVENT_BUTTON_CLICKED: "Certificate Remove Section It's Irrelevent Selected",
        CERTIFICATE_REMOVE_SECTION_I_WANT_ITS_ADVANCED_VERSION: "Certificate Remove Section I Want It's Advanced Version Selected",
        CERTIFICATE_REMOVE_SECTION_I_WANT_ITS_BASIC_VERSION: "Certificate Remove Section I Want It's Basic Version Selected",
        CERTIFICATE_REMOVE_SECTION_OTHER_REASON_SELECTED: "Certificate Remove Section Other Reason Selected",

        ADD_ON_REMOVE_SECTION_I_NEED_SOMETHING_ELSE_OR_I_NEED_MORE_INFO_SELECTED: "Add On Remove Section I need Something Else Or I Need More Info Reason Selected",
        ADD_ON_REMOVE_SECTION_OTHER_REASONS_SELECTED: "Add On Remove Section Other Reasons Selected",

        FINALISED_BUNDLE_SCREEN_LOADED: "Finalised Suggested Bundle Page loaded",
        FINALISED_BUNDLE_SCREEN_EDIT_USER_GOAL_BUTTON_CLICKED: "Finalised Suggested Bundle Page Edit User Goal Button Clicked",
        FINALISED_BUNDLE_SCREEN_GET_THIS_PATH_BUTTON_CLICKED: "Finalised Suggested Bundle Page Get This Path Button Clicked",
        FINALISED_BUNDLE_SCREEN_WHY_DOES_THIS_WORK_BUTTON_CLICKED: "Finalised Suggested Bundle Page Why Does This Work Button Clicked",
        FINALISED_BUNDLE_SCREEN_EDIT_COURSE_MODAL_BUTTON_CLICKED: "Finalised Suggested Bundle Edit Course Modal Button Clicked",
        FINALISED_BUNDLE_SCREEN_PLACEMENT_SUPPORT_ADDED: "Finalised Suggested Bundle Placement Support Added",
        FINALISED_BUNDLE_SCREEN_MENTORSHIP_BUTTON_ADDED: "Finalised Suggested Bundle Mentorship Added",
        FINALISED_BUNDLE_SCREEN_PRO_MEMBERSHIP_BUTTON_ADDED: "Finalised Suggested Bundle Pro Membership Added",
        FINALISED_BUNDLE_SCREEN_PLACEMENT_SUPPORT_MODAL_OPENED: "Finalised Suggested bundle Placement Modal opened",
        FINALISED_BUNDLE_SCREEN_MENTORSHIP_MODAL_OPENED: "Finalised Suggested bundle Mentorship Modal opened",
        FINALISED_BUNDLE_SCREEN_PRO_MEMBERSHIP_MODAL_OPENED: "Finalised Suggested bundle Pro Membership Modal opened",

        CART_PAGE_LOADED: "Cart Page Loaded",
        CART_PAGE_CHECK_SCHOLARSHIP_ELIGIBILITY_BUTTON_CLICKED: "Cart Page Check Scholarship Eligibility Button Clicked",
        CART_PAGE_CHECKOUT_BUTTON_CLICKED: "Cart Page Proceed To Checkout Button Clicked.",
        CART_PAGE_ADDING_ITEMS_TO_CART_BUTTON_CLICKED: "Cart Page Adding Items To Cart Button Clicked",
        CART_PAGE_REMOVING_ITEMS_FROM_CART_BUTTON_CLICKED: "Cart Page Removing Items From Cart Button Clicked",
        CART_PAGE_ADD_ONS_ADDED_FROM_CAROUSEL: "Cart Page Add-Ons Added From Carousel",
        CART_PAGE_ADD_ONS_ADDED_TO_CART_FROM_MODALS: "Cart Page Add-Ons Added To Cart From Modals",
        CART_PAGE_ADD_ONS_REMOVED_FROM_CART_FROM_MODALS: "Cart Page Add-Ons Removed From Cart From Modals",
        CART_PAGE_CERTIFICATES_AND_COURSES_ADDING_AND_REMOVING_MODAL_BUTTON_CLICKED: 'Cart Page Certificates And Courses Adding and Removing Modal Button Clicked',
        CART_PAGE_ADDING_REMOVING_COURSE_OR_CERTIFICATES_MODAL_OPENED: 'Cart Page Adding/Removing Courses Or Certificates Modal Opened',
        CART_PAGE_ADDING_REMOVING_COURSE_OR_CERTIFICATES_MODAL_COURSE_ADDED: 'Cart Page Adding/Removing Courses Or Certificates Course Added',
        CART_PAGE_ADDING_REMOVING_COURSE_OR_CERTIFICATES_MODAL_COURSE_REMOVE_CLICKED: 'Cart Page Adding/Removing Courses Or Certificates Course Remove Clicked',
        CART_PAGE_ADDING_REMOVING_COURSE_OR_CERTIFICATES_MODAL_EXPLORE_MORE_COURSE_CLICKED: 'Cart Page Adding/Removing Courses Or Certificates Explore More Courses Clicked',
        CART_PAGE_ADDING_REMOVING_COURSE_OR_CERTIFICATES_MODAL_CERTIFICATE_ADDED: 'Cart Page Adding/Removing Courses Or Certificates Certificate Added',
        CART_PAGE_ADDING_REMOVING_COURSE_OR_CERTIFICATES_MODAL_CERTIFICATE_REMOVE_CLICKED: 'Cart Page Adding/Removing Courses Or Certificates Certificate Remove Clicked',
        CART_PAGE_ADDING_REMOVING_COURSE_OR_CERTIFICATES_MODAL_EXPLORE_MORE_CERTIFICATES_CLICKED: 'Cart Page Adding/Removing Courses Or Certificates Explore More Certificates Clicked',

        CART_PAGE_ADDING_REMOVING_ADDONS_PLACEMENT_SERVICE_MODAL_OPENED: 'Cart Page Add-On Cart Modal Opened',
        CART_PAGE_ADDING_REMOVING_ADDONS_PLACEMENT_SERVICE_MODAL_ADDON_ADDED: 'Cart Page Add-On Cart Modal Add-On Added',
        CART_PAGE_ADDING_REMOVING_ADDONS_PLACEMENT_SERVICE_MODAL_ADDON_REMOVED: 'Cart Page Add-On Cart Modal Add On Removed',
        CART_PAGE_ADDING_REMOVING_ADDONS_PLACEMENT_SERVICE_MODAL_PLACEMENT_SERVICE_ADDED: 'Cart Page Add-On Cart Modal Placement Services Added',
        CART_PAGE_ADDING_REMOVING_ADDONS_PLACEMENT_SERVICE_MODAL_PLACEMENT_SERVICE_REMOVED: 'Cart Page Add-On Cart Modal Placement Services Removed',

        HOW_DOES_THIS_WORK_PAGE_LOADED: "How Does This Work Page Loaded",
        HOW_DOES_THIS_WORK_PAGE_GET_THIS_CAREER_PATH_BUTTON_CLICKED: "How Does This Work Page Get This Career Path Button Clicked",
        SECOND_TRANSACTION_THANK_YOU_PAGE_LOADED: "Second Transaction Thank You Page Loaded",

        SUGGESTED_BUNDLE_LOADING_PAGE_LOADED: "Path Generation Loading Page Loaded",

        POST_TRANSACTION_PLACEMENT_SUPPORT_BUTTON_CLICKED: 'Post Certificate Purchase Only Placement Support Purchase Button Clicked',
        SALARY_CALCULATOR_CALCULATE_BUTTON_CLICKED: "Salary Calculator Calculate Button Clicked",
        HOW_DOES_THIS_WORK_BUTTON_CLICKED: 'How Does This Work Button Clicked',
        MODIFY_MY_CART_BUTTON_CLICKED: 'Modify My Cart Button Clicked',

        NORMAL_PAYMENT_CANCEL_MODAL_OPENED: 'Normal Payment Cancel Modal Opened',
        TEN_MINUTES_TIMER_MODAL_OPENED: 'Ten Minutes Timer Modal Opened',
        FINAL_TIME_UP_MODAL_OPENED: 'Final Time Up Modal Opened',

        COURSE_CERTIFICATE_MODAL_OPENED: 'Course Certificate Modal Opened',
        CERTIFICATE_MODAL_OPENED: 'Certificate Modal Opened',

        FINAL_TIME_UP_MODAL_GO_BACK_TO_CART_CLICKED: "Final Time Up Modal Go Back To Cart Clicked",

        UNPAID_USERS_ANALYSIS_AND_ANSWERS_PAGE_LOADED: "Unpaid Users Analysis And Answers Page Loaded",
        UNPAID_USERS_ANALYSIS_AND_ANSWERS_PAGE_CLAIM_MY_REWARD_NOW_BUTTON_CLICKED: "Unpaid Users Analysis And Answers Page Claim My Reward Now Button Clicked",
        UNPAID_USERS_ANALYSIS_AND_ANSWERS_PAGE_MODAL_OPENED: "Unpaid Users Analysis And Answers Page Details Modal Opened",
        UNPAID_USERS_ANALYSIS_AND_ANSWERS_PAGE_VIEW_DETAILS_BUTTON_CLICKED: "Unpaid Users Analysis And Answers Page View Details Button Clicked For Opening Modals",
        UNPAID_USERS_ANALYSIS_AND_ANSWERS_PAGE_IN_MODAL_VIEW_MORE_CLICKED: "Unpaid Users Analysis And Answers Page View More Button Inside Modal Clicked",

        ADDITIONAL_QUESTIONS_MODAL_OPENED: 'New Additional Questions Modal Opened',
        ADDITIONAL_QUESTIONS_MODAL_SAVE_AND_CONTINUE_CLICKED: 'New Additional Questions Modal Save And Continue Clicked',
        ADDITIONAL_QUESTIONS_MODAL_USERS_PRIORITY_SELECTED: "New Additional Questions Modal User's Priority Selected",
        ADDITIONAL_QUESTIONS_MODAL_USERS_INTERESTED_INDUSTRY_SELECTED: "New Additional Questions Modal User's Interested Industry Selected",

        BACK_BUTTON_CLICK_MODAL_OPENED: 'Back Button Click Modal Opened',
        BACK_BUTTON_CLICK_GET_ANOTHER_CERTIFICATE_BUTTON_CLICKED: 'Back Button Click Modal Get Another Certificate Button Clicked',
        BACK_BUTTON_CLICK_DOWNLOAD_CERTIFICATE_BUTTON_CLICKED: 'Back Button Click Modal Download Certificate Button Clicked',
        BACK_BUTTON_CLICK_UNLOCK_REWARD_BUTTON_CLICKED: 'Back Button Click Modal Unlock Reward Button Clicked',
        BACK_BUTTON_CLICK_CHANGE_USER_GOAL_BUTTON_CLICKED: 'Back Button Click Modal Change User Goal Button Clicked',

        //New Add-ons modals
        AI_TOOLS_LEARNING_MODAL_LOADED: 'AI Tools Learning Modal Opened',
        AI_TOOLS_LEARNING_MODAL_STICKY_BAR_ADD_NOW_CLICKED: 'AI Tools Learning Modal Sticky Bar Add Now Clicked',
        CV_REVAMP_MODAL_LOADED: 'CV Revamp Modal Opened',
        CV_REVAMP_MODAL_STICKY_BAR_ADD_NOW_CLICKED: 'CV Revamp Modal Sticky Bar Add Now Clicked',
        NETWORK_WITH_HIRING_MANAGER_MODAL_LOADED: 'Network With Hiring Manager Modal Opened',
        NETWORK_WITH_HIRING_MANAGER_MODAL_STICKY_BAR_ADD_NOW_CLICKED: 'Network With Hiring Manager Modal Sticky Bar Add Now Clicked',
        UNLIMITED_ACCESS_TO_COURSE_MODAL_LOADED: 'Unlimited Access To Course Modal Opened',
        UNLIMITED_ACCESS_TO_COURSE_MODAL_STICKY_BAR_ADD_NOW_CLICKED: 'Unlimited Access To Course Modal Sticky Bar Add Now Clicked',
        SOFT_SKILL_IMPROVEMENT_MODAL_OPENED: 'Soft Skill Improvement Modal Opened',
        SOFT_SKILL_IMPROVEMENT_MODAL_STICKY_BAR_ADD_NOW_CLICKED: 'Soft Skill Improvement Modal Sticky Bar Add Now Clicked',
        LEADERSHIP_IMPROVEMENT_MODAL_OPENED: 'Leadership Improvement Modal Opened',
        LEADERSHIP_IMPROVEMENT_MODAL_STICKY_BAR_ADD_NOW_CLICKED: 'Leadership Improvement Modal Sticky Bar Add Now Clicked',
        PROJECTS_MODAL_OPENED: 'Projects Add-On Modal Opened',
        PROJECTS_MODAL_STICKY_BAR_ADD_NOW_CLICKED: 'Projects Add-On Modal Sticky Bar Add Now Clicked',
        INTERVIEW_GUARANTEE_MODAL_OPENED: 'Interview Guarantee Add-On Modal Opened',
        INTERVIEW_GUARANTEE_MODAL_STICKY_BAR_ADD_NOW_CLICKED: 'Interview Guarantee Add-On Modal Sticky Bar Add Now Clicked',
        PLACEMENT_SUPPORT_MODAL_OPENED: 'Placement Support Add-on Modal Opened',
        PLACEMENT_SUPPORT_MODAL_STICKY_BAR_ADD_NOW_CLICKED: 'Placement Support Add-on Modal Sticky Bar Add Now Clicked',

        //Referral Page
        REFERRAL_PAGE: 'Referral Page loaded',
        REFERRAL_PAGE_BUTTON_CLICKED: 'Referral Page Get Certified Button Was Clicked',
        REFERRAL_PAGE_PIL_CLICKED: 'Referral Page Pil Was Clicked',
        REFERRAL_PAGE_EXPLORE_BUTTON : 'Referral Page Explore Button Was Clicked',

    }
}

export const coursesList = [
  'Programming', 'Digital Marketing', 'Data Science & Analytics', 'Design, Art & Tools', 'Finance & Investments',  'UI/UX', 'Bussiness & Management', 'Language', 'Cloud Computing', 'Operating System and Databases', 'Hardware and Network Security', 'Film Making', 'Development Tools and No Code', 'Web 3', 'Music'
]

export const qualityLevel = [[0, 10, 10], [10, 20, 30], [20, 30, 40], [30, 40, 50]]

export const qualityLevel2 = [1, 2, 3]

export const courses = [
    {
        id: 1,
        name: 'Programming',
        course_slug: 'programming-courses',
        image: "https://assets.learntube.ai/files/AI_Syllabus_generator/Coding_1.svg?updatedAt=1688364023282",
        mskill_count: 749
    },
    {
        id: 2,
        name: 'Digital Marketing',
        course_slug: 'digital-marketing-courses',
        image: "https://assets.learntube.ai/files/AI_Syllabus_generator/Digital_Marketing_25.svg?updatedAt=1688364137460",
        mskill_count: 224
    },
    {
        id: 3,
        name: 'Data Science & Analytics',
        course_slug: 'data-science-analytics-courses',
        image: "https://assets.learntube.ai/files/AI_Syllabus_generator/Data_Science_1.svg?updatedAt=1688364191116",
        mskill_count: 305
    },
    {
        id: 4,
        name: 'Design, Art & Tools',
        course_slug: 'design-art-tools-courses',
        image: "https://assets.learntube.ai/files/AI_Syllabus_generator/Pencil_with_Ruler.svg?updatedAt=1688364239209",
        mskill_count: 412
    },
    {
        id: 5,
        name: 'Finance & Investments',
        course_slug: 'finance-investments-courses',
        image: "https://assets.learntube.ai/files/AI_Syllabus_generator/finance_1.svg?updatedAt=1688364280208",
        mskill_count: 153
    },
    {
        id: 6,
        name: 'UI/UX',
        course_slug: 'uiux-courses',
        image: "https://assets.learntube.ai/files/AI_Syllabus_generator/UI_UX_Design_1.svg?updatedAt=1688364322372",
        mskill_count: 82
    },
    {
        id: 7,
        name: 'Business & Management',
        course_slug: 'business-management-courses',
        image: "https://assets.learntube.ai/files/LinkdinUsers/Business.svg?updatedAt=1701415944525",
        mskill_count: 244
    },
    {
        id: 8,
        name: 'Language',
        course_slug: 'language-courses',
        image: "https://assets.learntube.ai/files/AI_Syllabus_generator/Language_Translate_1.svg?updatedAt=1688364410223",
        mskill_count: 45
    },
    {
        id: 9,
        name: 'Cloud Computing',
        course_slug: 'cloud-computing-courses',
        image: "https://assets.learntube.ai/files/AI_Syllabus_generator/Cloud_Computing_1.svg?updatedAt=1688364460111",
        mskill_count: 123
    },
    {
        id: 10,
        name: 'Operating System and Databases',
        course_slug: 'operating-system-and-databases-courses',
        image: "https://assets.learntube.ai/files/LinkdinUsers/Database.svg?updatedAt=1701415944394",
        mskill_count: 114
    },
    {
        id: 11,
        name: 'Hardware and Network Security',
        course_slug: 'hardware-and-network-security-courses',
        image: "https://assets.learntube.ai/files/AI_Syllabus_generator/Hardware_1.svg?updatedAt=1688364553384",
        mskill_count: 99
    },
    {
        id: 12,
        name: 'Film Making',
        course_slug: 'film-making-courses',
        image: "https://assets.learntube.ai/files/AI_Syllabus_generator/film_making_1.svg?updatedAt=1688364620738",
        mskill_count: 76
    },
    {
        id: 13,
        name: 'Development Tools and No Code',
        course_slug: 'development-tools-and-no-code-courses',
        image: "https://assets.learntube.ai/files/LinkdinUsers/No%20Code%20Development%20Platform.svg?updatedAt=1701416015216",
        mskill_count: 177
    },
    {
        id: 14,
        name: 'Web 3',
        course_slug: 'web-3-courses',
        image: "https://assets.learntube.ai/files/LinkdinUsers/NFT%20technology.svg?updatedAt=1701416015062",
        mskill_count: 14
    },
    {
        id: 15,
        name: 'Music',
        course_slug: 'music-courses',
        image: "https://assets.learntube.ai/files/AI_Syllabus_generator/Music_Sign_1.svg?updatedAt=1688364728768",
        mskill_count: 82
    }
]

export const faqPersonaliseAddon = [
    {
        id: 0,
        question: 'How is this course personalised for me?',
        answer: 'Our domain experts (with 30+ years of combined experience) along with our AI engine analyse your skills, goals & answers to identify what you need to learn. We then build a detailed syllabus accordingly for you. And the personalisation doesn’t end here. Once you start learning, your course will be further personalised to you as per your needs.'

    },
    {
        id: 1,
        question: 'What all courses do you offer?',
        answer: 'Our personalisation technology works across domains, from career skills like Java to even hobbies like baking. Most users use us to learn work related skills in the domain of Programming, Marketing, Data Science, Design, Business & lots of different tools.'

    },
    {
        id: 2,
        question: 'Does the course really help in jobs?',
        answer: 'Yess! If you learn properly, do your assessments & projects and then showcase your skills in your CV & portfolio to employers it will make a huge difference in your job applications & even your own confidence. Our learners work at top companies from Amazon to TCS and many have gone on to become freelancers & entrepreneurs.'

    },
    {
        id: 3,
        question: 'Is there any refund policy?',
        answer: 'There sure is. While completing your course, if you find a cheaper, more personalised course than ours you will get your money back! Just reach out to us within 7 days of purchase with the details on hello@careerninja.in'

    }
]

export const newFaqPersonaliseAddon = [
    {
        id: 0,
        question: 'How valuable is this certificate in the job market?',
        answer: 'This certificate is your key to standing out—recognised by 1100+ top companies like Google, Flipkart, LinkedIn, Swiggy, etc., it elevates your CV value by 42% and increases your chances of landing interviews by 53%.'
    },
    {
        id: 1,
        question: 'How can I leverage this certificate for job opportunities?',
        answer: 'Certificates validate your skills. Sharing your certification on LinkedIn and adding it to your resume makes your profile stand out, showing that you’re qualified for the job. This makes you a more appealing candidate compared to others without certification. Recruiters can quickly verify your certificate by scanning the QR code, boosting their confidence in your qualifications.'
    },
    {
        id: 2,
        question: 'How will I receive the additional certificates that I add to my bundle?',
        answer: 'After completing your payment, you will receive a link via WhatsApp and Email to select your subjects and take the corresponding quizzes. Upon passing the quizzes, you can download the certificates immediately, and they will also be sent to your registered Email and WhatsApp.'
    },
    {
        id: 3,
        question: 'How will I access 1240+ certified courses that I add to my bundle?',
        answer: 'After completing your payment, you will receive a link via WhatsApp and Email through which you can access 1240+ courses on our platform. You will also receive a certificate of completion for each course you finish.'
    },
    {
        id: 4,
        question: 'How will I access the personalised course that I add to my bundle?',
        answer: 'After completing your payment, you will receive a link via WhatsApp and Email to access your personalized course, specifically designed based on your quiz results. This course will focus on the essential skills you need to develop, and upon completion, you will earn a certificate of completion.'
    },
    {
        id: 5,
        question: 'What types of courses do you offer?',
        answer: 'We offer a diverse range of courses tailored to your interests and career goals. Our personalization technology spans various domains, including essential career skills in Programming, Marketing, Data Science, and Design, as well as enjoyable hobbies like Baking, Piano, Photography, and more. The courses are designed to empower you with the exact knowledge and skills you need to succeed!'
    },
    {
        id: 6,
        question: 'What impact will the courses have on my career?',
        answer: 'Courses make you 100% job-ready by focusing on essential skills while eliminating unnecessary content, saving you time and energy. Course completion certificates position you as a knowledgeable and skilled candidate, improving your CV by 60% and doubling your chances of being directly contacted by recruiters. This increases your likelihood of working at top brands to 92% and boosts your salary potential by 56%.'
    },
    {
        id: 7,
        question: 'How are the courses personalised for me?',
        answer: 'Our courses are tailored specifically for you by combining insights from our domain experts—who bring over 30 years of combined experience—with our advanced AI engine. This powerful duo analyzes your skills, goals, and responses to pinpoint exactly what you need to learn and then creates a detailed syllabus that aligns with your objectives. The personalization continues as you progress through the course, adapting to your learning behavior and evolving needs.'
    },
    {
        id: 8,
        question: 'What features tailor the course to my needs and help me achieve job readiness quickly?',
        answer: 'Our courses offer self-paced pre-recorded lectures and evaluation tests with live feedback, ensuring flexible learning and progress tracking. You’ll have 24/7 live doubt-solving support, work on industry-recognised projects, and gain lifetime access to course materials. With short, focused courses tailored to your skill set, you can easily complete them within a week and earn a certificate of completion.'
    },
    {
        id: 9,
        question: 'Will your courses really help me land interviews or get a job?',
        answer: "Yes, our courses can indeed help you land interviews and secure a job, but only if you sincerely engage with the coursework and complete the assessments and projects on time. Effectively showcasing the skills you've gained, the projects you've completed, and your certificate in your CV and network will significantly boost your job prospects. Many of our learners have successfully secured positions at top companies like Amazon and TCS, and others have thrived as freelancers and entrepreneurs."
    },
    {
        id: 10,
        question: 'Is there any refund policy?',
        answer: "Yes, we do have a refund policy! If you find a cheaper, more personalized course while you're completing our course, just email us at hello@careerninja.in within 7 days of your purchase along with the details, and we'll process your refund."
    },
    {
        id: 11,
        question: 'What are the eligibility criteria for placement?',
        answer: "To be eligible for placement, you need to opt in for the placement service, attend all 4 live online placement training sessions, and ensure to complete the tasks assigned during these sessions."
    },
    {
        id: 12,
        question: 'What happens in the placement training sessions?',
        answer: "These will be live online instructor-led sessions where you'll learn how to revamp your CV and optimize your LinkedIn profile to attract recruiters, along with receiving interview training that includes 5 practice interviews with live feedback to enhance your performance. You'll gain valuable insights into everything that increase your chances of landing your ideal job through the 4 live training sessions. Schedule for these sessions will be shared post payment."
    },
    {
        id: 13,
        question: 'What comes next after I complete the placement training sessions?',
        answer: "Once you’ve finished all your purchased courses, attended all 4 live online placement training sessions and completed all the assigned tasks, we will send your CV to our network of 1100+ hiring partners. Additionally, you can apply for external job opportunities using the strategies learned during the training. With the mock interviews and comprehensive preparation you’ve received, you’ll be well-equipped to succeed in real interviews."
    },
]

export const popularSkills = [
    {
        id: 1,
        skill_name: "JavaScript Basic (English)",
        skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/infrastructure-94301.png?updatedAt=1688727083984"
    },
    {
        id: 2,
        skill_name: "JavaScript Advanced (English)",
        skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/device-94309.png?updatedAt=1688727083691"
    },
    {
        id: 3,
        skill_name: "Java Basic (English)",
        skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/router-94311.png?updatedAt=1688727084011",
    },
    {
        id: 4,
        skill_name: "Java Advanced (English)",
        skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/mobile-94304.png?updatedAt=1688727085080"
    },
    {
        id: 276,
        skill_name: "C Programming (English)",
        skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/communication-94300.png?updatedAt=1688727083586"
    }
]

export const professionalExperiences = [
    {
        name: "Student/Recent Grad.",
        image: "https://assets.learntube.ai/files/post-payment-updates/graduate.svg?updatedAt=1726129364165",
        width: 27.6,
        height: 28
    }, 
    {
        name: "1-5 Yrs Work Exp.",
        image: "https://assets.learntube.ai/files/post-payment-updates/1-5experience.svg?updatedAt=1726129494355",
        width: 26.9,
        height: 28
    }, 
    {
        name: "5-10 Yrs Work Exp.",
        image: "https://assets.learntube.ai/files/post-payment-updates/Group%2022055.svg?updatedAt=1727157941985",
        width: 28,
        height: 28
    }, 
    {
        name: "10+ Yrs Work Exp.",
        image: "https://assets.learntube.ai/files/post-payment-updates/Group%2022057.svg?updatedAt=1727158029128",
        width: 27,
        height: 29
    }
]

export const studentCareerGoal = [
    {
        name: "Get A Good Job",
        image: "https://assets.learntube.ai/files/post-payment-updates/googJob.svg?updatedAt=1726133556799",
        width: 31.62,
        height: 28
    }, 
    {
        name: "Learn New Skills",
        image: "https://assets.learntube.ai/files/post-payment-updates/learnNewSkill.svg?updatedAt=1726133657940",
        width: 28,
        height: 28
    }, 
    {
        name: "Improve CV",
        image: "https://assets.learntube.ai/files/post-payment-updates/Vector%20(2).svg?updatedAt=1727160790319",
        width: 24,
        height: 28
    },
]

export const professionalCareerGoal = [
    {
        name: "Get A Promotion",
        image: "https://assets.learntube.ai/files/post-payment-updates/getPromotion.svg?updatedAt=1726135113037",
        width: 22.7,
        height: 28
    },
    {
        name: "Get A Good Job",
        image: "https://assets.learntube.ai/files/post-payment-updates/googJob.svg?updatedAt=1726133556799",
        width: 31.6,
        height: 28
    },
    {
        name: "Change Career Path",
        image: "https://assets.learntube.ai/files/post-payment-updates/careerPath.svg?updatedAt=1726134778987",
        width: 29.1,
        height: 28
    }, 
    {
        name: "Learn New Skills",
        image: "https://assets.learntube.ai/files/post-payment-updates/learnNewSkill.svg?updatedAt=1726133657940",
        width: 28,
        height: 28
    }, 
]

export const newAdditionalQuestionOne = [
    {
        name: "Job Search",
        image: "https://assets.learntube.ai/files/personalise-app-lesson/Vector%20(6).svg?updatedAt=1738776330946",
        width: 31.6,
        height: 28
    },
    {
        name: "Skill Building",
        image: "https://assets.learntube.ai/files/personalise-app-lesson/Vector%20(7).svg?updatedAt=1738776437260",
        width: 28,
        height: 28
    },
    {
        name: "Learning + Job Search",
        image: "https://assets.learntube.ai/files/personalise-app-lesson/Vector%20(5).svg?updatedAt=1738776163115",
        width: 27.5,
        height: 28
    },
]

export const newAdditionalQuestionTwo = [
    {
        name: "Skill Building",
        image: "https://assets.learntube.ai/files/personalise-app-lesson/Vector%20(7).svg?updatedAt=1738776437260",
        width: 28,
        height: 28
    },
    {
        name: "Learning + Job Search",
        image: "https://assets.learntube.ai/files/personalise-app-lesson/Vector%20(5).svg?updatedAt=1738776163115",
        width: 27.5,
        height: 28
    },
]

export const newAdditionalQuestionThree = [
    {
        name: "Job Search",
        image: "https://assets.learntube.ai/files/personalise-app-lesson/Vector%20(6).svg?updatedAt=1738776330946",
        width: 31.6,
        height: 28
    },
    {
        name: "Learning + Job Search",
        image: "https://assets.learntube.ai/files/personalise-app-lesson/Vector%20(5).svg?updatedAt=1738776163115",
        width: 27.5,
        height: 28
    },
]

export const newDomainList = [
    'Information Technology (IT) and Software Services',
    'Banking, Financial Services, and Insurance (BFSI)',
    'Manufacturing and Engineering',
    'Healthcare and Pharmaceuticals',
    'Retail and E-commerce',
    'Other'
]

export const careerGoals = [
    "Get A Good Job", "Switch Career Path", "Get A Promotion", "Learn New Skills"
]

export const popularRoles = [
    "Software Developer", "Data Scientist", "Project Manager", "Product Manager", "Marketing Manager", "Financial Analyst", "UX/UI Designer", "Cybersecurity Specialist"
]

export const leadershipAddOnRemoveReasons = [
    'I don’t need this',
    'I need more info.'
]

export const aiCourseRemoveReasons = [
    'I know this', 'I need something else', 'It’s irrelevant'
]

export const projectsRemoveReasons = [
    'I don’t need this', 'I need more info.', 'I need something else', 'It’s irrelevant'
]

export const companyAccessRemoveReasons = [
    'I already know this',
    'I don’t need this'
]

export const placementSectionRemoveReasons = [
    'I don’t need this',
    'I need something else'
]

export const iconList = [
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/router-94311.png?updatedAt=1688727084011",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/mobile-94304.png?updatedAt=1688727085080",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/infrastructure-94301.png?updatedAt=1688727083984",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/configure-94308.png?updatedAt=1688727083711",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/chip-94294.png?updatedAt=1688727079774",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/atom-101491.png?updatedAt=1688726932512",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/cogwheel-94296.png?updatedAt=1688727079230",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/attract-101478.png?updatedAt=1688726931998",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/atom-101488.png?updatedAt=1688726932206",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/d-101398.png?updatedAt=1688727215016",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/blackboard-101481.png?updatedAt=1688726932551",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101400.png?updatedAt=1688727204601",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/access-101411.png?updatedAt=1688727204514",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101400.png?updatedAt=1688727204601",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/app-101402.png?updatedAt=1688727203802",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101405.png?updatedAt=1688727204140",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101409.png?updatedAt=1688727203891",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/balance-94453.png?updatedAt=1688727390531",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/strip-94370.png?updatedAt=1688727498391",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/diagram-94367.png?updatedAt=1688727498311",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/art-94360.png?updatedAt=1688727493725",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/backup-94310.png?updatedAt=1688726544823",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/explore-101477.png?updatedAt=1688726937840",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/bulb-101472.png?updatedAt=1688726936304",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/broadcast-101487.png?updatedAt=1688726932946",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/infrastructure-94301.png?updatedAt=1688727083984",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/router-94311.png?updatedAt=1688727084011",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/mobile-94304.png?updatedAt=1688727085080",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/infrastructure-94301.png?updatedAt=1688727083984",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/configure-94308.png?updatedAt=1688727083711",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/chip-94294.png?updatedAt=1688727079774",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/atom-101491.png?updatedAt=1688726932512",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/cogwheel-94296.png?updatedAt=1688727079230",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/attract-101478.png?updatedAt=1688726931998",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/atom-101488.png?updatedAt=1688726932206",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/d-101398.png?updatedAt=1688727215016",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/blackboard-101481.png?updatedAt=1688726932551",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101400.png?updatedAt=1688727204601",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/access-101411.png?updatedAt=1688727204514",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101400.png?updatedAt=1688727204601",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/app-101402.png?updatedAt=1688727203802",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101405.png?updatedAt=1688727204140",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101409.png?updatedAt=1688727203891",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/balance-94453.png?updatedAt=1688727390531",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/strip-94370.png?updatedAt=1688727498391",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/diagram-94367.png?updatedAt=1688727498311",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/art-94360.png?updatedAt=1688727493725",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/backup-94310.png?updatedAt=1688726544823",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/explore-101477.png?updatedAt=1688726937840",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/bulb-101472.png?updatedAt=1688726936304",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/broadcast-101487.png?updatedAt=1688726932946",
    "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/infrastructure-94301.png?updatedAt=1688727083984"
]

export const companyIcons = [
    'https://assets.learntube.ai/files/dataschool/image%20340.png?updatedAt=1707912130704',
    'https://assets.learntube.ai/files/dataschool/image%20343.png?updatedAt=1707912130707',
    'https://assets.learntube.ai/files/dataschool/image%20344.png?updatedAt=1707912130695',
    'https://assets.learntube.ai/files/dataschool/image%20345.png?updatedAt=1707912130762',
    'https://assets.learntube.ai/files/dataschool/Paytm%20-%20jpeg%200.png?updatedAt=1707912130698'
]

export const ourLearnersLove = [
    {
        id: 1,
        name: "DEVENDRA KUMAR",
        skill: 'Data Analyst Personalised Course',
        image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/baXEcb1XPmnis57MeW-H9qGFd4o/4lN0Kw../fake48838.jpg",
        content: '"Credit to LearnTube, I transformed from an engineer to a part-time data analyst earning 80-90k and leading an internationally recognised Auto Pneumatic System project"'
    },
    {
        id: 2,
        name: "Nilambar Giri",
        image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/ph839iZMfBhV7-IC3r7D2MvBcms/Meff0A../236490.jpg",
        content: '"LearnTube empowered my dream startup. I mastered JavaScript and Product Management and raised funding for SavePae. You turned my aspirations into reality as a middle-class dreamer."',
        skill: "Javascript Personalised Course"
    },
    {
        id: 3,
        name: "Bhavmeet Kaur",
        image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/iW3EiVDEHFOILH543H-zv902nVc/MYUOSQ../438935.jpg",
        content: '"Thanks to LearnTube, I upgraded my SEO skills at Ablysoft. Your transformative power helped me secure a Management Trainee position at Reliance Retail with a 24LPA salary"',
        skill: "SEO Personalised Course"
    },
    {
        id: 4,
        name: "Kishore V",
        image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/uBeomyjcMRfMFuyvqOshR-fUXvo/oDc3QQ../fake602695.jpeg",
        content: '"LearnTube’s Figma Prototyping course unlocked my creative potential and helped me build an Instagram clone. I’ve found my passion and am ready to scale my career in the design world!"',
        skill: "Figma Design Personalised Course"
    },
    {
        id: 5,
        name: "Prithish Bhardwaj",
        image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/wLAxWaaWeNfvTMQASPDLm9UJyvw/27dy6A../14017.jpg",
        content: '"Discovering LearnTube in my final MBBS year was a game-changer. Despite battling cancer, I still managed to achieve financial success with a 10 LPA salary. All thanks to LearnTube’s learning."',
        skill: "System Design Personalised Course"
    },
]

export const skills = [
        [
            {
                id: 273,
                skill_name: "Java Basic (English)",
                skill_slug: "java-basic-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/router-94311.png?updatedAt=1688727084011",
            },
            {
                id: 265,
                skill_name: "Java Advanced (English)",
                skill_slug: "java-advanced-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/mobile-94304.png?updatedAt=1688727085080"
            },
            {
                id: 275,
                skill_name: "HTML (English)",
                skill_slug: "html-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/international-94303.png?updatedAt=1688727086351"
            },
            {
                id: 283,
                skill_name: "JavaScript Basic (English)",
                skill_slug: "javascript-basic-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/infrastructure-94301.png?updatedAt=1688727083984"
            },
            {
                id: 296,
                skill_name: "JavaScript Advanced (English)",
                skill_slug: "javascript-advanced-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/device-94309.png?updatedAt=1688727083691"
            },
            {
                id: 276,
                skill_name: "C Programming (English)",
                skill_slug: "c-programming-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/communication-94300.png?updatedAt=1688727083586"
            },
            {
                id: 282,
                skill_name: "C++ Programming (English)",
                skill_slug: "cplusplus-programming-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/connection-94295.png?updatedAt=1688727083576"
            },
            {
                id: 314,
                skill_name: "C# Basic (English)",
                skill_slug: "c-basic-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/configure-94308.png?updatedAt=1688727083711"
            },
            {
                id: 89,
                skill_name: "C# Intermediate",
                skill_slug: "c-intermediate-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/folder-94302.png?updatedAt=1688727083658"
            },
            {
                id: 90,
                skill_name: "C# Advanced",
                skill_slug: "c-advanced-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/communication-94297.png?updatedAt=1688727083019"
            },
            {
                id: 308,
                skill_name: "Django (Basic)",
                skill_slug: "django-basic-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/cloud-94305.png?updatedAt=1688727079684"
            },
            {
                id: 100,
                skill_name: "Django Advanced",
                skill_slug: "django-advanced-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/cloud-94307.png?updatedAt=1688727079751"
            },
            {
                id: 323,
                skill_name: "PHP (English)",
                skill_slug: "php-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/chip-94294.png?updatedAt=1688727079774"
            },
            {
                id: 127,
                skill_name: "Angular JS",
                skill_slug: "angular-js-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/access-94298.png?updatedAt=1688727079504"
            },
            {
                id: 128,
                skill_name: "jQuery",
                skill_slug: "jquery-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/access-94292.png?updatedAt=1688727079556"
            },
            {
                id: 134,
                skill_name: "Bootstrap",
                skill_slug: "bootstrap-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/cloud-94306.png?updatedAt=1688727079443"
            },
            {
                id: 153,
                skill_name: "Laravel",
                skill_slug: "laravel-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/cloud-94293.png?updatedAt=1688727079369"
            },
            {
                id: 266,
                skill_name: "Android App Development for Beginners",
                skill_slug: "android-app-development-for-beginners-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/blueprint-94357.png?updatedAt=1688727494104"
            },
            {
                id: 197,
                skill_name: "Flask",
                skill_slug: "flask-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/backup-94310.png?updatedAt=1688727079205"
            },
            {
                id: 204,
                skill_name: "TensorFlow",
                skill_slug: "tensorflow-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/cogwheel-94296.png?updatedAt=1688727079230"
              
            },
            {
                id: 278,
                skill_name: "Data Structure and Algorithm",
                skill_slug: "data-structure-and-algorithm-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/chart-94299.png?updatedAt=1688727078984"
            },
            {
                id: 220,
                skill_name: "Flutter",
                skill_slug: "flutter-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/atom-101491.png?updatedAt=1688726932512"
            },
            {
                id: 221,
                skill_name: "Kotlin",
                skill_slug: "kotlin-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/biology-101476.png?updatedAt=1688726932836"
            },
            {
                id: 224,
                skill_name: "CodeIgniter",
                skill_slug: "codeigniter-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/atom-101488.png?updatedAt=1688726932206"
            },
            {
                id: 230,
                skill_name: "Object Oriented Analysis and Design",
                skill_slug: "object-oriented-analysis-and-design-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/biohazard-101494.png?updatedAt=1688726932343"
            },
            {
                id: 231,
                skill_name: "Redux",
                skill_slug: "redux-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/explore-101477.png?updatedAt=1688726937840"
            },
            {
                id: 285,
                skill_name: "React JS",
                skill_slug: "react-js-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/earth-101473.png?updatedAt=1688726937920"
            },
            {
                id: 235,
                skill_name: "PHP (Hindi)",
                skill_slug: "php-(hindi)-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/experiment-101490.png?updatedAt=1688726937682"
            },
            {
                id: 319,
                skill_name: "Java Basic (Telugu)",
                skill_slug: "java-basic-telugu-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/danger-101479.png?updatedAt=1688726936884"
            },
            {
                id: 240,
                skill_name: "Node.JS",
                skill_slug: "node.js-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/vector-101475.png?updatedAt=1688726936707"
            },
            {
                id: 312,
                skill_name: "Java Basic (Tamil)",
                skill_slug: "java-basic-tamil-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/design-101474.png?updatedAt=1688726936750"
            },
            {
                id: 313,
                skill_name: "Java Basic (Hindi)",
                skill_slug: "java-basic-hindi-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/chip-101493.png?updatedAt=1688726936588"
            },
            {
                id: 251,
                skill_name: "Express JS",
                skill_slug: "express-js-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/clipboard-101485.png?updatedAt=1688726936464"
            },
            {
                id: 252,
                skill_name: "PostgreSQL",
                skill_slug: "postgresql-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/chemistry-101482.png?updatedAt=1688726936501"
            },
            {
                id: 337,
                skill_name: "C++ Programming (Hindi)",
                skill_slug: "cplusplus-programming-hindi-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/bulb-101472.png?updatedAt=1688726936304"
            },
            {
                id: 256,
                skill_name: "System Design",
                skill_slug: "system-design-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/book-101486.png?updatedAt=1688726932682"
            },
            {
                id: 320,
                skill_name: "CSS (English)",
                skill_slug: "css-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/blackboard-101481.png?updatedAt=1688726932551"
            },
            {
                id: 336,
                skill_name: "Webflow For Website Creation",
                skill_slug: "webflow-for-website-creation-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/biohazard-101494.png?updatedAt=1688726932343"
            },
            {
                id: 343,
                skill_name: "Master DSA in Java Using Collections Framework",
                skill_slug: "master-dsa-in-java-using-collections-framework-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/atom-101488.png?updatedAt=1688726932206"
            },
            {
                id: 344,
                skill_name: "Next.js Mastery: Building Modern Web Applications",
                skill_slug: "next-js-mastery-building-modern-web-applications-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/biology-101489.png?updatedAt=1688726932395"
            },
            {
                id: 345,
                skill_name: "SpringBoot (English)",
                skill_slug: "springboot-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/attract-101478.png?updatedAt=1688726931998"
              
            }
        ],
        [
            {
                id: 267,
                skill_name: "Digital Marketing Fundamentals",
                skill_slug: "digital-marketing-fundamentals-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/brain-101484.png?updatedAt=1688726932002"
            },
            {
                id: 290,
                skill_name: "SEO (English)",
                skill_slug: "seo-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/game-101401.png?updatedAt=1688727215507"
            },
            {
                id: 291,
                skill_name: "Social Media Marketing (English)",
                skill_slug: "social-media-marketing-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/eye-101399.png?updatedAt=1688727215284"
            },
            {
                id: 303,
                skill_name: "Content Marketing (English)",
                skill_slug: "content-marketing-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/diagram-101416.png?updatedAt=1688727215184"
            },
            {
                id: 38,
                skill_name: "Search Engine Marketing",
                skill_slug: "search-engine-marketing-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/d-101398.png?updatedAt=1688727215016"
            },
            {
                id: 39,
                skill_name: "Email Marketing",
                skill_slug: "email-marketing-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/copy-101410.png?updatedAt=1688727214574"
            },
            {
                id: 40,
                skill_name: "Web Analytics",
                skill_slug: "web-analytics-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/computer-101397.png?updatedAt=1688727209753",
            },
            {
                id: 41,
                skill_name: "Account Management & Client Servicing",
                skill_slug: "account-management-client-servicing-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/content-101407.png?updatedAt=1688727209562"
            },
            {
                id: 42,
                skill_name: "Lead Generation",
                skill_slug: "lead-generation-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/bulb-101417.png?updatedAt=1688727208821"
            },
            {
                id: 43,
                skill_name: "Branding & Design Essentials",
                skill_slug: "branding-design-essentials-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/bulb-101415.png?updatedAt=1688727208629"
            },
            {
                id: 44,
                skill_name: "Display Advertisements",
                skill_slug: "display-advertisements-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/cogwheel-101414.png?updatedAt=1688727208454"
            },
            {
                id: 45,
                skill_name: "Influencer Marketing",
                skill_slug: "influenceers-marketing-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/calipers-101406.png?updatedAt=1688727208545"
            },
            {
                id: 46,
                skill_name: "Remarketing & Growth Hacking",
                skill_slug: "remarketing-growth-hacking-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/brain-101404.png?updatedAt=1688727208281"
            },
            {
                id: 297,
                skill_name: "Affiliate Marketing (English)",
                skill_slug: "affiliate-marketing-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/build-101412.png?updatedAt=1688727207968"
            },
            {
                id: 48,
                skill_name: "CRM & Community Building",
                skill_slug: "crm-community-building-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/beverage-101419.png?updatedAt=1688727207752"
            },
            {
                id: 150,
                skill_name: "Google Analytics",
                skill_slug: "google-analytics-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101418.png?updatedAt=1688727206561"
            },
            {
                id: 311,
                skill_name: "Social Media Marketing (Hindi)",
                skill_slug: "social-media-marketing-hindi-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101395.png?updatedAt=1688727205000"
            },
            {
                id: 247,
                skill_name: "Paid Ads and Paid Media",
                skill_slug: "paid-ads-and-paid-media-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101408.png?updatedAt=1688727204953"
            },
            {
                id: 248,
                skill_name: "SEO (Hindi)",
                skill_slug: "seo-hindi-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/access-101411.png?updatedAt=1688727204514"
            },
            {
                id: 322,
                skill_name: "Digital Marketing (Hindi)",
                skill_slug: "digital-marketing-hindi-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/application-101396.png?updatedAt=1688727204328"
            },
            {
                id: 10000,
                skill_name: "Copywriting",
                skill_slug: "copywriting-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101400.png?updatedAt=1688727204601"
            },
            {
                id: 10000,
                skill_name: "Growth Marketing",
                skill_slug: "growth-marketing-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101400.png?updatedAt=1688727204601"
            }
        ],
        [
            {
                id: 274,
                skill_name: "Python Basic (English)",
                skill_slug: "python-basic-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101400.png?updatedAt=1688727204601"
            },
            {
                id: 292,
                skill_name: "Python Advanced (English)",
                skill_slug: "python-advanced-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101405.png?updatedAt=1688727204140"
            },
            {
                id: 287,
                skill_name: "Power BI Basic (English)",
                skill_slug: "power-bi-basic-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/action-101403.png?updatedAt=1688727204221"
            },
            {
                id: 114,
                skill_name: "Deep Learning",
                skill_slug: "deep-learning-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101409.png?updatedAt=1688727203891"
            },
            {
                id: 289,
                skill_name: "Power BI Advanced (English)",
                skill_slug: "power-bi-advanced-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/app-101402.png?updatedAt=1688727203802"
            },
            {
                id: 271,
                skill_name: "Tableau Basic (English)",
                skill_slug: "tableau-basic-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101413.png?updatedAt=1688727203597"
            },
            {
                id: 110,
                skill_name: "Tableau Advanced",
                skill_slug: "tableau-advanced-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/report-94467.png?updatedAt=1688727395300"
            },
            {
                id: 293,
                skill_name: "Python Basic (Hindi)",
                skill_slug: "python-basic-hindi-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/sheild-94457.png?updatedAt=1688727395172"
            },
            {
                id: 294,
                skill_name: "Python Advanced (Hindi)",
                skill_slug: "python-advanced-hindi-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/patnership-94458.png?updatedAt=1688727394393"
            },
            {
                id: 295,
                skill_name: "Machine Learning",
                skill_slug: "machine-learning-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/plant-94460.png?updatedAt=1688727394168"
            },
            {
                id: 186,
                skill_name: "R Programming",
                skill_slug: "r-programming-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/target-94461.png?updatedAt=1688727394244"
            },
            {
                id: 268,
                skill_name: "Data Analytics (English)",
                skill_slug: "data-analytics-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/idea-94459.png?updatedAt=1688727394053"
            },
            {
                id: 309,
                skill_name: "Applied Artificial Intelligence",
                skill_slug: "applied-artificial-intelligence-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/money-94471.png?updatedAt=1688727393951"
            },
            {
                id: 324,
                skill_name: "Python Basic (Tamil)",
                skill_slug: "python-basic-tamil-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/money-94470.png?updatedAt=1688727393827"
            },
            {
                id: 259,
                skill_name: "Statistical Modelling",
                skill_slug: "statistical-modelling-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/money-94469.png?updatedAt=1688727393908"
            },
            {
                id: 264,
                skill_name: "Python (Telugu)",
                skill_slug: "python-telugu-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/hourglass-94456.png?updatedAt=1688727393223"
            },
            {
                id: 333,
                skill_name: "Mastering ChatGPT - The Ultimate Guide to Conversational AI",
                skill_slug: "mastering-chatgpt-the-ultimate-guide-to-conversational-ai-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/analysis-94465.png?updatedAt=1688727390446"
            }
        ],
        [
            {
                id: 269,
                skill_name: "Photoshop Basic (English)",
                skill_slug: "photoshop-basic-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/balance-94453.png?updatedAt=1688727390531"
            },
            {
                id: 270,
                skill_name: "Photoshop Advanced (English)",
                skill_slug: "photoshop-advanced-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/briefcase-94468.png?updatedAt=1688727390306"
            },
            {
                id: 342,
                skill_name: "Blender Basic (English)",
                skill_slug: "blender-basic-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/analysis-94452.png?updatedAt=1688727390408"
            },
            {
                id: 77,
                skill_name: "Blender Advanced",
                skill_slug: "blender-advanced-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/account-94454.png?updatedAt=1688727390135"
            },
            {
                id: 298,
                skill_name: "Beginner's Guide to Illustrator",
                skill_slug: "beginner-s-guide-to-illustrator-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/finance-94455.png?updatedAt=1688727390727"
            },
            {
                id: 85,
                skill_name: "After Effects",
                skill_slug: "after-effects-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/analysis-94462.png?updatedAt=1688727390018"
            },
            {
                id: 326,
                skill_name: "AutoCAD (English)",
                skill_slug: "autocad-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/funding-94464.png?updatedAt=1688727390028"
            },
            {
                id: 118,
                skill_name: "GIMP",
                skill_slug: "gimp-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/analysis-94466.png?updatedAt=1688727389841"
            },
            {
                id: 111,
                skill_name: "Premiere Pro Essentials: A Beginner's Guide (English)",
                skill_slug: "premiere-pro-essentials-a-beginner-s-guide-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/accounting-94463.png?updatedAt=1688727389859"
            },
            {
                id: 121,
                skill_name: "Digital Art Basic",
                skill_slug: "digital-art-basic-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/text-94368.png?updatedAt=1688727499394"
            },
            {
                id: 122,
                skill_name: "Digital Art Advanced",
                skill_slug: "digital-art-advanced-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/strip-94370.png?updatedAt=1688727498391"
            },
            {
                id: 132,
                skill_name: "Krita",
                skill_slug: "krita-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/diagram-94367.png?updatedAt=1688727498311"
            },
            {
                id: 340,
                skill_name: "Sketching Basics",
                skill_slug: "sketching-basics-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/idea-94369.png?updatedAt=1688727498258"
            },
            {
                id: 135,
                skill_name: "Wondershare Filmora",
                skill_slug: "wondershare-filmora-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/design-94366.png?updatedAt=1688727498170"
            },
            {
                id: 138,
                skill_name: "DaVinci Resolve Pre-Beginner",
                skill_slug: "davinci-resolve-pre-beginner-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/design-94364.png?updatedAt=1688727498157"
            },
            {
                id: 151,
                skill_name: "Brush Pen Calligraphy",
                skill_slug: "brush-pen-calligraphy-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/work-94371.png?updatedAt=1688727498065"
            },
            {
                id: 152,
                skill_name: "Inkscape",
                skill_slug: "inkscape-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/compass-94362.png?updatedAt=1688727498013"
            },
            {
                id: 154,
                skill_name: "Solidworks",
                skill_slug: "solidworks-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/coding-94363.png?updatedAt=1688727497968"
            },
            {
                id: 155,
                skill_name: "Lightroom",
                skill_slug: "lightroom-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/design-94365.png?updatedAt=1688727497843"
            },
            {
                id: 160,
                skill_name: "Motion Graphics Basic",
                skill_slug: "motion-graphics-basic-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/box-94358.png?updatedAt=1688727494086"
            },
            {
                id: 288,
                skill_name: "Canva - Graphic Designing",
                skill_slug: "canva-graphic-designing-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/blueprint-94357.png?updatedAt=1688727494104"
            },
            {
                id: 213,
                skill_name: "Photoshop By Gareth David",
                skill_slug: "photoshop-by-gareth-david-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/bezier-94361.png?updatedAt=1688727494019"
            },
            {
                id: 207,
                skill_name: "Graphic Designing - Concepts",
                skill_slug: "graphic-designing--concepts-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/api-94352.png?updatedAt=1688727493902"
            },
            {
                id: 215,
                skill_name: "Embroidery",
                skill_slug: "embroidery-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/balance-94354.png?updatedAt=1688727493781"
            },
            {
                id: 217,
                skill_name: "Make Up",
                skill_slug: "make-up-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/art-94360.png?updatedAt=1688727493725"
            },
            {
                id: 222,
                skill_name: "SketchUp",
                skill_slug: "sketchup-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/brainstorming-94359.png?updatedAt=1688727493618"
            },
            {
                id: 223,
                skill_name: "Substance Painter",
                skill_slug: "substance-painter-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/api-94353.png?updatedAt=1688727493533"
            },
            {
                id: 225,
                skill_name: "Interior Designing With AutoCAD",
                skill_slug: "interior-designing-with-autocad-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/application-94356.png?updatedAt=1688727493357"
            },
            {
                id: 227,
                skill_name: "Catia",
                skill_slug: "catia-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/app-94355.png?updatedAt=1688727493256"
            },
            {
                id: 234,
                skill_name: "Adobe XD",
                skill_slug: "adobe-xd-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/access-94292.png?updatedAt=1688716203631"
            },
            {
                id: 369,
                skill_name: "Introduction to Maya for Beginners",
                skill_slug: "introduction-to-maya-for-beginners-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/cloud-94293.png?updatedAt=1688726577600"
            }
        ],
        [
            {
                id: 299,
                skill_name: "Forex Trading",
                skill_slug: "forex-trading-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/access-94298.png?updatedAt=1688726529998"
            },
            {
                id: 279,
                skill_name: "Stock Market Basics (Hinglish)",
                skill_slug: "stock-market-basics-hinglish-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/backup-94310.png?updatedAt=1688726544823"
            },
            {
                id: 300,
                skill_name: "Advanced Stock Market Strategies for Experienced Investors (Hinglish)",
                skill_slug: "advanced-stock-market-strategies-for-experienced-investors-hinglish-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/chart-94299.png?updatedAt=1688726560024"
            },
            {
                id: 332,
                skill_name: "Financial Advisory and Portfolio Management",
                skill_slug: "financial-advisory-and-portfolio-management-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/cloud-94293.png?updatedAt=1688726577600"
            },
            {
                id: 304,
                skill_name: "Tally (Hindi)",
                skill_slug: "tally-hindi-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/configure-94308.png?updatedAt=1688726614736"
            },
            {
                id: 339,
                skill_name: "Fundamentals of SAP",
                skill_slug: "fundamentals-of-sap-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/international-94303.png?updatedAt=1688726645411"
            },
            {
                id: 338,
                skill_name: "Financial Accounting",
                skill_slug: "financial-accounting-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/action-101483.png?updatedAt=1688726715839"
            },
            {
                id: 194,
                skill_name: "Accounting Documents",
                skill_slug: "accounting-documents-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/analysis-101492.png?updatedAt=1688726748532"
            },
            {
                id: 195,
                skill_name: "Controlling",
                skill_slug: "controlling-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/apple-101470.png?updatedAt=1688726776098"
            },
            {
                id: 196,
                skill_name: "Bank Accounting",
                skill_slug: "bank-accounting-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/astronomy-101471.png?updatedAt=1688726821127"
            },
            {
                id: 229,
                skill_name: "Tally in Hindi By Rahul Chaudhary",
                skill_slug: "tally-in-hindi-by-rahul-chaudhary-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/atom-101480.png?updatedAt=1688726821267"
            }
        ],
        [
            {
                id: 262,
                skill_name: "UI/UX Fundamentals for Beginners",
                skill_slug: "ui-ux-fundamentals-for-beginners-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/explore-101477.png?updatedAt=1688726937840"
            },
            {
                id: 277,
                skill_name: "Careers in UX Design",
                skill_slug: "careers-in-ux-design-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/earth-101473.png?updatedAt=1688726937920"
            },
            {
                id: 53,
                skill_name: "Product/ UX Strategy",
                skill_slug: "product-ux-strategy-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/experiment-101490.png?updatedAt=1688726937682"
            },
            {
                id: 55,
                skill_name: "Information Architecture",
                skill_slug: "information-architecture-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/danger-101479.png?updatedAt=1688726936884"
            },
            {
                id: 57,
                skill_name: "Surveying Data through Card Sorting & Site Maps",
                skill_slug: "surveying-data-through-card-sorting-site-maps-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/vector-101475.png?updatedAt=1688726936707"
            },
            {
                id: 58,
                skill_name: "Task Flow & User Flow",
                skill_slug: "task-flow-user-flow-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/design-101474.png?updatedAt=1688726936750"
            },
            {
                id: 59,
                skill_name: "Wireframing, Prototyping, & Laws for UX",
                skill_slug: "wireframing,-prototyping,-laws-for-ux-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/chip-101493.png?updatedAt=1688726936588"
            },
            {
                id: 61,
                skill_name: "Elements of UI Design",
                skill_slug: "elements-of-ui-design-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/clipboard-101485.png?updatedAt=1688726936464"
            },
            {
                id: 63,
                skill_name: "Designer Developer Handoff",
                skill_slug: "designer-developer-handoff-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/chemistry-101482.png?updatedAt=1688726936501"
            },
            {
                id: 316,
                skill_name: "Figma",
                skill_slug: "figma-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/bulb-101472.png?updatedAt=1688726936304"
            }
        ],
        [
            {
                id: 318,
                skill_name: "Microsoft Excel Basic (English)",
                skill_slug: "microsoft-excel-basic-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/broadcast-101487.png?updatedAt=1688726932946"
            },
            {
                id: 310,
                skill_name: "Microsoft Excel Advanced (English)",
                skill_slug: "microsoft-excel-advanced-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/book-101486.png?updatedAt=1688726932682"
            },
            {
                id: 317,
                skill_name: "Mastering Freelancing",
                skill_slug: "mastering-freelancing-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/atom-101491.png?updatedAt=1688726932512"
            },
            {
                id: 341,
                skill_name: "Microsoft Word (Basics)",
                skill_slug: "microsoft-word-basics-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/biology-101476.png?updatedAt=1688726932836"
            },
            {
                id: 328,
                skill_name: "Product Management (English)",
                skill_slug: "product-management-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/blackboard-101481.png?updatedAt=1688726932551"
            },
            {
                id: 261,
                skill_name: "Business Intelligence",
                skill_slug: "business-intelligence-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/biohazard-101494.png?updatedAt=1688726932343"
            },
            {
                id: 198,
                skill_name: "Microsoft Powerpoint Basic",
                skill_slug: "microsoft-powerpoint-basic-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/atom-101488.png?updatedAt=1688726932206"
            },
            {
                id: 199,
                skill_name: "Microsoft Powerpoint Advanced",
                skill_slug: "microsoft-powerpoint-advanced-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/biology-101489.png?updatedAt=1688726932395"
            },
            {
                id: 200,
                skill_name: "Google Docs",
                skill_slug: "google-docs-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/attract-101478.png?updatedAt=1688726931998"
            },
            {
                id: 208,
                skill_name: "Google Sheets",
                skill_slug: "google-sheets-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube/brain-101484.png?updatedAt=1688726932002"
            },
            {
                id: 209,
                skill_name: "Google Slides",
                skill_slug: "google-slides-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/international-94303.png?updatedAt=1688727086351"
            },
            {
                id: 216,
                skill_name: "Microsoft Word Advanced",
                skill_slug: "microsoft-word-advanced-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/mobile-94304.png?updatedAt=1688727085080"
            },
            {
                id: 228,
                skill_name: "Scrum Master",
                skill_slug: "scrum-master-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/router-94311.png?updatedAt=1688727084011"
            },
        ],
        [
            {
                id: 281,
                skill_name: "Learn English From Scratch In Hindi",
                skill_slug: "learn-english-from-scratch-in-hindi-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/infrastructure-94301.png?updatedAt=1688727083984"
            },
            {
                id: 280,
                skill_name: "Mastering English",
                skill_slug: "mastering-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/device-94309.png?updatedAt=1688727083691"
            }
        ],
        [
            {
                id: 306,
                skill_name: "Oracle Cloud Infrastructure Basics",
                skill_slug: "oracle-cloud-infrastructure-basics-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/communication-94300.png?updatedAt=1688727083586"
            },
            {
                id: 168,
                skill_name: "Oracle Cloud Core Infrastructure Advanced Foundations",
                skill_slug: "oracle-cloud-core-infrastructure-advanced-foundations-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/connection-94295.png?updatedAt=1688727083576"
            },
            {
                id: 307,
                skill_name: "Amazon Web Services Analytics",
                skill_slug: "amazon-web-services-analytics-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/folder-94302.png?updatedAt=1688727083658"
            },
            {
                id: 327,
                skill_name: "Amazon Web Services Database",
                skill_slug: "amazon-web-services-database-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-2/configure-94308.png?updatedAt=1688727083711"
            },
            {
                id: 325,
                skill_name: "Azure (English)",
                skill_slug: "azure-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/game-101401.png?updatedAt=1688727215507"
            },
            {
                id: 182,
                skill_name: "Docker Basic",
                skill_slug: "docker-basic-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/eye-101399.png?updatedAt=1688727215284"
            },
            {
                id: 183,
                skill_name: "Docker Advanced",
                skill_slug: "docker-advanced-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/diagram-101416.png?updatedAt=1688727215184"
            },
            {
                id: 226,
                skill_name: "Linux for DevOps Engineers in Hindi by TrainWithShubham",
                skill_slug: "linux-for-devops-engineers-in-hindi-by-trainwithshubham-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/d-101398.png?updatedAt=1688727215016"
            },
            {
                id: 260,
                skill_name: "Kubernetes",
                skill_slug: "kubernetes-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/copy-101410.png?updatedAt=1688727214574"
            }
        ],
        [
            {
                id: 286,
                skill_name: "SQL Basic",
                skill_slug: "sql-basic-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/computer-101397.png?updatedAt=1688727209753"
            },
            {
                id: 67,
                skill_name: "SQL Advanced",
                skill_slug: "sql-advanced-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/content-101407.png?updatedAt=1688727209562"
            },
            {
                id: 102,
                skill_name: "MySQL",
                skill_slug: "mysql-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/bulb-101417.png?updatedAt=1688727208821"
            },
            {
                id: 346,
                skill_name: "Linux Basic (English)",
                skill_slug: "linux-basic-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/bulb-101415.png?updatedAt=1688727208629"
            },
            {
                id: 98,
                skill_name: "Linux Advanced",
                skill_slug: "linux-advanced-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/cogwheel-101414.png?updatedAt=1688727208454"
            },
            {
                id: 145,
                skill_name: "Shell Scripting",
                skill_slug: "shell-scripting-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/calipers-101406.png?updatedAt=1688727208545"
            },
            {
                id: 157,
                skill_name: "Mongo DB",
                skill_slug: "mongo-db-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/brain-101404.png?updatedAt=1688727208281"
            },
            {
                id: 158,
                skill_name: "Redis",
                skill_slug: "redis-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/build-101412.png?updatedAt=1688727207968"
            }
        ],
        [
            {
                id: 321,
                skill_name: "Arduino",
                skill_slug: "arduino-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/beverage-101419.png?updatedAt=1688727207752"
            },
            {
                id: 315,
                skill_name: "Cyber Security (English)",
                skill_slug: "cyber-security-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101418.png?updatedAt=1688727206561"
            },
            {
                id: 305,
                skill_name: "Ethical Hacking",
                skill_slug: "ethical-hacking-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101395.png?updatedAt=1688727205000"
            },
            {
                id: 329,
                skill_name: "5G Wireless Engineer",
                skill_slug: "5g-wireless-engineer-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101408.png?updatedAt=1688727204953"
            },
            {
                id: 331,
                skill_name: "CCNA",
                skill_slug: "ccna-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/access-101411.png?updatedAt=1688727204514"
            },
            {
                id: 334,
                skill_name: "Comptia A+",
                skill_slug: "comptia-a-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/application-101396.png?updatedAt=1688727204328"
            },
            {
                id: 335,
                skill_name: "Comptia N+",
                skill_slug: "comptia-n-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101400.png?updatedAt=1688727204601"
            }
        ],
        [
            {
                id: 301,
                skill_name: "Film Editing Basics",
                skill_slug: "film-editing-basics-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101405.png?updatedAt=1688727204140"
            },
            {
                id: 302,
                skill_name: "Elemental Creation Basic of Film Making",
                skill_slug: "elemental-creation-basic-of-film-making-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/action-101403.png?updatedAt=1688727204221"
            },
            {
                id: 170,
                skill_name: "Theory and Practical Cinematography",
                skill_slug: "theory-and-practical-cinematography-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101409.png?updatedAt=1688727203891"
            },
            {
                id: 171,
                skill_name: "Sparkling Art of Film Direction",
                skill_slug: "sparkling-art-of-film-direction-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/app-101402.png?updatedAt=1688727203802"
            },
            {
                id: 172,
                skill_name: "Film Financing and Distribution",
                skill_slug: "film-financing-and-distribution-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-3/art-101413.png?updatedAt=1688727203597"
            },
            {
                id: 173,
                skill_name: "Film Advertising and Public Relations",
                skill_slug: "film-advertising-and-public-relations-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/report-94467.png?updatedAt=1688727395300"
            },
            {
                id: 174,
                skill_name: "Corporate Communications in Film Making",
                skill_slug: "corporate-communications-in-film-making-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/sheild-94457.png?updatedAt=1688727395172"
            },
            {
                id: 175,
                skill_name: "Film Production Design",
                skill_slug: "film-production-design-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/patnership-94458.png?updatedAt=1688727394393"
            },
            {
                id: 176,
                skill_name: "Film Theories and its Societal Impact",
                skill_slug: "film-theories-and-its-societal-impact-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/plant-94460.png?updatedAt=1688727394168"
            },
            {
                id: 177,
                skill_name: "Sound Production and Design",
                skill_slug: "sound-production-and-design-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/target-94461.png?updatedAt=1688727394244"
            },
            {
                id: 178,
                skill_name: "Graphical Animation of Films with Communication Research",
                skill_slug: "graphical-animation-of-films-with-communication-research-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/idea-94459.png?updatedAt=1688727394053"
            },
            {
                id: 179,
                skill_name: "Sound Designing on Set",
                skill_slug: "sound-designing-on-set-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/money-94471.png?updatedAt=1688727393951"
            },
            {
                id: 181,
                skill_name: "Story, Scripting and Story Boarding",
                skill_slug: "story,-scripting-and-story-boarding-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/money-94470.png?updatedAt=1688727393827"
            }
        ],
        [
            {
                id: 166,
                skill_name: "Oracle Application Express – Application Development Foundations",
                skill_slug: "oracle-application-express-–-application-development-foundations-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/money-94469.png?updatedAt=1688727393908"
            },
            {
                id: 117,
                skill_name: "Git",
                skill_slug: "git-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/hourglass-94456.png?updatedAt=1688727393223"
            },
            {
                id: 161,
                skill_name: "Salesforce App Builder and Administrator",
                skill_slug: "salesforce-app-builder-and-administrator-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/analysis-94465.png?updatedAt=1688727390446"
            },
            {
                id: 68,
                skill_name: "WordPress",
                skill_slug: "wordpress-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/balance-94453.png?updatedAt=1688727390531"
            },
            {
                id: 164,
                skill_name: "Jenkins",
                skill_slug: "jenkins-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/briefcase-94468.png?updatedAt=1688727390306"
            },
            {
                id: 107,
                skill_name: "Android Studio",
                skill_slug: "android-studio-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/analysis-94452.png?updatedAt=1688727390408"
            },
            {
                id: 146,
                skill_name: "WIX",
                skill_slug: "wix-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/account-94454.png?updatedAt=1688727390135"
            },
            {
                id: 147,
                skill_name: "Unreal Engine",
                skill_slug: "unreal-engine-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/finance-94455.png?updatedAt=1688727390727"
            },
            {
                id: 149,
                skill_name: "Joomla",
                skill_slug: "joomla-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/analysis-94462.png?updatedAt=1688727390018"
            },
            {
                id: 156,
                skill_name: "Jira",
                skill_slug: "jira-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/funding-94464.png?updatedAt=1688727390028"
            },
            {
                id: 263,
                skill_name: "Software Testing",
                skill_slug: "software-testing-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/analysis-94466.png?updatedAt=1688727389841"
            }
        ],
        [
            {
                id: 272,
                skill_name: "Blockchain Fundamentals",
                skill_slug: "blockchain-fundamentals-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-4/accounting-94463.png?updatedAt=1688727389859"
            }
        ],
        [
            {
                id: 103,
                skill_name: "Piano",
                skill_slug: "piano-english-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/strip-94370.png?updatedAt=1688727498391"
            },
            {
                id: 104,
                skill_name: "Guitar Basics: A Comprehensive Guide for Beginners",
                skill_slug: "guitar-basics-a-comprehensive-guide-for-beginners-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/diagram-94367.png?updatedAt=1688727498311"
            },
            {
                id: 105,
                skill_name: "Guitar Advanced",
                skill_slug: "guitar-advanced-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/idea-94369.png?updatedAt=1688727498258"
            },
            {
                id: 124,
                skill_name: "Piano Crash Course",
                skill_slug: "piano-crash-course-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/design-94366.png?updatedAt=1688727498170"
            },
            {
                id: 165,
                skill_name: "Violin",
                skill_slug: "violin-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/design-94364.png?updatedAt=1688727498157"
            },
            {
                id: 187,
                skill_name: "FL Studio Begginer Music Production",
                skill_slug: "fl-studio-begginer-music-production-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/work-94371.png?updatedAt=1688727498065"
            },
            {
                id: 188,
                skill_name: "FL Studio 20 - Music Production In FL Studio for Mac & PC",
                skill_slug: "fl-studio-20--music-production-in-fl-studio-for-mac-pc-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/compass-94362.png?updatedAt=1688727498013"
            },
            {
                id: 189,
                skill_name: "FL Studio 12",
                skill_slug: "fl-studio-12-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/coding-94363.png?updatedAt=1688727497968"
            },
            {
                id: 190,
                skill_name: "FL Studio 12 Music Making",
                skill_slug: "fl-studio-12-music-making-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/design-94365.png?updatedAt=1688727497843"
            },
            {
                id: 191,
                skill_name: "FL Studio Hardstyle Production Hard Dance Music Production",
                skill_slug: "fl-studio-hardstyle-production-hard-dance-music-production-course",
                skill_thumbnail: "https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/box-94358.png?updatedAt=1688727494086"
            }
        ]
]

export const placementData = [
    {
      label: "Week 1",
      title: "Building the Ultimate Profile",
      subtitle: "CV + LinkedIn revamp to make your application stand out",
      video_link: "https://youtu.be/OKVe7qahDoc",
      thumbnail: "https://assets.learntube.ai/files/Optimized_folder/premium/placementImages/week-1.jpg?updatedAt=1688366093369",
    },
    {
      label: "Week 2",
      title: "Creating Your Job Hunt Plan",
      subtitle: "Learn winning strategies that will get you shortlisted",
      video_link: "https://youtu.be/93Y-_Pzk7SM",
      thumbnail: "https://assets.learntube.ai/files/Optimized_folder/premium/placementImages/week-2.jpg?updatedAt=1688366094136",
    },
    {
      label: "Week 3",
      title: "Mastering The Elevator Pitch",
      subtitle: "Land multiple job interviews with the right skills & attitude",
      video_link: "https://youtu.be/Oa73QfUg9WI",
      thumbnail: "https://assets.learntube.ai/files/Optimized_folder/premium/placementImages/week-3.jpg?updatedAt=1688366094579",
    },
    {
      label: "Week 4",
      title: "Live Interview Training",
      subtitle: "Get hired with mock interviews & personalised feedback",
      video_link: "https://youtu.be/AKUVJT7UYl0",
      thumbnail: "https://assets.learntube.ai/files/Optimized_folder/premium/placementImages/week-4.jpg?updatedAt=1688366094496",
    },
]

export const videoThumbnail = [
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Group_8553.png?updatedAt=1686917725183',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Group_8549.png?updatedAt=1686917725222',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Group_8550.png?updatedAt=1686917725363',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Group_8547.png?updatedAt=1686917725406',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Group_8551.png?updatedAt=1686917725508',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Group_8552.png?updatedAt=1686917725668',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Group_8548.png?updatedAt=1686917725742',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Group_8546.png?updatedAt=1686917725828',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Group_8545.png?updatedAt=1686917725891',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Group_8533.png?updatedAt=1686917725959'
]

export const projects = [
    {
      id: 1,
      mentor: "Rahila Saleem",
      domain_icon: "https://assets.learntube.ai/files/AI_Syllabus_generator/project-1/digital-marketing.png?updatedAt=1686737716822",
      domain: 'Digital Marketing',
      project_thumbnail:
        "https://assets.learntube.ai/files/AI_Syllabus_generator/thumbnails/digital-marketing-project-thumbnail.png?updatedAt=1686737808692",
      title: "Creating a Social Media Campaign for a Product Launch",
      description:
        "The objective of this project is to create and execute a comprehensive social media campaign to generate buzz, drive engagement, and increase sales for a new product launch.",
      skills_showcase: [
        "Social media strategy development",
        "Content creation and curation",
        "Social media advertising",
        "Analytics and reporting",
        "Project management",
      ],
      tools_showcase: [
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-1/Canva_-_png_0.png?updatedAt=1686750058981",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-1/google_analytics.png?updatedAt=1686750063138",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-1/Hootsuite_-_png_0.png?updatedAt=1686750064611",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-1/instagram.png?updatedAt=1686750058966",
       
      ],
      companies_showcase: [
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-1/Gazoop_-_png_0.png?updatedAt=1686750059167",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-1/ogilvy.png?updatedAt=1686750062352",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-1/publicis_groupe.png?updatedAt=1686750059164",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-1/Schbang_-_jpeg_0.png?updatedAt=1686750058978"
      ],
      download_link:
        "https://drive.google.com/file/d/1ap6selIs8LiW6tjPOd6poCyrJb5l031d/view?usp=drive_link",
    },
    {
      id: 2,
      mentor: "Dushyant Pathak",
      domain: 'Programming',
      domain_icon: "https://assets.learntube.ai/files/AI_Syllabus_generator/project-2/programming.png?updatedAt=1686737693833",
      project_thumbnail:
        "https://assets.learntube.ai/files/AI_Syllabus_generator/thumbnails/programming-project-thumbnail.png?updatedAt=1686737808024",
      title:
        "Building an E-commerce Platform with Payment Integration and User Authentication",
      description:
        "The objective of this project is to develop a functional e-commerce platform that allows users to browse and purchase products and integrates secure payment processing.",
      skills_showcase: [
        "Web development (HTML, CSS, JavaScript)",
        "Backend development using NodeJs",
        "Database management (MySQL, PostgreSQL)",
        "Payment gateway integration (Stripe, PayPal)",
        "User authentication and authorization",
      ],
      tools_showcase: [
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-2/Node.js_-_png_0.png?updatedAt=1686750420514",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-2/Oracle_MySQL_-_png_0.png?updatedAt=1686750420884",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-2/Stripe_-_png_0.png?updatedAt=1686750420468",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-2/Adobe_XD_Elements_-_png_0.png?updatedAt=1686750420189", 
      ],
      companies_showcase: [
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-2/Wipro_-_png_0.png?updatedAt=1686750486201",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-2/IBM_-_jpeg_0__1_.png?updatedAt=1686750406617",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-2/Stripe_-_png_1.png?updatedAt=1686750404814",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-2/jp_morgan_chase.png?updatedAt=1686750398583"
      ],
      download_link:
        "https://drive.google.com/file/d/1ucbxVGTxi4kWkTthrbJ2WWPFI0V3PEI6/view?usp=drive_link",
    },
    {
      id: 3,
      mentor: "Anirban Paul",
      domain: 'Data Science',
      domain_icon: "https://assets.learntube.ai/files/AI_Syllabus_generator/project-3/data-science.png?updatedAt=1686737743114",
      project_thumbnail:
        "https://assets.learntube.ai/files/AI_Syllabus_generator/thumbnails/data-science-project-thumbnail.png?updatedAt=1686737808493",
      title: "Building a Predictive Model for Stock Price Forecasting",
      description:
        "The objective of this project is to develop a predictive model that can forecast stock prices or market trends based on historical data. The model will help investors and traders make informed decisions by providing insights into potential price movements.",
      skills_showcase: [
        "Analysing and visualising trends and patterns",
        "Feature engineering using Python libraries",
        "Selecting and training time series models like ARIMA or LSTM",
        "Evaluating model performance and refining predictions with metrics and optimization techniques",
        "Python for data manipulation and analysis",
      ],
      tools_showcase: [
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-3/Python_Software_Foundation_-_png_0.png?updatedAt=1686750875757",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-3/pandas.png?updatedAt=1686750875758",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-3/matplotlib.png?updatedAt=1686750919583",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-3/alpha_vantage__1_.png?updatedAt=1686750875760",
       
      ],
      companies_showcase: [
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-3/Amazon_-_png_0.png?updatedAt=1686750875778",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-3/Deloitte_-_png_0.png?updatedAt=1686750875705",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-3/cloudera.png?updatedAt=1686750875592",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-3/Microsoft_-_png_0.png?updatedAt=1686750875711"
      ],
      download_link:
        "https://drive.google.com/file/d/1he-WBEONlpz0J_usyGDAOahfv4hXcSsQ/view?usp=drive_link",
    },
    {
      id: 4,
      mentor: "Dulab Deb",
      domain: 'Design',
      domain_icon: "https://assets.learntube.ai/files/AI_Syllabus_generator/project-4/design.png?updatedAt=1686737764588",
      project_thumbnail:
        "https://assets.learntube.ai/files/AI_Syllabus_generator/thumbnails/design-project-thumbnail.png?updatedAt=1686737808572",
      title: "Designing an Engaging User Onboarding Experience",
      description:
        "The objective of this project is to create a user onboarding system which incorporates an easy payment system and also facilitates early product adoption through suggestive content strategy.",
      skills_showcase: [
        "User Experience Design Principles",
        "Interaction Design Techniques",
        "Content Strategy and Personalization",
        "Information Architecture Planning and Organization",
        "Usability Testing and User Research",
      ],
      tools_showcase: [
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-4/Figma_-_png_0.png?updatedAt=1686751222952",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-4/UserTesting_-_png_0.png?updatedAt=1686751223507",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-4/InVision_-_png_0.png?updatedAt=1686751223091",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-4/Adobe_XD_Elements_-_png_6.png?updatedAt=1686751223447",
      
      ],
      companies_showcase: [
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-4/Tata_Consultancy_Services_-_png_0.png?updatedAt=1686751223490",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-4/popxo.png?updatedAt=1686751223103",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-4/Flipkart_-_png_1.png?updatedAt=1686751280597",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-4/Disney__Hotstar_-_png_0__1_.png?updatedAt=1686751222924",
      ],
      download_link:
        "https://drive.google.com/file/d/1N-MNPtlPvSVn_fiC50KsvInUhYz_o8gv/view?usp=drive_link",
    },
    {
      id: 5,
      mentor: "Rishita Motwani",
      domain: 'Finance',
      domain_icon: "https://assets.learntube.ai/files/AI_Syllabus_generator/project-5/finance.png?updatedAt=1686737784270",
      project_thumbnail:
        "https://assets.learntube.ai/files/AI_Syllabus_generator/thumbnails/finance-project-thumbnail.png?updatedAt=1686737808180",
      title: "Financial Risk Management: Mitigating Risks for a Product Launch",
      description:
        "The objective of this project is to do a financial risk mitigation for a new car launch for a car manufacturer. This will help the business to take informed decisions and avoid losses due to unforeseen risks during project implementation.",
      skills_showcase: [
        "Risk Assessment and Analysis Techniques",
        "Project Planning and Scheduling",
        "Data Analysis for Risk Evaluation",
        "Decision-making under Uncertainty",
        "Project Risk Mitigation Strategies",
      ],
      tools_showcase: [
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-5/excel.png?updatedAt=1686751624475",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-5/ms_powerpointt.png?updatedAt=1686751624127",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-5/ms_projects.png?updatedAt=1686751624108",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-5/tableau.png?updatedAt=1686751684136",
      
      ],
      companies_showcase: [
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-5/jp_morgan__1_.png?updatedAt=1686751622177",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-5/KPMG_-_png_0.png?updatedAt=1686751621593",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-5/EY_-_png_0.png?updatedAt=1686751684132",
        "https://assets.learntube.ai/files/AI_Syllabus_generator/project-5/Deutsche_Bank_-_png_0__1_.png?updatedAt=1686751621587"
      ],
      download_link:
        "https://docs.google.com/spreadsheets/d/1N_fYO8P6YSLB31tfHYxaZ0WNrASgp7d0/edit?usp=share_link&ouid=111942812402022720730&rtpof=true&sd=true",
    },
]

export const features = [
    'Personalised Syllabus',
    'Verified Certifications',
    'Practical Projects',
    'Live Doubt Solving',
]

export async function downloadCertificate(link, setDownload) {
    const bytes = await fetch(link, {
        headers: {
            'Cache-Control': 'no-cache'
        }
    })
    .then((res) => res.arrayBuffer())
    .catch((err) => console.log(err))
  
    saveAs(new Blob([bytes]), `Certificate.jpg`)
    setDownload(true)
}

export const years = [
    {
        id: 0,
        year: '1 Year',
        image:'https://assets.learntube.ai/files/AI_Syllabus_generator/1year.svg?updatedAt=1685861204276'
    },
    {
        id: 1,
        year: '3 Year',
        image:'https://assets.learntube.ai/files/AI_Syllabus_generator/3year.svg?updatedAt=1685861189080'
    },
    {
        id: 2,
        year: '5 Year',
        image:'https://assets.learntube.ai/files/AI_Syllabus_generator/5year.svg?updatedAt=1685861155995'
    }
]

export const companyLogo1 = [
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Facebook_-_png_0__1_.png?updatedAt=1685624352896',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Amazon_-_jpeg_0.png?updatedAt=1685624249275',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Apple_-_png_0__1_.png?updatedAt=1685624249085',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Netflix_-_png_0__1_.png?updatedAt=1685624248825',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Google_-_png_0__1_.png?updatedAt=1685624248441'
]

export const companyLogo2 = [
    'https://assets.learntube.ai/files/AI_Syllabus_generator/image_340.png?updatedAt=1685624248922',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/image_343.png?updatedAt=1685624509156',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/image_344.png?updatedAt=1685624248932',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/image_345.png?updatedAt=1685624248680',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Paytm_-_jpeg_0.png?updatedAt=1685624248692'
]

export const linkdInCertificateList = [
    {
        id: 1,
        name: 'Vidhi Mer',
        gender: '(She/Her)',
        designation: '.',
        post_link: "https://www.linkedin.com/feed/update/urn:li:activity:7113488469238161408/?actorCompanyId=13328177",
        profile_image: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/BfAWyhk_qy6XMG9sOTj99vmnUmc/j4_kjg../1695273639728.jpg',
        certificate_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/XVLQRUJN-K7iFQf4E2FvjTHM3Cg/QyyLgg../1695987812617.jpg",
        description: "🚀📚 I'm thrilled to share my accomplishment and newfound knowledge in the world of digital marketing. 🌐💼 \n 📈 This journey has equipped me with essential skills to navigate the digital landscape and drive meaningful results. I'm excited to apply this knowledge to my career and beyond! 💪💡",
        likes: 60,
        icon_image: (
            <div className='w-[15px] h-full mr-1'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={14} height={14} className='w-full h-auto' alt="" />
            </div>
        ),
        comments: [
            {
                id: 1,
                user_name: "Shronit Ladhani",
                gender: '(He/Him)',
                user_image: "https://assets.learntube.ai/files/LinkdinUsers/1691577786209.jpg?updatedAt=1698758533634",
                designation: 'Entrepreneur | Angel Investor | 30 Under 30 | Triathlete | 2x TEDx Speaker | Hiring for Exciting Tech, Growth and Marketing Roles',
                description: "This is great. Best of luck <span style='color: #69B4FF;'>Vidhi Mer</span>"
            },
        ]
    },
    {
        id: 2,
        name: 'Sreeya S.',
        gender: '(She/Her)',
        designation: 'Analyst at EY | Student at BITS PILANI',
        post_link: "https://www.linkedin.com/feed/update/urn:li:activity:7086763519278276609/?actorCompanyId=13328177",
        profile_image: 'https://assets.learntube.ai/files/certifiedOptimisation/1693384172683.webp?updatedAt=1720514693519',
        certificate_image: "https://assets.learntube.ai/files/certifiedOptimisation/1689616086974.webp?updatedAt=1720514690381",
        description: "🔌📊 Exciting News! Just Completed the Introduction to Power BI Certification! 🚀🎉\nHey everyone,\nI hope this post finds you all in great spirits! 🌟 Today, I am thrilled to share a moment of joy in my professional development journey. I have just completed the 'Introduction to Power BI' certification. 💪🔥\nI highly recommend anyone who wants to harness the true potential of data to consider taking the Introduction to Power BI certification. Whether you are a data enthusiast, analyst, or business professional, this course equips you with the tools you need to drive impactful outcomes. 💡\nHere's to more growth, more learning, and a future filled with data-driven success! 🚀📊",
        likes: 35,
        icon_image: (
            <div className='w-[29px] flex h-full'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={15} height={15} className='w-[15px] h-auto' alt="" />
                <img src="https://assets.learntube.ai/files/LinkdinUsers/9wt27hvi2lgll1v30u00n0p5p.svg?updatedAt=1699081182096" width={15} height={15} className='w-[15px] h-auto -ml-1.5' alt="" />
            </div>
        ),
        comments: [
            {
                id: 1,
                user_name: "Tapas Saha",
                gender: '(He/Him)',
                user_image: "https://assets.learntube.ai/files/certifiedOptimisation/1652358524721.webp?updatedAt=1720514690527",
                designation: 'A result oriented techno-functional multi skilled IT professional with 28+ years of IT Experience across various manufacturing domain. Possessing expertise both in IT infrastructure setup and ERP implementation.',
                description: "Congratulations <span style='color: #69B4FF;'>Sreeya.</span>"
            }
        ]
    },
    {
        id: 3,
        name: 'Mustafa Maner',
        gender: '(He/Him)',
        post_link: "https://www.linkedin.com/feed/update/urn:li:activity:7082967078017675264/?actorCompanyId=13328177",
        designation: 'Passionate Electronics and Telecommunication Engineering Student | Intern at CodSoft Pvt Ltd.',
        profile_image: 'https://assets.learntube.ai/files/LinkdinUsers/1696431769803.jpg?updatedAt=1698758348979',
        certificate_image: "https://assets.learntube.ai/files/certifiedOptimisation/1688710945693.webp?updatedAt=1720514690483",
        description: "Thrilled to receive my certificate of completion!💫Grateful for the opportunity to enhance my skills and knowledge in the Computers and Programming Languages course offered by <span style='color: #69B4FF;'>CareerNinja | LearnTube</span> platform. Thank you, <span style='color: #69B4FF;'>Shronit Ladhani</span> Sir, for the incredible learning experience. Excited to apply my newfound expertise to drive success and make a positive impact.",
        likes: 31,
        icon_image: (
            <div className='w-[15px] h-full mr-1'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={14} height={14} className='w-full h-auto' alt="" />
            </div>
        ),
        comments: [
            {
                id: 1,
                user_name: "Shronit Ladhani",
                gender: '(He/Him)',
                user_image: "https://assets.learntube.ai/files/LinkdinUsers/1691577786209.jpg?updatedAt=1698758533634",
                designation: 'Entrepreneur | Angel Investor | 30 Under 30 | Triathlete | 2x TEDx Speaker | Hiring for Exciting Tech, Growth and Marketing Roles',
                description: "This is great. Best of luck <span style='color: #69B4FF;'>Mustafa Maner!</span>"
            },
            // {
            //     id: 2,
            //     user_name: "CareerNinja | LearnTube",
            //     designation: "16,718 followers",
            //     user_image: "https://assets.learntube.ai/files/LinkdinUsers/careerninja_logo.jpg?updatedAt=1698757218181",
            //     description: "Congratulations on completing the course <span style='color: #69B4FF;'>Mustafa Maner!</span>"
            // }
        ]
    },
    {
        id: 4,
        name: 'Muhammad P P',
        gender: '(He/Him)',
        post_link: 'https://www.linkedin.com/feed/update/urn:li:activity:7071003165982134272/?actorCompanyId=13328177',
        designation: 'Founder at Watermelon Graphics',
        profile_image: 'https://assets.learntube.ai/files/certifiedOptimisation/1697816280708.webp?updatedAt=1720514693099',
        certificate_image: "https://assets.learntube.ai/files/certifiedOptimisation/1685858526614.webp?updatedAt=1720514690440",
        description: "Excited to announce that I've successfully completed the UI-UX Fundamental for Beginners course from LearnTube by CareerNinja! This comprehensive course has equipped me with the essential skills and knowledge needed to kickstart my career in UI-UX design. I am now ready to create intuitive and user-centered experiences that will make a positive impact. Thank you, LearnTube and <span style='color: #69B4FF;'>CareerNinja | LearnTube</span> , for this valuable learning opportunity!",
        likes: 26,
        icon_image: (
            <div className='w-[29px] flex h-full'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={15} height={15} className='w-[15px] h-auto' alt="" />
                <img src="https://assets.learntube.ai/files/LinkdinUsers/3bhtnif60blspoiyhoex4lfx.svg?updatedAt=1699081881177" width={15} height={15} className='w-[15px] h-auto -ml-1.5' alt="" />
            </div>
        ),
        comments: [
            {
                id: 1,
                user_name: "PARAMASIVAN P",
                gender: '(He/Him)',
                user_image: "https://assets.learntube.ai/files/LinkdinUsers/1664770010213.jpg?updatedAt=1698758920528",
                designation: 'Director at Dhaanish Ahmed College Of Engineering, Chennai',
                description: "Excellent"
            },
            // {
            //     id: 2,
            //     user_name: "Mohammed Sinan",
            //     gender: '(He/Him)',
            //     user_image: "https://assets.learntube.ai/files/LinkdinUsers/1691714985499.jpg?updatedAt=1698759128956",
            //     designation: 'Mechanical Engineering Student',
            //     description: "Congrats 🎉"
            // },
        ]
    },
    {
        id: 5,
        name: 'Baibhab Pal',
        gender: '(He/Him)',
        designation: 'Product @Chefkart | Ex Founder',
        post_link: 'https://www.linkedin.com/feed/update/urn:li:activity:7105562765301342211/?actorCompanyId=13328177',
        profile_image: 'https://assets.learntube.ai/files/certifiedOptimisation/1635805601560.webp?updatedAt=1720514690487',
        certificate_image: "https://assets.learntube.ai/files/LinkdinUsers/1694098177347.jpg?updatedAt=1698759349284",
        description: "🚀 Excited to share that I recently completed a product management certificate course! By <span style='color: #69B4FF;'>CareerNinja | LearnTube</span>\n😎 Through this program, I gained core product management skills and knowledge that I'm eager to apply.\n🤔Let me know if you'd like to connect to discuss product management practices and methodologies. I'm happy to share my learnings from the course.\n<span style='color: #69B4FF;'>Shronit Ladhani</span>",
        likes: 25,
        icon_image: (
            <div className='w-[29px] flex h-full'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={15} height={15} className='w-[15px] h-auto' alt="" />
                <img src="https://assets.learntube.ai/files/LinkdinUsers/9wt27hvi2lgll1v30u00n0p5p.svg?updatedAt=1699081182096" width={15} height={15} className='w-[15px] h-auto -ml-1.5' alt="" />
            </div>
        ),
        comments: [
            // {
            //     id: 2,
            //     user_name: "CareerNinja | LearnTube",
            //     designation: "16,718 followers",
            //     user_image: "https://assets.learntube.ai/files/LinkdinUsers/careerninja_logo.jpg?updatedAt=1698757218181",
            //     description: "Congratulations on your first milestone <span style='color: #69B4FF;'>Baibhab Pal!</span>"
            // }
        ]
    },
    {
        id: 6,
        name: 'Gajjar Mona',
        gender: '(She/Her)',
        designation: 'Student at New L.J ENG & TECH.',
        post_link: 'https://www.linkedin.com/feed/update/urn:li:activity:7091734162818146304/?actorCompanyId=13328177',
        profile_image: 'https://assets.learntube.ai/files/LinkdinUsers/1690876595417.webp?updatedAt=1725949537463',
        certificate_image: "https://assets.learntube.ai/files/LinkdinUsers/1690801179659.jpg?updatedAt=1698759757119",
        description: "I had successfully completed an extensive training program in AngularJS. Throughout the course, I demonstrated exceptional understanding and implementation of AngularJS concepts, including data binding, directives, controllers, and routing. I commitment to learning and enthusiasm for front-end development were evident in I outstanding performance and the successful completion of various hands-on projects. With this certification, I showcases a valuable skill set and is well-prepared to contribute to the development of dynamic and responsive web applications using AngularJS.\nThankyou <span style='color: #69B4FF;'>CareerNinja | LearnTube</span> to help me throughout learning",
        icon_image: (
            <div className='w-[15px] h-full mr-1'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={14} height={14} className='w-full h-auto' alt="" />
            </div>
        ),
        likes: 24,
        comments: [
            // {
            //     id: 2,
            //     user_name: "CareerNinja | LearnTube",
            //     designation: "16,718 followers",
            //     user_image: "https://assets.learntube.ai/files/LinkdinUsers/careerninja_logo.jpg?updatedAt=1698757218181",
            //     description: "Congratulations on your achievement <span style='color: #69B4FF;'>Gajjar Mona.</span> We hope you keep upskilling with LearnTube to take your career to new heights 🚀!"
            // }
        ]
    },
    {
        id: 7,
        name: 'Poonam Gambhire',
        gender: '(She/Her)',
        designation: 'Matoshri college of engineering and research centre Nashik',
        post_link: 'https://www.linkedin.com/feed/update/urn:li:activity:7092112961221124096/?actorCompanyId=13328177',
        profile_image: 'https://assets.learntube.ai/files/LinkdinUsers/1691414895232.jpg?updatedAt=1698759945239',
        certificate_image: "https://assets.learntube.ai/files/LinkdinUsers/1690891494140.jpg?updatedAt=1698760021218",
        description: "I'm happy to share that I've obtained a new certification : JAVA Introduction from <span style='color: #69B4FF;'>CareerNinja | LearnTube</span>",
        likes: 24,
        icon_image: (
            <div className='w-[15px] h-full mr-1'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={14} height={14} className='w-full h-auto' alt="" />
            </div>
        ),
        comments: [
            {
                id: 1,
                user_name: "Divya Borse",
                gender: '(She/Her)',
                user_image: "https://assets.learntube.ai/files/LinkdinUsers/1690431999406.jpg?updatedAt=1698760337072",
                designation: 'Attended Savitribai Phule Pune University',
                description: "Congratulations 🎊"
            },
            {
                id: 2,
                user_name: "Reshma Gambhire",
                gender: '(She/Her)',
                user_image: "https://assets.learntube.ai/files/certifiedOptimisation/1691414582096.webp?updatedAt=1720514690442",
                designation: 'Student at Savitribai Phule Pune University',
                description: "Nice 👍"
            }
        ]
    },
    {
        id: 8,
        name: 'Akshay Ravella',
        gender: '(He/Him)',
        designation: 'Data Science & Analytics Enthusiast || Python | SQL | Advanced Excel | Power BI | Tableau | ML',
        post_link: 'https://www.linkedin.com/feed/update/urn:li:activity:7069601251298086912/?actorCompanyId=13328177',
        profile_image: 'https://assets.learntube.ai/files/certifiedOptimisation/1689604333123.webp?updatedAt=1720514690489',
        certificate_image: "https://assets.learntube.ai/files/LinkdinUsers/image%20(1).webp?updatedAt=1725949745864",
        description: "🎉 Excited to share my latest achievement! 🎓🚀\nI'm thrilled to announce that I have successfully earned my Tableau Advanced certificate! 📊✨\nDuring this certification journey, I honed my skills in advanced data visualization, storytelling, and interactive dashboards using Tableau. I mastered the art of creating dynamic and visually appealing visualizations that effectively convey complex information in a concise and intuitive manner.\nI am grateful for the opportunity to have expanded my analytical toolkit and enhanced my data visualization skills through this certification.",
        likes: 24,
        icon_image: (
            <div className='w-[15px] h-full mr-1'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={14} height={14} className='w-full h-auto' alt="" />
            </div>
        ),
        comments: [
            // {
            //     id: 2,
            //     user_name: "CareerNinja | LearnTube",
            //     designation: "16,718 followers",
            //     user_image: "https://assets.learntube.ai/files/LinkdinUsers/careerninja_logo.jpg?updatedAt=1698757218181",
            //     description: "Congratulations on your achievement <span style='color: #69B4FF;'>Akshay Ravella</span>. We hope you keep upskilling with LearnTube to kickstart your career!"
            // }
        ]
    },
    {
        id: 9,
        name: 'Rohit Nikumbh',
        gender: '(He/Him)',
        designation: 'Mechanical Engineer | CAD Designer | Formula Student Champion | Digital Marketing',
        post_link: 'https://www.linkedin.com/feed/update/urn:li:activity:7111336933695352832/?actorCompanyId=13328177',
        profile_image: 'https://assets.learntube.ai/files/certifiedOptimisation/1696962035002.webp?updatedAt=1720514693561',
        certificate_image: "https://assets.learntube.ai/files/LinkdinUsers/1695474845305.jpg?updatedAt=1698761377324",
        description: "🚀 Exciting News! I've just completed a comprehensive digital marketing course with certification from <span style='color: #69B4FF;'>CareerNinja | LearnTube</span>, in association with Praven Rao, the marketing director of SAP .\n🎓This course has been an incredible journey, allowing me to delve deep into the world of digital marketing. I've gained expertise in various strategies, from SEO to social media marketing, and I'm thrilled to bring this knowledge to the table.\n💼 With digital marketing being at the forefront of modern business, I'm excited to apply these skills and insights to drive results and create impact. Whether you're looking to boost your online presence, engage with your target audience, or elevate your brand's digital strategy, I'm here to help!\n🙏 Huge thanks to Praven Rao for the invaluable guidance and insights throughout this course. Your expertise has been a game-changer.\n📚 Lifelong learning is a core value of mine, and I can't wait to continue expanding my knowledge in the dynamic world of digital marketing. Let's connect and explore how we can collaborate or share ideas in this exciting field.",
        likes: 17,
        icon_image: (
            <div className='w-[15px] h-full mr-1'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={14} height={14} className='w-full h-auto' alt="" />
            </div>
        ),
        comments: [
            {
                id: 1,
                user_name: "Devendra Wagh",
                gender: '(he/Him)',
                user_image: "https://assets.learntube.ai/files/certifiedOptimisation/1610471216036.webp?updatedAt=1720514690437",
                designation: 'Sr. Manager Sales and Marketing',
                description: "Congratulations <span style='color: #69B4FF;'>Rohit</span></p>"
            },
            // {
            //     id: 2,
            //     user_name: "CareerNinja | LearnTube",
            //     designation: "16,718 followers",
            //     user_image: "https://assets.learntube.ai/files/LinkdinUsers/careerninja_logo.jpg?updatedAt=1698757218181",
            //     description: "Congratulations on completing the course <span style='color: #69B4FF;'>Rohit Nikumbh!<span>"
            // }
        ]
    },
    {
        id: 10,
        name: 'Sudharshanam R',
        gender: '(He/Him)',
        designation: '--',
        post_link: 'https://www.linkedin.com/feed/update/urn:li:activity:7100824941461176320/?actorCompanyId=13328177',
        profile_image: 'https://assets.learntube.ai/files/certifiedOptimisation/1695773173560.webp?updatedAt=1720514694109',
        certificate_image: "https://assets.learntube.ai/files/certifiedOptimisation/1692968590977.webp?updatedAt=1720514690388",
        description: "Thrilled 🚀 to announce that I've successfully completed a course on Visual Design Principles in UI-UX Design.Learned the significance of color theory, typography, and spacing in crafting compelling interfaces.\n⚡Explored the balance between aesthetics and usability, ensuring every design decision enhances the user experience.\n🌟 Studied the principles of grid systems, alignment, and consistency, creating seamless and intuitive layouts.\n🔁 Embraced the iterative design process, understanding the value of feedback and refinement for a very good design💫.",
        likes: 16,
        icon_image: (
            <div className='w-[15px] h-full mr-1'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={14} height={14} className='w-full h-auto' alt="" />
            </div>
        ),
        comments: [
            // {
            //     id: 1,
            //     user_name: "YUVAN N K",
            //     gender: '(he/Him)',
            //     user_image: "https://assets.learntube.ai/files/LinkdinUsers/1666604973548.jpg?updatedAt=1698762315710",
            //     designation: 'Student at RMK ENGINEERING COLLEGE, CHENNAI',
            //     description: "Great job <span style='color: #69B4FF;'>SUDHARSHANAM R</span>"
            // },
            {
                id: 2,
                user_name: "Arsath haja Mohideen",
                gender: '(he/Him)',
                user_image: "https://assets.learntube.ai/files/certifiedOptimisation/1690823675248.webp?updatedAt=1720514690410",
                designation: 'Student at R.M.K Engineering College',
                description: "Congratulations 👏 <span style='color: #69B4FF;'>SUDHARSHANAM R</span>"
            },
        ]
    },
]

export const newLinkedInCertificateList = [
    {
        id: 1,
        name: 'Chirag Goswami',
        gender: '(He/Him)',
        designation: 'SkillUP Certified in Agile Scrum Master & Agile Scrum Foundation | Product Analyst',
        post_link: "https://www.linkedin.com/feed/update/urn:li:activity:7202919317305270272/?actorCompanyId=13328177",
        profile_image: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/qS4SCe0129PVcFwjZgFEEWqVylA/QXR04g../1632225421959.jpg',
        certificate_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/AJMC4ibbFK75DDvpGHHrOZfJ9Oc/o0UhlQ../1717309787006.jpg",
        description: "I am excited to share my latest achievement - just received my certificate in Business Analyst Assessment! 🎓🎉 Posting it here to showcase my dedication to continuous learning and professional growth. \nThank you LearnTube.ai \n hashtag#certificate hashtag#professionaldevelopment hashtag#neverstoplearning hashtag#careeradvancement hashtag#skillsboost hashtag#achievementunlocked hashtag#proudmoment hashtag#LinkedIn",
        likes: 36,
        icon_image: (
            <div className='flex items-center'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={14} height={14} className='' alt="" />
                <img src="https://assets.learntube.ai/files/LinkdinUsers/9wt27hvi2lgll1v30u00n0p5p.svg?updatedAt=1699081182096" width={14} height={14} className='-ml-0.5' alt="" />
                <img src="https://assets.learntube.ai/files/post-payment-updates/esahr356vrv0vklww6hcjar1j.svg?updatedAt=1730104591454" width={14} height={14} className='-ml-0.5' alt="" />
            </div>
        ),
        comments: [
            {
                id: 1,
                user_name: "LearnTube.ai",
                gender: '(He/Him)',
                user_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/I4_nqM2rRm2KiHVS7Dzl6dm4G88/HR9jbg../careerninja_logo.jpg",
                designation: '25,722 followers',
                description: "Congratulations on your achievement Chirag Goswami! Look forward to seeing you continue to grow in your career. \nWould love to have you share more about your experience with LearnTube🙂"
            },
            {
                id: 2,
                user_name: "Ritik Bansal",
                gender: '(He/Him)',
                user_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/1tfGxG8jpiPM2h4KGXxN2k0VRmQ/iHik-A../1729407598455.jpg",
                designation: 'Devops Engineer',
                description: "Congratulations!"
            },
        ]
    },
    {
        id: 2,
        name: 'Mayank Gubrele',
        gender: '(He/Him)',
        designation: 'Strategic Alliances & Partnerships I Sales & Marketing operations , all things business',
        post_link: "https://www.linkedin.com/feed/update/urn:li:activity:7203654463641849859/?actorCompanyId=13328177",
        profile_image: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/KtOwSZQuFUR63c9DG4beEUDlWug/9GAFSw../1642596833933.jpg',
        certificate_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/7suDuVghUgAFEGXEcaT8pQ4Vi0o/tmqg-w../Screenshot+2024-10-29+120550.png",
        description: "In today's fast-paced world, staying updated and continuously enhancing our skill sets is crucial for both personal and professional development. I'm excited to share that I've recently completed a certification in Project Management Assessment from LearnTube.ai \nLooking forward to applying these new skills and and continuing this journey of growth and learning. \n#ContinuousLearning #Upskilling #ProfessionalDevelopment #LifelongLearning #Certification #CareerGrowth",
        likes: 37,
        icon_image: (
            <div className='flex items-center'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={14} height={14} className='w-full h-auto' alt="" />
                <img src="https://assets.learntube.ai/files/LinkdinUsers/9wt27hvi2lgll1v30u00n0p5p.svg?updatedAt=1699081182096" width={14} height={14} className='w-full h-auto -ml-0.5' alt="" />
            </div>
        ),
        comments: [
            {
                id: 1,
                user_name: "Kushal Pratap Singh",
                gender: '(He/Him)',
                user_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/7U8nxoAVxtPnfhMoCWJ-MrxpTW8/1-CHWg../1721622399824.jpg",
                designation: 'Assistant Manager | Franchise Support Manager @ DBMCI | eGurukul Official',
                description: "Congratulations Mayank Sir 🎉"
            },
            {
                id: 2,
                user_name: "Raj Chaubey",
                gender: '(He/Him)',
                user_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Fb287AzU0Si4kMZCcw63cbOoTqc/byGfyw../1709896655244.jpg",
                designation: 'Business Development Manager at Primathon Academy | Building Primathon Technologies',
                description: "Congratulations 🎉"
            },
        ]
    },
    {
        id: 3,
        name: 'Mohit Sheelwant',
        gender: '(He/Him)',
        designation: "Financial Consultant specializing in Financial Planning at @HDFC Life || CFA L-1 Candidate|| DU'24",
        post_link: "https://www.linkedin.com/feed/update/urn:li:activity:7206206405110894592/?actorCompanyId=13328177",
        profile_image: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/QxUIpeKAHP1el8rbb8CC7Fwjo-E/Wv7s7g../1720730906191.jpg',
        certificate_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/9uFk0OHvZBjH0jZYkeSuqOfFmnk/SQS1NA../1719101581608.jpg",
        description: "I am very happy to announce that, I have successfully completed the certification course 'Power Bi' which is conducted by LearnTube.ai under the mentorship of Shronit Ladhani. I'm convinced that I would have progressed and learnt in pretty good time. Thanking LearnTube.ai and mentor Shronit Ladhani sir for training me in my journey. \n#PowerBi #charts #learning #careerdevelopment #dataanalystics #thankyou",
        likes: 9,
        icon_image: (
            <div className='flex items-center'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={14} height={14} className='w-full h-auto' alt="" />
            </div>
        ),
        comments: [
            {
                id: 1,
                user_name: "LearnTube.ai",
                gender: '(He/Him)',
                user_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/I4_nqM2rRm2KiHVS7Dzl6dm4G88/HR9jbg../careerninja_logo.jpg",
                designation: '25,722 followers',
                description: "Congratulations on your achievement Mohit Sheelwant! Look forward to seeing you continue to grow in your career. Would love to have you share more about your experience with LearnTube😄"
            },
            {
                id: 2,
                user_name: "Sunil Soni",
                gender: '(He/Him)',
                user_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Odr6rAoULcd9obBWHmM_d1moHe0/LDlWoQ../1713441409872.jpg",
                designation: 'Account Controlar and Book keeping',
                description: "Great to hear"
            },
        ]
    },
    {
        id: 4,
        name: 'Sinchana S Rao',
        gender: '(She/Her)',
        designation: "Student at Srinivas Institute of Technology, Mangalore",
        post_link: "https://www.linkedin.com/feed/update/urn:li:activity:7213186153569497088/?actorCompanyId=13328177",
        profile_image: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/KZNTaI_8dSy3XZ-8odNnxKuMG0Y/x-y5Kw../1723828744173.jpg',
        certificate_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/a6bbgRhJ8SgXBKRMRqDYSso18ho/MuuMRg../1719757592115.jpg",
        description: "LearnTube.ai\n Thrilled to have completed my internship at learntube and received a certificate in Java \nSo this was actually a assessment based task which i got suggested in instagram page so i decided to try once🙂‍↕️and here i received a certificate too which i am really happy for🤩\nSo trying new things or suggested internships are the opportunity that we get….so using it in a right way helps us to build our knowledge even more",
        likes: 20,
        icon_image: (
            <div className='flex items-center'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={14} height={14} className='w-full h-auto' alt="" />
                <img src="https://assets.learntube.ai/files/LinkdinUsers/9wt27hvi2lgll1v30u00n0p5p.svg?updatedAt=1699081182096" width={14} height={14} className='w-full h-auto -ml-0.5' alt="" />
            </div>
        ),
        comments: [
            {
                id: 1,
                user_name: "LearnTube.ai",
                gender: '(He/Him)',
                user_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/I4_nqM2rRm2KiHVS7Dzl6dm4G88/HR9jbg../careerninja_logo.jpg",
                designation: '25,722 followers',
                description: "Congratulations on your achievement Suvanjita Das! Look forward to seeing you continue to grow in your career. \nWould love to have you share more about your experience with LearnTube🙂"
            }
        ]
    },
    {
        id: 5,
        name: 'Suvanjita Das',
        gender: '(She/Her)',
        designation: "HYLP’24, Havells India Ltd. | PGDM-Marketing | Infrastructure & Discipline Secretary, SAWC | IMT Ghaziabad’24 | National Pre-Finalist, Tata Steel-a-thon’23 | Ex - Vedanta Aluminium Ltd. | IGIT Sarang'19",
        post_link: "https://www.linkedin.com/feed/update/urn:li:activity:7221923731944742912/?actorCompanyId=13328177",
        profile_image: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/kzyUNzxcDNBk_WyGw0R6_tiJWZk/eWoLKw../1712202650974.jpg',
        certificate_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/G7SgrY1QA7rLRpXx5NPFBjPe40Y/PlQ9_w../1721840793545.jpg",
        description: "I'm thrilled to announce that I've officially passed the Data Analytics Assessment by LearnTube.ai ! This certification is a testament to my dedication to data analytics and I'm excited to apply my new skills to drive impactful insights. \n#dataanalytics #certified #newskills #grow #data #analysis",
        likes: 32,
        icon_image: (
            <div className='flex items-center'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={14} height={14} className='w-full h-auto -ml-0.5' alt="" />
            </div>
        ),
        comments: [
            {
                id: 1,
                user_name: "LearnTube.ai",
                gender: '(He/Him)',
                user_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/I4_nqM2rRm2KiHVS7Dzl6dm4G88/HR9jbg../careerninja_logo.jpg",
                designation: '25,722 followers',
                description: "Congratulations on your achievement Sinchana S Rao! Look forward to seeing you continue to grow in your career. \nWould love to have you share more about your experience with LearnTube🙂"
            }
        ]
    },
    {
        id: 6,
        name: 'Shubham Joshi ',
        gender: '(He/Him)',
        designation: "Summer Intern @ONGC || Final Year Chemical Engineering Student || Winner of Hom-E-Chem || Vice President, AIChE GSFCU SC|| Featured in a Bimonthly Newsletter ||",
        post_link: "https://www.linkedin.com/feed/update/urn:li:activity:7217918228235210752/?actorCompanyId=13328177",
        profile_image: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/f93O9ro_fiPOI3MnIQaxcmB44WM/fuoxSA../1723793291179.jpg',
        certificate_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/MyvBBjFBlHc00zZzjpvBWZ_4BJ8/IqCcTQ../1720885806373.jpg",
        description: "In today's data-driven world, Data is a hidden mine, and Data Analytics is the key that unlocks its treasures! \nI am elated to apprise that I am now Certified in Data Analytics Assessment by LearnTube.ai \nAttributable to LearnTube.ai for providing an inclusive and engaging experiential learning opportunity. \n#DataDrivenWorld\n#DataAnalytics\n#Certified\n#SkillsEnhancement\n#ResourcefulDataManagement",
        likes: 26,
        icon_image: (
            <div className='flex items-center'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={14} height={14} className='w-full h-auto' alt="" />
                <img src="https://assets.learntube.ai/files/LinkdinUsers/9wt27hvi2lgll1v30u00n0p5p.svg?updatedAt=1699081182096" width={14} height={14} className='w-full h-auto -ml-0.5' alt="" />
            </div>
        ),
        comments: [
            {
                id: 1,
                user_name: "LearnTube.ai",
                gender: '(He/Him)',
                user_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/I4_nqM2rRm2KiHVS7Dzl6dm4G88/HR9jbg../careerninja_logo.jpg",
                designation: '25,722 followers',
                description: "Congratulations on your achievement Sinchana S Rao! Look forward to seeing you continue to grow in your career. \nWould love to have you share more about your experience with LearnTube🙂"
            },
            {
                id: 2,
                user_name: "Riddhi Soni",
                gender: '(She/Her)',
                user_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/8wwI7Do2rCbfavdTTuwX84yjINI/ubmxUg../1701084834444.jpg",
                designation: 'Graduate Environment Consultant at Arcadis',
                description: "Well done!"
            }
        ]
    },
    {
        id: 7,
        name: 'Dhaneshwar PatidarDhaneshwar Patidar',
        gender: '(He/Him)',
        designation: "Senior Visual Designer @ JetSynthesys Pvt. Ltd. | Artwork, Creative Design",
        post_link: "https://www.linkedin.com/feed/update/urn:li:activity:7228998956771328000/?actorCompanyId=13328177",
        profile_image: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/Y9xBRfNuEtsg9Et5sEbTn6osPqU/FXJFng../1689107997844.jpg',
        certificate_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/FgFUL9jIDPKKANXECMaQfdGKwHE/WFch_w../1723527658526.jpg",
        description: "Excited to share that I've completed my UI/UX certification from LearnTube.ai \nThis certification has not only enhanced my skills in creating user-centered designs but also deepened my understanding of the latest industry trends and best practices. \nI'm eager to apply my knowledge and expertise to deliver exceptional user experiences and drive business success.\nThanks to LearnTube.ai for the opportunity to grow and develop my skills!\n#UIUXCertification #LearnTube #UserExperience #UserInterface #DesignCertification #CareerGrowth #SkillDevelopment",
        likes: 15,
        icon_image: (
            <div className='flex items-center'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={14} height={14} className='w-full h-auto' alt="" />
            </div>
        ),
        comments: [
            {
                id: 1,
                user_name: "LearnTube.ai",
                gender: '(He/Him)',
                user_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/I4_nqM2rRm2KiHVS7Dzl6dm4G88/HR9jbg../careerninja_logo.jpg",
                designation: '25,722 followers',
                description: "Congratulations on your achievement Dhaneshwar Patidar! Look forward to seeing you continue to grow in your career. \nWould love to have you share more about your experience with LearnTube🙂"
            }
        ]
    },
    {
        id: 8,
        name: 'Kirti Raj',
        gender: '(He/Him)',
        designation: "Project Analyst at PHOTON",
        post_link: "https://www.linkedin.com/feed/update/urn:li:activity:7229062750243545088/?actorCompanyId=13328177",
        profile_image: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/mmUZp-8PqYMx9Is23YhGycljwGk/OqRWTg../1705245223398.jpg',
        certificate_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/dC_ZqMg0BUp8LyHA29RwZrSRKw4/gT67pA../1723542868074.jpg",
        description: "I'm thrilled to share that I've successfully completed my Project Management Assessment! 🎉📈\nThis milestone marks a significant step in enhancing my skills and knowledge in project management.\nA huge thank you to everyone who supported me through this journey. Your encouragement and insights made all the difference. 🙌\nLooking forward to applying these new skills to drive even more successful projects and contribute to our team's goals. Onward and upward! 🚀💼\n#ProjectManagement #ProfessionalDevelopment #Success #ContinuousLearning #CareerGrowth",
        likes: 45,
        icon_image: (
            <div className='flex items-center'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={14} height={14} className='w-full h-auto' alt="" />
                <img src="https://assets.learntube.ai/files/LinkdinUsers/9wt27hvi2lgll1v30u00n0p5p.svg?updatedAt=1699081182096" width={14} height={14} className='w-full h-auto -ml-0.5' alt="" />
            </div>
        ),
        comments: [
            {
                id: 1,
                user_name: "Salil Banerjee",
                gender: '(He/Him)',
                user_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/UEN99MWmIMtSIhrgJzWu29YE6io/2Li-hw../1700212423876.jpg",
                designation: 'Having hunger to learn and upskill An aspiring Data Analyst | Data Enthusiast | Data Analysis | Python | EDA | PowerBI/Tableau | SQL with a background in HR',
                description: "Congratulations Kirti"
            },
            {
                id: 2,
                user_name: "satyanshu kumar",
                gender: '(He/Him)',
                user_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/qscb7-0SvBCKZTzVYBrzW8nOuBQ/7liPKg../1692721847272.jpg",
                designation: 'Assistant Professor at Shri Mata Vaishno Devi University',
                description: "Congratulations"
            }
        ]
    },
    {
        id: 9,
        name: 'Arpita Datta',
        gender: '(She/Her)',
        designation: "Regional Manager @ Caratlane | Lenskart | PepeJeans | Levi's",
        post_link: "https://www.linkedin.com/feed/update/urn:li:activity:7232600459503398914/?actorCompanyId=13328177",
        profile_image: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/p2tWX9glVSDV58wAe5EBctKElUo/PyrSmg../1723299825277.jpg',
        certificate_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/esqtZ_F9wGm5ZNmYG-xU_LS5IWs/GzPOqA../1724386322927.jpg",
        description: "Hey Everyone!\nI am thrilled to announce that I have just completed my Six Sigma Assessment test with LearnTube.ai.\nThank you LearnTube!! \n#SixSigma #ProcessImprovement #QualityManagement #Certification #ProfessionalDevelopment #BusinessExcellence",
        likes: 59,
        icon_image: (
            <div className='flex items-center'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={14} height={14} className='w-full h-auto' alt="" />
                <img src="https://assets.learntube.ai/files/LinkdinUsers/9wt27hvi2lgll1v30u00n0p5p.svg?updatedAt=1699081182096" width={14} height={14} className='w-full h-auto -ml-0.5' alt="" />
                <img src="https://assets.learntube.ai/files/post-payment-updates/esahr356vrv0vklww6hcjar1j.svg?updatedAt=1730104591454" width={14} height={14} className='w-full h-auto -ml-0.5' alt="" />
            </div>
        ),
        comments: [
            {
                id: 1,
                user_name: "Basavaraj M",
                gender: '(He/Him)',
                user_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/p_8FfZGmeAAupc5pgHUZWB_0Z6U/Fges2A../1600424264686.jpg",
                designation: 'Lenskart.com | Aditya Birla Groups | Amazon | More Retail | Coffee Day Global Ltd.| Abctcl',
                description: "Congratulations 👏"
            },
            {
                id: 2,
                user_name: "Aniket Pande",
                gender: '(He/Him)',
                user_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/3N-pxJ0COSl3aaQQ4TRwXixmDbs/I-1V9w../1612385151727.jpg",
                designation: 'SCM manager with an experience in Flipkart Health Plus( SastaSundar Health & Happiness), Flipkart, United Colors of Benetton, BIBA Apparels . Well expert in Last Mile operations, Hub Management , Warehouse Operations,',
                description: "Well done Arpita"
            }
        ]
    },
    {
        id: 10,
        name: 'Indrajit Banerjee',
        gender: '(He/Him)',
        designation: "Top Voice || Assistant Vice President || Zonal Head- Vigilance || Data Analytics & Critical Thinking badges || Six Sigma-Green Belt || Post Graduate in Banking Operations || IIBF Certified || ChatGpt and AI hacks",
        post_link: "https://www.linkedin.com/posts/indrajit-banerjee-60983b53_careerninja-leansixsigma-ai-activity-7245848442294484992-dihn/?utm_source=share&utm_medium=member_desktop",
        profile_image: 'https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/DsL3Ujb9P3rvFE1PXhd_qLXD78k/P5To-Q../1669960068771.jpg',
        certificate_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/OMQd6YjJlLLKtsSxA5tCVKvI8I0/c5tNSg../1727544888530.jpg",
        description: "Thrilled to share that I've earned my Certified Six Sigma Assessment from LearnTube.ai by hashtag#CareerNinja\nAs a seasoned Process Improvement Expert, Data-Driven Problem Solver, and Collaboration Leader, I harness the power of Six Sigma methodologies and AI-driven insights to:\nOptimize processes\nBoost efficiency\nDrive business excellence\nEquipped with cutting-edge expertise, I'm committed to delivering exceptional results. Let's streamline processes and achieve success together!\n#LeanSixSigma #AI #ProcessImprovement #DataDriven #BusinessExcellence #Certified #ProcessOptimization",
        likes: 42,
        icon_image: (
            <div className='flex items-center'>
                <img src="https://assets.learntube.ai/files/LinkdinUsers/emei2gdl9ikg7penkh9ij9llx.svg?updatedAt=1699081182178" width={14} height={14} className='w-full h-auto' alt="" />
                <img src="https://assets.learntube.ai/files/LinkdinUsers/9wt27hvi2lgll1v30u00n0p5p.svg?updatedAt=1699081182096" width={14} height={14} className='w-full h-auto -ml-0.5' alt="" />
            </div>
        ),
        comments: [
            {
                id: 1,
                user_name: "Surya Prakash Singh",
                gender: '(He/Him)',
                user_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/omCiCXHfNka3kpmEYhgJCMqoscc/3ZGALg../1714716597726.jpg",
                designation: 'Vigilance & Fraud control #Raipur #chhattishgarh',
                description: "One more added,  congrats 💐🥳"
            },
            {
                id: 2,
                user_name: "Alok Tiwari",
                gender: '(He/Him)',
                user_image: "https://xgfy-czuw-092q.m2.xano.io/vault/OXY-0ZPV/4rR3af7ps7HI4iChWONLKyil8GQ/I5eb5w../1681416424740.jpg",
                designation: 'Auditor at Fusion Finance Limited',
                description: "Congrats sir.... 💐"
            }
        ]
    },
]

export const timeFormat = (time) => {
    let minutes = Math.floor(time / 60)
    let seconds = time % 60

    return minutes === 0 ? `${seconds}s` : `${minutes}m ${seconds}s`
}

export const packUsers = [
    {
        name: 'Kevin Thomas',
        pack: 'Beginner Pack',
        image: 'https://assets.learntube.ai/files/certified%20app/man2.jpg?updatedAt=1713178941231',
        description: 'LearnTube boosted my confidence & I gave job interviews that really helped me secure a Career in Data Analysis.'
    },
    {
        name: 'Amrita',
        pack: 'Beginner Pack',
        image: 'https://assets.learntube.ai/files/certified%20app/woman2.jpg?updatedAt=1713178941830',
        description: 'I was looking for Certificates to boost my chances of landing a job and Learntubeʼs beginner pack became my ultimate savior.'
    },
    {
        name: 'Shraddha Rao',
        pack: 'Intermediate Pack',
        image: 'https://assets.learntube.ai/files/certified%20app/woman3.jpg?updatedAt=1713178941485',
        description: 'This pack gave me Basic to Advanced skills and boosted my career opportunities.'
    },
    {
        name: 'Rhea Sharma',
        pack: 'Intermediate Pack',
        image: 'https://assets.learntube.ai/files/certified%20app/woman1.jpg?updatedAt=1713178941627',
        description: 'LearnTube Helped me improving my practical skills I was struggling with in my first job.'
    },
    {
        name: 'Zain Shaikh',
        pack: 'Intermediate Pack',
        image: 'https://assets.learntube.ai/files/certified%20app/woman5.jpg?updatedAt=1713178940631',
        description: 'LearnTube helped with restart my career with practical skills after my gap.'
    },
    {
        name: 'Jennifer',
        pack: 'Intermediate Pack',
        image: 'https://assets.learntube.ai/files/certified%20app/woman4.jpg?updatedAt=1713178941953',
        description: 'The Intermediate Pack provided me with practical skills and boosted my confidence in my job applications.'
    },
    {
        name: 'Sameer Singh',
        pack: 'Advanced Pack',
        image: 'https://assets.learntube.ai/files/certified%20app/man5.jpg?updatedAt=1713178942754',
        description: 'With help of LearnTubeʼs Advanced Pack, I was able to secure multiple job offers at same time.'
    },
    {
        name: 'Dhruv Rathi',
        pack: 'Advanced Pack',
        image: 'https://assets.learntube.ai/files/certified%20app/man1.jpg?updatedAt=1713178942751',
        description: 'With the placement support, I was able to recognize my faults and improve them which led me to secure my first Job.'
    },
    {
        name: 'Shahmeer',
        pack: 'Advanced Pack',
        image: 'https://assets.learntube.ai/files/certified%20app/man4.jpg?updatedAt=1713178942484',
        description: 'Within a short period, I not only secured multiple job offers but also negotiated a higher salary with help of LearnTubeʼs Advanced Pack.'
    },
    {
        name: 'Siya Bose',
        pack: 'Advanced Pack',
        image: 'https://assets.learntube.ai/files/certified%20app/man3.jpg?updatedAt=1713178942481',
        description: 'This acted as an all rounder course for me & helped me secure my first internship at Microsoft.'
    },
]

export const similarAchievementSection = [
    {
        name: 'Rajesh Jha',
        image: 'https://assets.learntube.ai/files/post-payment-updates/00d94417b512d7695c3810e48b7c4156.jpg?updatedAt=1728115347532',
        text: <p className='text-sm text-white/70 mt-3'>Our <span className='text-span_color font-medium'>Fastest Hire</span> secured a job in just <span className='text-white font-medium'>15 days!</span></p>
    },
    {
        name: 'Preeti K',
        image: 'https://assets.learntube.ai/files/post-payment-updates/images%20(3).jpg?updatedAt=1728115384223',
        text: <p className='text-sm text-white/70'>Landed a job with a <span className='text-span_color font-medium'>top salary</span> of <span className='text-white font-medium'>34 LPA!</span></p>
    },
    {
        name: 'Om Kumar',
        image: 'https://assets.learntube.ai/files/post-payment-updates/Frame%20427318933.svg?updatedAt=1728115483614',
        text: <p className='text-sm text-white/70 mt-3'><span className='text-span_color font-medium'>Secured interviews</span> in top 3 <span className='text-white font-medium'>major companies.</span></p>
    },
    {
        name: 'Rhea Prakash',
        image: 'https://assets.learntube.ai/files/post-payment-updates/images%201.png?updatedAt=1728115538513',
        text: <p className='text-sm text-white/70 mt-3'>Project got <span className='text-span_color font-medium'>recognised</span> by <span className='text-white font-medium'>5+ employers.</span></p>
    },
    {
        name: 'Vidya Shetty',
        image: 'https://assets.learntube.ai/files/post-payment-updates/ai-generated-indian-female-student-free-photo%201.png?updatedAt=1728115709187',
        text: <p className='text-sm text-white/70 mt-3'>Project got <span className='text-span_color font-medium'>recognised</span> by <span className='text-white font-medium'>5+ employers.</span></p>
    },
    {
        name: 'Shloka Sen',
        image: 'https://assets.learntube.ai/files/post-payment-updates/k1Ty02QOSpKu7MP7wwWA_3ZNmkramQw8ek9w8.jpg?updatedAt=1728115764364',
        text: <p className='text-sm text-white/70 mt-3'>Landed a job with a <span className='text-span_color font-medium'>top salary</span> of <span className='text-white font-medium'>32 LPA!</span></p>
    },
    {
        name: 'Sahil Jain',
        image: 'https://assets.learntube.ai/files/post-payment-updates/download.jpg?updatedAt=1728115820519',
        text: <p className='text-sm text-white/70 mt-3'>Our <span className='text-span_color font-medium'>Fastest Hire</span> secured a job in just <span className='text-white font-medium'>15 days!</span></p>
    },
    {
        name: 'Sourav Sharma',
        image: 'https://assets.learntube.ai/files/post-payment-updates/Frame%20427318933.png?updatedAt=1728115619192',
        text: <p className='text-sm text-white/70 mt-3'><span className='text-span_color font-medium'>Secured interviews</span> in top 3 <span className='text-white font-medium'>major companies.</span></p>
    },
    {
        name: 'Sejal Arora',
        image: 'https://assets.learntube.ai/files/post-payment-updates/DfJ1xHgWkAAvyrR.jpg?updatedAt=1728115880649',
        text: <p className='text-sm text-white/70 mt-3'>Project got <span className='text-span_color font-medium'>recognised</span> by <span className='text-white font-medium'>5+ employers.</span></p>
    },
    {
        name: 'Sameer Shah',
        image: 'https://assets.learntube.ai/files/post-payment-updates/Frame%20427318933.png?updatedAt=1728115619192',
        text: <p className='text-sm text-white/70 mt-3'>Landed a job with a <span className='text-span_color font-medium'>top salary</span> of <span className='text-white font-medium'>28 LPA!</span></p>
    } 
]

export const formatDate = (date) => {

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    
    let hours = date.getHours()
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12 || 12
    
    const day = date.getDate()
    const month = months[date.getMonth()]
    const time = `${hours}:${minutes} ${ampm}`
    
    return `${month} ${day}, ${time}`
}

export const newLinkedData = [
    {
        name: 'Lucas Peterson',
        image: 'https://assets.learntube.ai/files/Global/Frame%20427320472.png?updatedAt=1743507708712',
        experience: '11+ Yrs. of Exp.',
        designation: 'Senior Financial Officer',
        company: 'Goldman Sachs',
        companyImage: 'https://assets.learntube.ai/files/Global/Icon.jpeg%20(1).png?updatedAt=1743507832859',
        post: false,
        certification: 'Financial Advisory and Portfolio Management',
        issuedOn: 'Issued March 2024',
        certificateId: 'Credential ID DJA-B-1-1128054-0',
        certificateImage: 'https://assets.learntube.ai/files/Global/Group%2023062.png?updatedAt=1743508019283',
        linkedInProfile: 'https://www.linkedin.com/in/aarti-j-60b426164/',
        location: 'San Francisco, USA'
    },
    {
        name: 'Chen Wei',
        image: 'https://assets.learntube.ai/files/Global/depositphotos_716181762-stock-photo-smiling-positive-young-asian-man%201.png?updatedAt=1743508408316',
        experience: '7+ Yrs. of Exp.',
        designation: 'Blockchain Engineer',
        company: 'Amazon',
        companyImage: 'https://assets.learntube.ai/files/Global/Frame%20427321124.png?updatedAt=1743508123704',
        post: true,
        description: 'Blockchain Engineer @Amazon',
        certificateImage: 'https://assets.learntube.ai/files/Global/Group%2023064.png?updatedAt=1743508124388',
        linkedInProfile: 'https://www.linkedin.com/posts/vellala-somanath-5b801942_im-happy-to-share-that-ive-obtained-a-new-activity-7238574617974521856-XtkI?utm_source=share&utm_medium=member_desktop&rcm=ACoAADYojcgBM3pyrmvqRl0dKq1dXRyqHTEIoSI',
        location:'New York, USA',
        likes: 5,
        comments: 3,
        commentsThread: [
            {
                image: 'https://assets.learntube.ai/files/New%20Analysis%20Page/careerninja_logo.jpg?updatedAt=1742287671708',
                name: 'LearnTube.ai',
                designation: '29,234 followers',
                comment: <span >Congratulations on your achievement <span className='font-semibold text-border'>Vellala Lalitha Somanath!</span> Look forward to seeing you continue to grow in your career. Would love to have you share more about your experience with LearnTube😃</span>
            },
            {
                image: 'https://assets.learntube.ai/files/New%20Analysis%20Page/1709633992932.jpg?updatedAt=1742287413788',
                name: 'Madhavan Raman',
                designation: "Fellow at NxtWave's CCBP Academy |Pre Final Year Student at SRM University |Knows C C++ Java Python Js Dynamic Website Development |Studying at NxtWave's to upgrade my knowledge and skills |Looking For Internships |",
                comment: 'Wonderful!'
            }
        ]
    },
    {
        name: 'Isabella Oliveira',
        image: 'https://assets.learntube.ai/files/Global/Frame%20427320472%20(2).png?updatedAt=1743508615241',
        experience: '8+ Yrs. of Exp.',
        designation: 'Marketing Strategist',
        company: 'JPMorgan Chase & Co.',
        companyImage: 'https://assets.learntube.ai/files/Global/Icon.jpeg%20(2).png?updatedAt=1743508615428',
        post: false,
        certification: 'Remarketing & Growth Hacking',
        issuedOn: 'Issued Nov 2024',
        certificateId: 'Credential ID DJA-B-1-1128139-0',
        certificateImage: 'https://assets.learntube.ai/files/Global/Group%2023068.png?updatedAt=1743508615782',
        linkedInProfile: 'https://www.linkedin.com/posts/vaskar-das-757ab621a_im-happy-to-share-that-ive-obtained-a-new-activity-7231944960042762241-Rs_p?utm_source=share&utm_medium=member_desktop&rcm=ACoAADYojcgBM3pyrmvqRl0dKq1dXRyqHTEIoSI',
        location:'Dallas, TX'
    },
    {
        name: 'Fatima Diallo',
        image: 'https://assets.learntube.ai/files/Global/1660360715994%201.png?updatedAt=1743508880203',
        experience: '14+ Yrs. of Exp.',
        designation: 'Project Manager',
        company: 'SpaceX',
        companyImage: 'https://assets.learntube.ai/files/Global/Frame%20427321123.png?updatedAt=1743508880478',
        post: true,
        description: "Project Manager | Agile & Scrum Certified | Driving Digital Transformation",
        certificateImage: 'https://assets.learntube.ai/files/Global/Group%2023065.png?updatedAt=1743508880659',
        linkedInProfile: 'https://www.linkedin.com/posts/abhijeet-satapathy-49526915b_im-happy-to-share-that-ive-obtained-a-new-activity-7229152585784389633-PFyX?utm_source=share&utm_medium=member_desktop&rcm=ACoAADYojcgBM3pyrmvqRl0dKq1dXRyqHTEIoSI',
        location: 'Seattle, WA',
        likes: 31,
        comments: 10,
        commentsThread: [
            {
                image: 'https://assets.learntube.ai/files/New%20Analysis%20Page/careerninja_logo.jpg?updatedAt=1742287671708',
                name: 'LearnTube.ai',
                designation: '29,234 followers',
                comment: <span>Congratulations on your achievement <span className='font-semibold text-border'>Abhijeet Satapathy!</span> Look forward to seeing you continue to grow in your career. Would love to have you share more about your experience with LearnTube🙂</span>
            }
        ]

    },
    {
        name: 'Carlos Rodríguez',
        image: 'https://assets.learntube.ai/files/Global/Frame%20427320472%20(4).png?updatedAt=1743509098192',
        experience: '10+ Yrs. of Exp',
        designation: 'AWS Developer',
        company: 'IBM',
        companyImage: 'https://assets.learntube.ai/files/Global/ibm_security_icon.jpeg.png?updatedAt=1743509098045',
        post: false,
        certification: 'Amazon Web Services Database',
        issuedOn: 'Issued Jan 2025',
        certificateId: 'Credential ID DJA-B-1-1128202-0',
        certificateImage: 'https://assets.learntube.ai/files/Global/Group%2023067.png?updatedAt=1743509098361',
        linkedInProfile: 'https://www.linkedin.com/posts/rushikeshpurat_learntube-careerninja-activity-7239156048551399424-iKsq?utm_source=share&utm_medium=member_desktop&rcm=ACoAADYojcgBM3pyrmvqRl0dKq1dXRyqHTEIoSI',
        location: 'Johannesburg, South Africa'
    },
    {
        name: 'Aisha Mohammed',
        image: 'https://assets.learntube.ai/files/Global/1726142277206%201.png?updatedAt=1743509300665',
        experience: '6+ Yrs. of Exp.',
        designation: 'AI Research Scientist',
        company: 'Open AI',
        companyImage: 'https://assets.learntube.ai/files/New%20Analysis%20Page/citi_logo%201.png?updatedAt=1742280877337',
        post: true,
        description: "AI Research Scientist | NLP & Computer Vision | Tech Speaker",
        certificateImage: 'https://assets.learntube.ai/files/Global/Certificate%20(25)%201.png?updatedAt=1743509301154',
        linkedInProfile: 'https://www.linkedin.com/posts/venkatesh-kumar-77898b192_thanks-learntubeai-activity-7230456750179540993-Zmlx?utm_source=share&utm_medium=member_desktop&rcm=ACoAADYojcgBM3pyrmvqRl0dKq1dXRyqHTEIoSI',
        location: 'San Francisco, USA',
        likes: 23,
        comments: 7,
        commentsThread: [
            {
                image: 'https://assets.learntube.ai/files/New%20Analysis%20Page/careerninja_logo.jpg?updatedAt=1742287671708',
                name: 'LearnTube.ai',
                designation: '29,234 followers',
                comment: <span>Congratulations on your achievement <span className='font-semibold text-border'>Venkatesh Kumar!</span> Look forward to seeing you continue to grow in your career. Would love to have you share more about your experience with LearnTube🙂</span>
            },
            {
                image: 'https://assets.learntube.ai/files/New%20Analysis%20Page/1739604063210.jpg?updatedAt=1742288730548',
                name: 'Senthil Vel Sivaraj',
                designation: 'Systems Engineer| Reconciliation Developer',
                comment: "Congratulations Venky!!"
            },
        ]
    },
    {
        name: 'Joshua Thompson',
        image: 'https://assets.learntube.ai/files/Global/Frame%20427320472%20(6).png?updatedAt=1743509557290',
        experience: '8+ Yrs. of Exp.',
        designation: 'Financial Services Project Manager',
        company: 'Standard Bank',
        companyImage: 'https://assets.learntube.ai/files/Global/standard_bank_group_icon.jpeg.png?updatedAt=1743509558198',
        post: false,
        certification: 'Chartered Financial Analyst (CFA)',
        issuedOn: 'Issued Sept 2024',
        certificateId: 'Credential ID DJA-B-1-1128818-0',
        certificateImage: 'https://assets.learntube.ai/files/Global/Group%2023069.png?updatedAt=1743509557523',
        linkedInProfile: 'https://www.linkedin.com/posts/akshay-betkar-2155263b_careernija-activity-7230764087444443136-Mb0a?utm_source=share&utm_medium=member_desktop&rcm=ACoAADYojcgBM3pyrmvqRl0dKq1dXRyqHTEIoSI',
        location:"Mexico City",
    },
    {
        name: 'Dr. Chidiebere M Ogbodo',
        image: 'https://assets.learntube.ai/files/Global/Frame%20427320472%20(7).png?updatedAt=1743509807556',
        experience: '14+ Yrs. of Exp.',
        designation: 'EVP of Project Management',
        company: 'Dexciss Technology',
        companyImage: 'https://assets.learntube.ai/files/Global/dexciss_technology_logo%201.png?updatedAt=1743509807824',
        post: true,
        description: "Co-Founder & EVP Projects @Dexciss.com | Salesforce & SAP Partner | HBR Advisory ",
        certificateImage: 'https://assets.learntube.ai/files/Global/1716636125869%201.png?updatedAt=1743509808357',
        linkedInProfile: 'https://www.linkedin.com/posts/arpita-datta-22031569_sixsigma-processimprovement-qualitymanagement-activity-7232600459503398914--unD?utm_source=share&utm_medium=member_desktop&rcm=ACoAADYojcgBM3pyrmvqRl0dKq1dXRyqHTEIoSI',
        location: 'New York, USA',
        likes: 23,
        comments: 7,
        commentsThread: [
            {
                image: 'https://assets.learntube.ai/files/New%20Analysis%20Page/1592060946267.jpg?updatedAt=1742288411712',
                name: 'Sourav Bhattacharjee',
                designation: 'Learner',
                comment: "Congrats Arpita!"
            },
            {
                image: 'https://assets.learntube.ai/files/New%20Analysis%20Page/1723176752998.jpg?updatedAt=1742288201618',
                name: 'Ashish Mani Tripathi',
                designation: "Working at Reliance Retail - Avantra format",
                comment: 'Congrats Arpita!'
            }
        ]
    },
    {
        name: 'Aryan Matthews',
        image: 'https://assets.learntube.ai/files/Global/Frame%20427320472%20(8).png?updatedAt=1743510683514',
        experience: '5+ Yrs. of Exp.',
        designation: 'Head Of Design',
        company: 'Meta',
        companyImage: 'https://assets.learntube.ai/files/Global/meta_icon.png.png?updatedAt=1743510683565',
        post: false,
        certification: 'Surveying Data through Card Sorting & Site Maps',
        issuedOn: 'Issued Dec 2023',
        certificateId: 'Credential ID DJA-B-1-1128846-0',
        certificateImage: 'https://assets.learntube.ai/files/Global/Group%2023070.png?updatedAt=1743510683776',
        linkedInProfile: 'https://www.linkedin.com/in/sindhuja-kathirvelu-5743b366/',
        location : 'Boston, USA'
    },
    {
        name: 'Jessica Patel',
        image: 'https://assets.learntube.ai/files/Global/images%2036.png?updatedAt=1743510775753',
        experience: '7+ Yrs. of Exp',
        designation: 'Business Analyst',
        company: 'Uber',
        companyImage: 'https://assets.learntube.ai/files/Global/uber_icon.jpeg.png?updatedAt=1743510775487',
        post: true,
        description: "Business Analyst at Uber | Microsoft Excel Expert",
        certificateImage: 'https://assets.learntube.ai/files/Global/Group%2023071.png?updatedAt=1743510776075',
        linkedInProfile: 'https://www.linkedin.com/posts/arpita-datta-22031569_sixsigma-processimprovement-qualitymanagement-activity-7232600459503398914--unD?utm_source=share&utm_medium=member_desktop&rcm=ACoAADYojcgBM3pyrmvqRl0dKq1dXRyqHTEIoSI',
        location: 'New Brunswick, USA',
        likes: 49,
        comments: 17,
        commentsThread: [
            {
                image: 'https://assets.learntube.ai/files/New%20Analysis%20Page/1592060946267.jpg?updatedAt=1742288411712',
                name: 'Sourav Bhattacharjee',
                designation: 'Learner',
                comment: "Congrats Arpita!"
            },
            {
                image: 'https://assets.learntube.ai/files/New%20Analysis%20Page/1723176752998.jpg?updatedAt=1742288201618',
                name: 'Ashish Mani Tripathi',
                designation: "Working at Reliance Retail - Avantra format",
                comment: 'Congrats Arpita!'
            }
        ]
    },
]

export const registerPageUsers = [
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320912.png?updatedAt=1743772223982',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320911.png?updatedAt=1743772223786',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320910.png?updatedAt=1743772223650',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320913.png?updatedAt=1743772223319',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320916.png?updatedAt=1743772222977',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320915.png?updatedAt=1743772222591',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320914.png?updatedAt=1743772222736',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320917.png?updatedAt=1743772221422',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320918.png?updatedAt=1743772221376',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320919.png?updatedAt=1743772221304',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320902.png?updatedAt=1743772219686',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320903.png?updatedAt=1743772219544',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320904.png?updatedAt=1743772219414',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320906.png?updatedAt=1743772219263',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320907.png?updatedAt=1743772219395',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320905.png?updatedAt=1743772219040',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320908.png?updatedAt=1743772218778',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320909.png?updatedAt=1743772217794',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320900.png?updatedAt=1743772217816',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320901.png?updatedAt=1743772217656',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320893.png?updatedAt=1743772214430',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320897.png?updatedAt=1743772214127',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320895.png?updatedAt=1743772214093',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320898.png?updatedAt=1743772214214',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%2010995.png?updatedAt=1743772214123',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320891.png?updatedAt=1743772214211',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320894.png?updatedAt=1743772214206',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320896.png?updatedAt=1743772213947',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320892.png?updatedAt=1743772213943',
   'https://assets.learntube.ai/files/Global/registerusers/Frame%20427320899.png?updatedAt=1743772213788'
]

export default constants